import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var fileDownload = require("js-file-download");
import axios from "axios";
import "vue-loading-overlay/dist/vue-loading.css";
import { request } from "@/js/http/http_request";
import { hasRole, isSuperAdmin, getClientAppData, hasLimitedLocations } from "@/js/http/auth.js";
import { scrollTo } from "@/js/animation.js";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { isArrowKey, filterIntegerKey } from "@/js/events/keycodes.js";
import { getFullNameUserHtml, getFullNameUser, userGroupName } from "@/js/user/user.js";
import { getOrderConfirmationReference, calculateOrderAmountsLocal, getUnitPriceCurrencyForItem, showShippingPriceMinusDefault } from "@/js/order/order.js";
import { isSameAddress } from "@/js/address";
import { casingForAdmin, wineNaming } from "@/js/wine/wine.js";
import { getSymbolCurrency, formatPrice, roundToTwoDigit } from "@/js/currency/currencies.js";
import { REGULAR_BOTTLING, itemStatus, inboundDeliveryStatus, orderTypes, orderStatus as _orderStatus, orderStatusOngoing, orderStatusStopped, orderStatusAdjusting, expeditionMethods, listTerms, listUserGroups, listContinents, listCurrencies, buyLimitErrors, casingWines, creditNote, creditNoteUse, creditNoteItem, listWineTypes, orderAdjustmentsTypes, paymentState, stockReservationTypes, wineStockStatus, purchaseOrder, IMPORTER, emptyCellContent, TASTING_PHOTOS, STOCK_PART, getPublicPaymentStateForAdmins, COUNTRIES, pricePostingStatusList, bottlings } from "@/js/lists.ts";
import Error from "@/views/error/error.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import UploaderV2 from "@/components/default/UploaderV2.vue";
import commentComponent from "@/components/comment/CommentComponent.vue";
import adressComponent from "@/components/address/Address.vue";
import PrepareOrderDrawer from "@/components/order/AdminSummarySubs/StateDrawers/PrepareOrderDrawer.vue";
import SplitOrderDrawer from "@/components/order/AdminSummarySubs/SplitAndMerge/SplitOrderDrawer.vue";
import MergeOrderDrawer from "@/components/order/AdminSummarySubs/SplitAndMerge/MergeOrderDrawer.vue";
import ValidateOrderDrawer from "@/components/order/AdminSummarySubs/StateDrawers/ValidateOrderDrawer.vue";
import DeliveryOrderDrawer from "@/components/order/AdminSummarySubs/StateDrawers/DeliveryOrderDrawer.vue";
import DeliveredOrderDrawer from "@/components/order/AdminSummarySubs/StateDrawers/DeliveredOrderDrawer.vue";
import WineNaming from "@/components/products/WineNaming.vue";
import WineDiscountTooltip from "@/components/products/WineDiscountTooltip.vue";
import EditOrderItemPriceDialog from "@/components/order/AdminSummarySubs/EditOrderItemPriceDialog.vue";
import SendMailModal from "@/components/mail/SendMailModal.vue";
import CreditNoteModal from "@/components/creditnote/CreditNoteModal.vue";
import WineStockListModal from "@/components/products/WineStockListModal.vue";
import WholesalersData from "@/components/payment/WholesalersData.vue";
import OrderAttachedFilesDrawer from "@/components/order/AdminSummarySubs/AttachedFiles/OrderAttachedFilesDrawer.vue";
import WarehouseSelectComponent from "@/components/warehouse/WarehouseSelectComponent.vue";
import SelectInitialOrderDialog from "@/components/order/AdminSummarySubs/SelectInitialOrderDialog.vue";
import OrderPaymentList from "@/components/order/AdminSummarySubs/Payments/OrderPaymentList.vue";
import OrderShipmentList from "@/components/order/AdminSummarySubs/OrderShipmentsList.vue";
import OrderCustomsInvoiceDialog from "@/components/order/AdminSummarySubs/DocumentsSettings/OrderCustomsInvoiceDialog.vue";
import CustomerChangeDialog from "@/components/order/AdminSummarySubs/CustomerChangeDialog.vue";
import StockReservation from "@/components/stock/StockReservation.vue";
import AccountancyOrderReconciliationDialog from "@/components/accountancy/AccountancyOrderReconciliationDialog.vue";
import AccountancyEcReconciliationDialog from "@/components/accountancy/AccountancyEcReconciliationDialog.vue";
import TastingPhotoUploadFormModal from "@/components/tasting-photos/TastingPhotoUploadFormModal.vue";
import ConsultantCommissionPaymentSub from "@/components/order/AdminSummarySubs/ConsultantCommissionPayment.vue";
import OrderCommunications from "@/components/order/AdminSummarySubs/OrderCommunications.vue";
import DocSettingsInvoiceAdditionalFieldsSub from "@/components/order/AdminSummarySubs/DocumentsSettings/InvoiceAdditionalFields.vue";
import StorageTermsReference from "@/components/common/StorageTermsReference.vue";
import OrderHistoryDrawer from "@/components/order/AdminSummarySubs/OrderHistoryDrawer.vue";
import OrderContainerChapter from "@/components/order/ContainerOrders/OrderContainerChapter.vue";
import DepartureWarehouseChangeDialog from "@/components/order/AdminSummarySubs/DepartureWarehouseChangeDialog.vue";
import OrderDomesticTransferList from "@/components/order/AdminSummarySubs/OrderDomesticTransferList.vue";
import PricePostedUsaEditModal from "@/components/price-posting/usa-pro/PricePostedUsaEditModal.vue";
import WineSupplierPriceModal from "@/components/supplier-prices/WineSupplierPriceModal.vue";
export default {
  name: "AdminOrderSummary",
  components: {
    CustomerChangeDialog: CustomerChangeDialog,
    ValidateOrderDrawer: ValidateOrderDrawer,
    DeliveryOrderDrawer: DeliveryOrderDrawer,
    SplitOrderDrawer: SplitOrderDrawer,
    MergeOrderDrawer: MergeOrderDrawer,
    PrepareOrderDrawer: PrepareOrderDrawer,
    DeliveredOrderDrawer: DeliveredOrderDrawer,
    WineNaming: WineNaming,
    adress: adressComponent,
    WineDiscountTooltip: WineDiscountTooltip,
    confirm: confirmationComponent,
    comment: commentComponent,
    UploaderV2: UploaderV2,
    SendMailModal: SendMailModal,
    CreditNoteModal: CreditNoteModal,
    WineStockListModal: WineStockListModal,
    EditOrderItemPriceDialog: EditOrderItemPriceDialog,
    WholesalersData: WholesalersData,
    OrderAttachedFilesDrawer: OrderAttachedFilesDrawer,
    WarehouseSelectComponent: WarehouseSelectComponent,
    SelectInitialOrderDialog: SelectInitialOrderDialog,
    OrderPaymentList: OrderPaymentList,
    ErrorModal: ErrorModal,
    Error: Error,
    OrderShipmentList: OrderShipmentList,
    OrderCustomsInvoiceDialog: OrderCustomsInvoiceDialog,
    StockReservation: StockReservation,
    AccountancyOrderReconciliationDialog: AccountancyOrderReconciliationDialog,
    AccountancyEcReconciliationDialog: AccountancyEcReconciliationDialog,
    TastingPhotoUploadFormModal: TastingPhotoUploadFormModal,
    ConsultantCommissionPaymentSub: ConsultantCommissionPaymentSub,
    OrderCommunications: OrderCommunications,
    DocSettingsInvoiceAdditionalFieldsSub: DocSettingsInvoiceAdditionalFieldsSub,
    StorageTermsReference: StorageTermsReference,
    OrderHistoryDrawer: OrderHistoryDrawer,
    OrderContainerChapter: OrderContainerChapter,
    DepartureWarehouseChangeDialog: DepartureWarehouseChangeDialog,
    OrderDomesticTransferList: OrderDomesticTransferList,
    PricePostedUsaEditModal: PricePostedUsaEditModal,
    WineSupplierPriceModal: WineSupplierPriceModal
  },
  props: ["baseModel", "loggedUserData"],
  data: function data() {
    return {
      clientAppData: null,
      showAllDeliveries: false,
      isUnselectingCreditNote: {},
      creditNoteHeaders: [{
        text: "Reference#",
        value: "numberLabel"
      }, {
        text: "Extra description",
        value: "extraDescription",
        width: "200px"
      }, {
        text: "Credit note date",
        value: "creationDate"
      }, {
        text: "Credit amount",
        value: "totalAmountCurrency"
      }, {
        text: "Credit available",
        value: "remaining.amountCurrency"
      }, {
        text: "",
        value: "maxAmountToCredit"
      }, {
        text: "Amount to credit",
        value: "amountToCredit"
      }],
      inboundDeliveryPaymentHeaders: [{
        text: "Order dispatch",
        value: "reference"
      }, {
        text: "Customer",
        value: "customer",
        align: "center"
      }, {
        text: "Status",
        value: "status",
        align: "center"
      }, {
        text: "Final payment date",
        value: "paymentDate",
        align: "center"
      }, {
        text: "Payment references",
        value: "paymentReferences",
        align: "center"
      }, {
        text: "Amount",
        value: "totalAmountCurrency",
        align: "right"
      }],
      updatedCustomerId: null,
      substituteCustomers: [],
      isUpdatingCustomer: false,
      isEditingCustomer: false,
      isShowingHistory: false,
      isAddingWine: false,
      isFetchingShippingCosts: false,
      isCollapsed: true,
      isLoadingAddableWines: false,
      deliveredDrawer: false,
      deliveryDrawer: false,
      preparationDrawer: false,
      preparationDrawerIterator: 0,
      validationDrawer: false,
      splitDrawer: false,
      mergeDrawer: false,
      chaptersVisibility: {
        communications: false,
        payments: false,
        shipments: false,
        container: false,
        documentsSettings: false
      },
      bufferedAddresses: {
        billingAddress: null,
        deliveryAddress: null,
        isSameAddress: null,
        inbound_warehouse_id: null,
        stockTransferWarehouseId: null
      },
      formStockTransfer: {
        stockTransferIsPreselling: null,
        reservationType: null,
        reservationUserId: null,
        reservationConsultantId: null
      },
      isEditingAddresses: false,
      deliveryAddressFaultedMessage: null,
      updateAddressesToken: null,
      isChangingInboundWarehouses: false,
      isChangingStockTransferWarehouses: false,
      orderCtaStyles: {},
      availabilities: [],
      shipmentModalShown: false,
      customerDialogShown: false,
      selectedDocuments: [],
      isLoadingDocuments: true,
      documentDialog: false,
      isUpdatingOrderStatus: false,
      isApprovingOrder: false,
      isDecliningOrder: false,
      isCancellingOrderWithoutNotifyCustomer: false,
      isCreatingAdjustment: false,
      isProcessingPayment: false,
      quantityToggleKey: false,
      order: {
        id_order: null,
        date_order: null,
        buyer_term: null,
        items: [],
        id_user: null,
        amount_ex_vat: null,
        total_amount: null,
        status: null,
        expedition_method: 0,
        expedition_methods: [],
        is_destination_inbound: false,
        inbound_warehouse_id: null,
        delivery_address: null,
        delivery_instructions: null,
        billing_address: null,
        amount_shipping: null,
        amount_vat: null,
        due_date: null,
        cancellation_date: null,
        deleted: false,
        user: null,
        isFullyCalculatedAmounts: false,
        isFullyGeneratedDocuments: false,
        stockTransferIsAskedByUser: false,
        isStockTransfer: false,
        stockTransferWarehouseId: null,
        stockTransferReservationType: null,
        stockTransferReservationUserId: null,
        stockTransferReservationConsultantId: null,
        stockTransferIsPreselling: null
      },
      orderChildren: [],
      isShippingQuantity: false,
      editShippingQuantityToken: null,
      isEditingShippingQuantity: false,
      imagesBroken: [],
      attachedFiles: [],
      sameAddress: true,
      user: {},
      listCountries: [],
      listStates: [],
      expedition_methods: [],
      errorLabels: {
        shipping: {},
        terms: "",
        user_selected: "",
        validation_comment: "",
        cgv: "",
        quantity_orders: [],
        adjustment: ""
      },
      errorMessages: {
        mandatory: "This field is required",
        cgv: {
          required: "You must accept the terms of sales, and certify you are complying with the law"
        },
        order: {
          quantity: "You don't reach the minimum per order"
        },
        shippingType: {
          required: "You must select a shipping type"
        }
      },
      managedExceptions: {
        warning: {
          credit_note_in_used: "The credit note is applied on another order.",
          credit_note_use_blocked_by_order: "The credit note is applied on another order.",
          order_pricing_credit_notes_amount_invalid: "The credits applied amount exceeds the products amount.",
          cancel_invoice_not_last_invoice: "This is not the last invoice.",
          return_to_validated_wrong_status_for_update: "Unable to update order.",
          return_to_validated_wrong_payment_state: "Payment state doesn't allow to edit order.",
          return_to_validated_exists_associations: "There are already some accountancy associations."
        }
      },
      lastCptCall: 2,
      canManageOrder: false,
      canAccessPoData: false,
      canManageUsers: false,
      canManageAccountancy: false,
      userLoggedHasLimitedLocation: false,
      updateStatusMenu: false,
      adjustmentToken: null,
      adjustments: [],
      dialogAdjustment: {
        visible: false,
        message: null,
        type: null,
        historicVisible: false
      },
      searchWineCancellationToken: null,
      removeBasketToken: null,
      addWineCancellationToken: null,
      wineAdding: null,
      winesAddables: [],
      updateDeliveryInstructionsToken: null,
      editingDeliveryInstructions: false,
      newDeliveryInstructions: "",
      isDeliveryInstructionsAsDefaultForUserAdress: false,
      updateTrackingToken: null,
      editingTracking: false,
      trackingIsUpdating: false,
      trackingForm: {
        inputTrackingNumber: null,
        inputTrackingUrl: null,
        valid: false
      },
      checkboxCGV: false,
      checkboxLawCompliance: false,
      documents: [],
      isLoadingAttachedFiles: false,
      searchValue: "",
      sendMailModalShown: false,
      lastExpeditionMethod: null,
      isChangingExpeditionMethod: false,
      changeExpeditionMethodToken: null,
      isLoadingCreditNoteApply: false,
      updateCreditNote: null,
      updateCreditNoteId: null,
      splitOrder: false,
      usableCreditNotes: [],
      generatedCreditNotes: [],
      isAvailableItemsForCreditNote: true,
      creditNoteModalShown: false,
      isShowExistingCreditNoteItems: false,
      creditNoteItems: [],
      importersAvailableForCountry: [],
      importersForSelector: [],
      isEditingImporter: false,
      importerSelectorSelected: null,
      changeOrderImporterCancellationToken: null,
      factoringProvidersAvailable: [],
      factoringProvidersForSelector: [],
      isEditingFactoringProvider: false,
      factoringProviderSelectorSelected: null,
      changeOrderFactoringProviderCancellationToken: null,
      handlingConsultants: {
        getting: {
          isPending: false,
          cancellationToken: null,
          results: []
        },
        updating: {
          isConfiguring: false,
          isPending: false,
          cancellationToken: null,
          form: {
            consultantId: null,
            valid: false
          }
        }
      },
      editOrderItemPriceDialogShown: false,
      inboundWarehouses: [],
      changeWineStockCancellationToken: null,
      wineStockIsUsedStockSwitchable: true,
      wineStockKey: null,
      currentWine: null,
      currentItemForWineStockChanged: null,
      currentQuantity: 1,
      currentCasingId: "OC1",
      orderAttachedWineFiles: [],
      orderAttachedFiles: [],
      orderAttachedWineryFiles: [],
      isMakingDrawerStateless: false,
      initialCurrency: null,
      updateOrderCurrencyToken: null,
      editingOrderCurrency: false,
      isUpdatingOrderCurrency: false,
      isDocumentsFetched: false,
      isCalculatingAmounts: false,
      calculateOrderAmountsToken: null,
      idProductsUpdating: [],
      mustRefreshLogisticDetails: false,
      selectInitialOrderDialogShown: false,
      isGeneratingInvoice: false,
      isCancellingInvoice: false,
      lastInvoicedOrder: null,
      isReturningToValidated: false,
      isExportingXlsFreight: false,
      customerComplete: {},
      customerCompleteLoaded: false,
      customerConsultantAttached: null,
      customerStripeMethods: null,
      customerHasStripeMethods: null,
      customerStripeMethodsLoaded: false,
      fetchingCompleteDepartureWarehouse: {
        isPending: false,
        cancellationToken: null,
        result: null
      },
      isFetchingInboundDeliveries: false,
      inboundDeliveries: [],
      orderCustomsInvoiceDialogShown: false,
      pricePosting: {
        idUsed: null,
        availableItems: [],
        isReselecting: false,
        isUpdating: false
      },
      accountancyReconciliationDialogShown: false,
      accountancyReconciliationPayments: {
        tableHeaders: [{
          text: "Order",
          value: "reference"
        }, {
          text: "Customer",
          value: "customer",
          align: "center"
        }, {
          text: "Status",
          value: "status",
          align: "center"
        }, {
          text: "Final payment date",
          value: "paymentDate",
          align: "center"
        }, {
          text: "Payment references",
          value: "paymentReferences",
          align: "center"
        }, {
          text: "Amount",
          value: "totalAmountCurrency",
          align: "right"
        }],
        payments: [],
        paymentsFromOldStockTransfers: []
      },
      accountancyEcReconciliationDialogShown: false,
      isEditingConsultantCommission: false,
      isSavingConsultantCommission: false,
      isNewConsultantCommissionTypePercentage: null,
      newConsultantCommissionPercentage: null,
      newConsultantCommissionAmountCurrency: null,
      tastingPhotos: {
        canManage: false,
        required: {
          isSearchPending: false,
          items: []
        },
        upload: {
          isComponentCreated: false,
          tastingPhotoRequiredId: null
        }
      },
      editingAccountancyCode: {
        isConfiguring: false,
        form: {
          accountancyCode: ""
        },
        isPending: false,
        cancellationToken: null
      },
      fetchingCompleteWines: {
        isPending: false,
        cancellationToken: null
      },
      committedPresellStockPartsHeaders: [{
        text: "Order",
        align: "start",
        value: "referenceOrder"
      }, {
        text: "Status",
        value: "status"
      }, {
        text: "Qty committed",
        value: "committedParts"
      }],
      committedPresellStockParts: [],
      definingAsStockTransferOnShipped: {
        isConfiguring: false,
        form: {
          warehouseId: null,
          reservationType: 0,
          stockReservationUserId: null,
          stockReservationConsultantId: null
        },
        cancellationToken: null,
        isPending: false
      },
      cancellingAsStockTransfer: {
        cancellationToken: null,
        isPending: false
      },
      creatingPreArrivalStocks: {
        cancellationToken: null,
        isPending: false
      },
      departureWarehouseChangeDialogShown: false,
      pricePostingDetails: {
        canManage: false,
        wine: null
      },
      isWineSupplierPriceModalShown: false,
      selectedIdWineSupplierForPriceModal: null,
      expedition_methods_ref: expeditionMethods,
      expeditionMethods: expeditionMethods,
      listTerms: listTerms,
      listUserGroups: listUserGroups,
      itemStatus: itemStatus,
      orderStatus: _orderStatus,
      orderTypes: orderTypes,
      rules: formRules,
      orderStatusOngoing: orderStatusOngoing,
      orderStatusStopped: orderStatusStopped,
      orderStatusAdjusting: orderStatusAdjusting,
      inboundDeliveryStatus: inboundDeliveryStatus,
      orderAdjustmentsTypes: orderAdjustmentsTypes,
      purchaseOrder: purchaseOrder,
      creditNote: creditNote,
      creditNoteItem: creditNoteItem,
      creditNoteUse: creditNoteUse,
      stockReservationTypes: stockReservationTypes,
      wineStockStatus: wineStockStatus,
      filterIntegerKey: filterIntegerKey,
      paymentState: paymentState,
      listCurrencies: listCurrencies,
      casingWines: casingWines,
      emptyCellContent: emptyCellContent,
      ERROR_DATA: ERROR_DATA,
      TASTING_PHOTOS: TASTING_PHOTOS,
      STOCK_PART: STOCK_PART,
      pricePostingStatusList: pricePostingStatusList
    };
  },
  computed: {
    isDeveloper: function isDeveloper() {
      return hasRole(process.env.VUE_APP_ROLES_USE_DEVELOPER_TOOLS);
    },
    hasAccessToGenerateInvoice: function hasAccessToGenerateInvoice() {
      return hasRole(process.env.VUE_APP_ROLES_GENERATE_INVOICE) && !this.isCancelled && !this.isInvoiced && !this.order.isPreventInvoice && this.hasBeenValidated && !this.isContainerOrder;
    },
    hasAccessToCancelInvoice: function hasAccessToCancelInvoice() {
      return hasRole(process.env.VUE_APP_ROLES_GENERATE_INVOICE) && this.isInvoiced && !this.isDelivered && !this.isCancelled;
    },
    hasAccessToReturnToValidated: function hasAccessToReturnToValidated() {
      return this.order.isPreventInvoice && this.hasBeenValidated && this.order.status !== this.orderStatus.find(function (os) {
        return os.id === "VALIDATED";
      }).status && this.order.status !== this.orderStatus.find(function (os) {
        return os.id === "INBOUND";
      }).status && !(this.isPaymentProcessing || this.isPaymentSucceeded) && !this.isStoredInbound && !this.isCancelled && !this.isDelivered && !this.isSubcontainerPutInboundStatus && !this.isSubcontainerWithContainerInTransit;
    },
    isOrderFullyCalculatedAmounts: function isOrderFullyCalculatedAmounts() {
      return this.order.isFullyCalculatedAmounts;
    },
    isInboundAvailable: function isInboundAvailable() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_DELIVERIES) && this.order.expedition_method !== expeditionMethods.CELLAR_STORAGE.id && !this.isShipped;
    },
    isCustomerHolding: function isCustomerHolding() {
      var _this$order;
      return (_this$order = this.order) === null || _this$order === void 0 || (_this$order = _this$order.user) === null || _this$order === void 0 ? void 0 : _this$order.isHolding;
    },
    isStockTransferAvailable: function isStockTransferAvailable() {
      return this.order.expedition_method !== expeditionMethods.CELLAR_STORAGE.id && !this.isShipped && !this.isLinkedToContainerOrder;
    },
    transferStockReservationTypes: function transferStockReservationTypes() {
      return Object.values(stockReservationTypes).map(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          name: x.id == stockReservationTypes.DEFAULT.id ? "Default reservation of destination warehouse" : x.name
        });
      });
    },
    canModifyStockTransferOnShippedOrder: function canModifyStockTransferOnShippedOrder() {
      var _this$order2, _this$order3, _this$order4;
      return this.isShipped && !this.isDelivered && !this.isCancelled && !this.isLinkedToContainerOrder && (!((_this$order2 = this.order) !== null && _this$order2 !== void 0 && _this$order2.isStockTransfer) || ((_this$order3 = this.order) === null || _this$order3 === void 0 ? void 0 : _this$order3.isStockTransfer) && !((_this$order4 = this.order) !== null && _this$order4 !== void 0 && _this$order4.stockTransferIsPreselling));
    },
    isStoredInbound: function isStoredInbound() {
      return this.order.is_destination_inbound || this.order.status == this.orderStatus.find(function (os) {
        return os.id === "INBOUND";
      }).status;
    },
    isOldStockTransferViaInbound: function isOldStockTransferViaInbound() {
      return this.isStoredInbound && this.order.isPreventInvoice;
    },
    isInInboundWithoutWarehouse: function isInInboundWithoutWarehouse() {
      return this.order.is_destination_inbound && !this.order.inbound_warehouse_id;
    },
    hasItemInInbound: function hasItemInInbound() {
      return this.order.items.some(function (x) {
        return x.inboundQuantityAvailable !== null;
      });
    },
    inboundDeliveryPayments: function inboundDeliveryPayments() {
      return this.inboundDeliveries.filter(function (x) {
        return x.status != inboundDeliveryStatus.find(function (y) {
          return y.id == "CANCELLED";
        }).status;
      });
    },
    isOrderEditable: function isOrderEditable() {
      return !this.isShipped &&
      //TODO : Maybe in the future change !isShipped by !isArchived-Finalized, to be able to modify OCs until finalized
      !this.isAnyTypeInvoiced && !this.isCancelled && !this.isSubcontainerPutInboundStatus && !this.isPaymentSucceeded && !this.isPaymentProcessing && !this.isWaitingForAdminValidation && !this.isAdminWaitingForCustomerAction;
    },
    canEditItems: function canEditItems() {
      return this.isOrderEditable;
    },
    isShippingEditable: function isShippingEditable() {
      return this.isOrderEditable;
    },
    isOrderStatusSplitable: function isOrderStatusSplitable() {
      return this.generatedCreditNotes.length === 0 && !this.isShipped && !this.isCancelled && !this.isAnyTypeInvoiced && !this.isSubcontainerWithContainerInTransit;
    },
    isOrderStatusMergable: function isOrderStatusMergable() {
      return this.generatedCreditNotes.length === 0 && !this.isShipped && !this.isCancelled && !this.isAnyTypeInvoiced && !this.isSubcontainerWithContainerInTransit;
    },
    isOrderCancellable: function isOrderCancellable() {
      return !this.orderStatus.filter(function (x) {
        return x.id == "INBOUND" || x.id == "DELIVERED" || x.id == "CANCELLED";
      }).map(function (x) {
        return x.status;
      }).includes(this.order.status);
    },
    isDocumentsConsultable: function isDocumentsConsultable() {
      return this.order.status !== this.orderStatus.find(function (x) {
        return x.id === "ADJUSTING";
      }).status;
    },
    hasBeenValidated: function hasBeenValidated() {
      return !_orderStatus.filter(function (x) {
        return ["AWAITING_CUSTOMER_VALIDATION", "AWAITING_VALIDATION", "ADJUSTING"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(this.order.status);
    },
    isInvoiced: function isInvoiced() {
      return this.order.isInvoiced;
    },
    isImporterInvoiced: function isImporterInvoiced() {
      return this.order.isImporterInvoiced;
    },
    isAnyTypeInvoiced: function isAnyTypeInvoiced() {
      return this.order.isAnyTypeInvoiced;
    },
    hasFactoringProvider: function hasFactoringProvider() {
      var _this$order$factoring;
      return (_this$order$factoring = this.order.factoringProvider) === null || _this$order$factoring === void 0 ? void 0 : _this$order$factoring.id;
    },
    hasImporter: function hasImporter() {
      var _this$order$importer;
      return (_this$order$importer = this.order.importer) === null || _this$order$importer === void 0 ? void 0 : _this$order$importer.id;
    },
    creditNoteItemProducts: function creditNoteItemProducts() {
      var _this2 = this;
      return this.creditNoteItems.filter(function (x) {
        return x.type == _this2.creditNoteItem.type.PRODUCT;
      });
    },
    creditNoteShipping: function creditNoteShipping() {
      var _this3 = this;
      return this.creditNoteItems.filter(function (x) {
        return x.type == _this3.creditNoteItem.type.SHIPPING;
      });
    },
    totalAmountCurrencyCreditNoteShipping: function totalAmountCurrencyCreditNoteShipping() {
      var _this$creditNoteShipp;
      return (_this$creditNoteShipp = this.creditNoteShipping) === null || _this$creditNoteShipp === void 0 ? void 0 : _this$creditNoteShipp.reduce(function (acc, item) {
        return acc + item.amountCurrency;
      }, 0);
    },
    orderShippingAmountCurrencyToPay: function orderShippingAmountCurrencyToPay() {
      return this.order.amountShippingNotIncludedInItemsCurrency - this.totalAmountCurrencyCreditNoteShipping;
    },
    generatedCreditNotesCmFr: function generatedCreditNotesCmFr() {
      var _this$generatedCredit;
      return (_this$generatedCredit = this.generatedCreditNotes) === null || _this$generatedCredit === void 0 ? void 0 : _this$generatedCredit.filter(function (x) {
        return x.isCmFrIssuing;
      });
    },
    generatedCreditNotesImporter: function generatedCreditNotesImporter() {
      var _this$generatedCredit2,
        _this4 = this;
      return (_this$generatedCredit2 = this.generatedCreditNotes) === null || _this$generatedCredit2 === void 0 ? void 0 : _this$generatedCredit2.filter(function (x) {
        var _this4$order$importer;
        return x.issuingImporterId === ((_this4$order$importer = _this4.order.importer) === null || _this4$order$importer === void 0 ? void 0 : _this4$order$importer.id);
      });
    },
    isOrderSplitableByCreditNote: function isOrderSplitableByCreditNote() {
      return this.isCreditNoteGenerable && !this.isShipped && !this.isSubcontainerWithContainerInTransit;
    },
    isAutoGeneratedCreditNote: function isAutoGeneratedCreditNote() {
      return this.isAvailableItemsForCreditNote && this.isAnyTypeInvoiced;
    },
    isCreditNoteGenerable: function isCreditNoteGenerable() {
      return this.isAvailableItemsForCreditNote && (this.isPaymentSucceeded || this.isAnyTypeInvoiced);
    },
    isCreditNoteUsable: function isCreditNoteUsable() {
      return true;
    },
    isCreditNoteApplyAvailable: function isCreditNoteApplyAvailable() {
      if (this.usableCreditNotes.length > 0) {
        var amountToCredit = 0;
        this.usableCreditNotes.forEach(function (x) {
          if (x.amountToCredit) {
            amountToCredit += parseFloat(x.amountToCredit);
          }
        });
        if (amountToCredit > this.order.total_amount_currency_include_credit_notes) {
          return false;
        }
        return !!amountToCredit;
      }
    },
    isDestinationGreatExport: function isDestinationGreatExport() {
      var _this$order5;
      return !((_this$order5 = this.order) !== null && _this$order5 !== void 0 && (_this$order5 = _this$order5.delivery_address) !== null && _this$order5 !== void 0 && (_this$order5 = _this$order5.country) !== null && _this$order5 !== void 0 && _this$order5.european_union_member);
    },
    isConcernedByVat: function isConcernedByVat() {
      var _this$order6;
      return ((_this$order6 = this.order) === null || _this$order6 === void 0 ? void 0 : _this$order6.amount_vat) > 0;
    },
    isAuthorizedToEditItemPrice: function isAuthorizedToEditItemPrice() {
      return this.isOrderEditable && this.canEditItems && hasRole(process.env.VUE_APP_ROLES_EDIT_ORDER_ITEM_PRICE);
    },
    //Should not happen anymore
    hasMissingLogisticCost: function hasMissingLogisticCost() {
      return this.isShippingEditable && !this.isFetchingShippingCosts && (!this.order.items || !this.expedition_methods);
    },
    isAdminWaitingForCustomerAction: function isAdminWaitingForCustomerAction() {
      return this.order.status === _orderStatus.find(function (os) {
        return os.id == "AWAITING_CUSTOMER_VALIDATION";
      }).status;
    },
    isWaitingForAdminValidation: function isWaitingForAdminValidation() {
      return this.order.status === _orderStatus.find(function (os) {
        return os.id == "AWAITING_VALIDATION";
      }).status;
    },
    isInDelivery: function isInDelivery() {
      return this.order.status === _orderStatus.find(function (os) {
        return os.id === "DELIVERY";
      }).status;
    },
    isSubcontainerWithContainerInTransit: function isSubcontainerWithContainerInTransit() {
      return this.order.status === _orderStatus.find(function (os) {
        return os.id === "SUBCONTAINER_CONTAINER_IN_TRANSIT";
      }).status;
    },
    isShipped: function isShipped() {
      return _orderStatus.filter(function (x) {
        return ["DELIVERY", "CUSTOMS_CLEARANCE", "INBOUND", "DELIVERED"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(this.order.status);
    },
    isDelivered: function isDelivered() {
      return _orderStatus.find(function (x) {
        return x.id === "DELIVERED";
      }).status === this.order.status;
    },
    isCancelled: function isCancelled() {
      return this.order.status == _orderStatus.find(function (os) {
        return os.id === "CANCELLED";
      }).status;
    },
    isSubcontainerPutInboundStatus: function isSubcontainerPutInboundStatus() {
      return this.order.status == _orderStatus.find(function (os) {
        return os.id === "SUBCONTAINER_PUT_INBOUND";
      }).status;
    },
    editOrderDisplayed: function editOrderDisplayed() {
      return orderStatusOngoing.includes(this.order.status) || orderStatusStopped.includes(this.order.status);
    },
    isSourcingAvailable: function isSourcingAvailable() {
      return this.$whitelabel.isAllowedToAccessPurchaseOrder && this.canAccessPoData && !this.isShipped;
    },
    nextStatus: function nextStatus() {
      var _this5 = this;
      if (this.order.is_destination_inbound && (this.order.status === this.orderStatus.find(function (os) {
        return os.id === "CUSTOMS_CLEARANCE";
      }).status || !this.isDestinationGreatExport && this.order.status === this.orderStatus.find(function (os) {
        return os.id === "DELIVERY";
      }).status)) {
        return this.orderStatus.filter(function (x) {
          return x.status == _orderStatus.find(function (os) {
            return os.id === "INBOUND";
          }).status;
        })[0];
      } else if (this.order.is_destination_inbound && this.order.status === this.orderStatus.find(function (os) {
        return os.id === "INBOUND";
      }).status) {
        return this.orderStatus.filter(function (x) {
          return x.status == _orderStatus.find(function (os) {
            return os.id === "DELIVERED";
          }).status;
        })[0];
      } else if (this.isInDelivery) {
        var _this$fetchingComplet, _this$order7;
        if (this.isDestinationGreatExport && ((_this$fetchingComplet = this.fetchingCompleteDepartureWarehouse.result) === null || _this$fetchingComplet === void 0 ? void 0 : _this$fetchingComplet.address.country.id_country) !== ((_this$order7 = this.order) === null || _this$order7 === void 0 || (_this$order7 = _this$order7.delivery_address) === null || _this$order7 === void 0 ? void 0 : _this$order7.country.id_country)) {
          return this.orderStatus.filter(function (x) {
            return x.status == _orderStatus.find(function (os) {
              return os.id === "CUSTOMS_CLEARANCE";
            }).status;
          })[0];
        } else {
          return this.orderStatus.filter(function (x) {
            return x.status == _orderStatus.find(function (os) {
              return os.id === "DELIVERED";
            }).status;
          })[0];
        }
      } else {
        return this.orderStatus.filter(function (x) {
          return x.status == _this5.order.status + 1;
        })[0];
      }
    },
    isNextStatusAllowed: function isNextStatusAllowed() {
      return this.order.items.length > 0 && !!this.order.expedition_method || this.isContainerOrderBeforeMerge && this.order.items.length === 0;
    },
    dialogAdjustmentData: function dialogAdjustmentData() {
      switch (this.dialogAdjustment.type) {
        case orderAdjustmentsTypes.USER_DECLINE.id:
          return {
            title: "Decline the order",
            message_placeholder: "Please explain the reason for cancelling the order.",
            cta_label: "Decline order",
            success_toast_message: "Order has been declined and cancelled."
          };
        case orderAdjustmentsTypes.USER_ASK_ADJUSTMENT.id:
          return {
            title: "Ask for adjustments",
            message_placeholder: "Please explain your adjustments wishes",
            cta_label: "Send your request",
            success_toast_message: "Request has been sent."
          };
        case orderAdjustmentsTypes.USER_APPROVE.id:
          return {
            title: "Approve order",
            message_placeholder: "Please explain your approvement",
            cta_label: "Approve",
            success_toast_message: "Approvement has been sent."
          };
        case orderAdjustmentsTypes.ADMIN_DECLINE.id:
          return {
            title: "Cancel order",
            message_placeholder: "Please explain why you cancel this order to the customer. This message will be surrounded by standard message\nBefore : Dear %CUSTOMER_NAME%, The order %ORDER_REFERENCE% has been cancelled.\nAfter : button 'View the order' Best regards.",
            cta_label: "Send to customer",
            success_toast_message: "Order cancelled."
          };
        case orderAdjustmentsTypes.ADMIN_PROPOSE_ADJUSTMENT.id:
          return {
            title: "Propose the adjustments",
            message_placeholder: "Please explain your adjustments to the customer. This message will be surrounded by standard message\nBefore : Dear %CUSTOMER_NAME%, We are suggesting a couple of adjustments for your order request %ORDER_REFERENCE%.\nAfter : You can choose to request for additional adjustments by following VIEW THE ORDER, or APPROVE or DECLINE the order without having to sign in. Best regards.",
            cta_label: "Send to customer",
            success_toast_message: "Proposition sent."
          };
        case "history":
          return {
            title: "History",
            message_placeholder: null,
            cta_label: null,
            success_toast_message: null
          };
        default:
          return null;
      }
    },
    nbBottles: function nbBottles() {
      var _this$order$items;
      return (_this$order$items = this.order.items) === null || _this$order$items === void 0 ? void 0 : _this$order$items.reduce(function (acc, item) {
        return acc + item.quantity;
      }, 0);
    },
    nbRegularBottles: function nbRegularBottles() {
      var _this$order$items2;
      var totalVolumeMl = (_this$order$items2 = this.order.items) === null || _this$order$items2 === void 0 ? void 0 : _this$order$items2.reduce(function (acc, item) {
        return acc + item.quantity * item.wine.bottling;
      }, 0);
      var number = (totalVolumeMl / REGULAR_BOTTLING).toFixed(2);
      return parseFloat(number).toString();
    },
    nbBottlesIncludingCreditNote: function nbBottlesIncludingCreditNote() {
      var _this$creditNoteItemP;
      return this.nbBottles - ((_this$creditNoteItemP = this.creditNoteItemProducts) === null || _this$creditNoteItemP === void 0 ? void 0 : _this$creditNoteItemP.reduce(function (acc, item) {
        return acc + item.quantity;
      }, 0));
    },
    nbRegularBottlesIncludingCreditNote: function nbRegularBottlesIncludingCreditNote() {
      var _this$order$items3, _this$creditNoteItemP2;
      var totalVolumeMl = (_this$order$items3 = this.order.items) === null || _this$order$items3 === void 0 ? void 0 : _this$order$items3.reduce(function (acc, item) {
        return acc + item.quantity * item.wine.bottling;
      }, 0);
      var creditNoteVolumeMl = (_this$creditNoteItemP2 = this.creditNoteItemProducts) === null || _this$creditNoteItemP2 === void 0 ? void 0 : _this$creditNoteItemP2.reduce(function (acc, item) {
        return acc + item.quantity * item.wine.bottling;
      }, 0);
      var number = ((totalVolumeMl - creditNoteVolumeMl) / REGULAR_BOTTLING).toFixed(2);
      return parseFloat(number).toString();
    },
    nbRegularBottlesForShippingIncludingCreditNote: function nbRegularBottlesForShippingIncludingCreditNote() {
      var _this$creditNoteItemP3;
      var nbRegularBottlesForShippingOnOrder = this.order.nbRegularBottlesForShipping;
      var nbRegularBottlesForShippingOnCreditNotes = (_this$creditNoteItemP3 = this.creditNoteItemProducts) === null || _this$creditNoteItemP3 === void 0 ? void 0 : _this$creditNoteItemP3.reduce(function (acc, item) {
        return acc + item.NbRegularBottlesForShipping;
      }, 0);
      var number = (nbRegularBottlesForShippingOnOrder - nbRegularBottlesForShippingOnCreditNotes).toFixed(2);
      return parseFloat(number).toString();
    },
    hasBeenPricePostedWithProperShippingFees: function hasBeenPricePostedWithProperShippingFees() {
      var _this$order$pricePost;
      return ((_this$order$pricePost = this.order.pricePostingUsaPro) === null || _this$order$pricePost === void 0 ? void 0 : _this$order$pricePost.id) > 0 && !this.order.shippingHasBeenCalculatedByMl;
    },
    documentCount: function documentCount() {
      var _this$documents;
      return (_this$documents = this.documents) === null || _this$documents === void 0 ? void 0 : _this$documents.reduce(function (acc, x) {
        return acc + x.children.length;
      }, 0);
    },
    deliveryInstructionsEditable: function deliveryInstructionsEditable() {
      return this.orderStatus.find(function (o) {
        return o.id == "INBOUND";
      }).status != this.order.status && this.orderStatus.find(function (o) {
        return o.id == "DELIVERED";
      }).status != this.order.status && this.orderStatus.find(function (o) {
        return o.id == "CANCELLED";
      }).status != this.order.status;
    },
    hasItems: function hasItems() {
      return this.order.items.length > 0;
    },
    hasInactiveItems: function hasInactiveItems() {
      return this.order.items.some(function (x) {
        return x.hasClosedStock || !x.wine.is_active || x.wine.deleted || x.wine.isClosedStock;
      });
    },
    isPaymentSucceeded: function isPaymentSucceeded() {
      var _this$order$payments;
      if ((_this$order$payments = this.order.payments) !== null && _this$order$payments !== void 0 && _this$order$payments.length) {
        return this.order.payments.some(function (x) {
          return [paymentState.SUCCEEDED].includes(x.state);
        });
      }
      return [paymentState.SUCCEEDED].includes(this.order.payment_state);
    },
    isPaymentProcessing: function isPaymentProcessing() {
      var _this$order$payments2;
      if ((_this$order$payments2 = this.order.payments) !== null && _this$order$payments2 !== void 0 && _this$order$payments2.length) {
        return this.order.payments.some(function (x) {
          return [paymentState.PROCESSING].includes(x.state);
        });
      }
      return [paymentState.PROCESSING].includes(this.order.payment_state);
    },
    canShowFinalDueDate: function canShowFinalDueDate() {
      return this.order.isPreventInvoice && this.order.due_date || !this.order.isPreventInvoice && this.order.due_date && this.isInvoiced;
    },
    isTrackingEditable: function isTrackingEditable() {
      return !this.editingTracking && this.order.status !== _orderStatus.find(function (os) {
        return os.id === "CANCELLED";
      }).status && this.order.status !== _orderStatus.find(function (os) {
        return os.id === "DELIVERED";
      }).status;
    },
    canEditImporter: function canEditImporter() {
      var _this6 = this;
      return this.canManageOrder && this.importersAvailableForCountry.some(function (x) {
        var _this6$order$importer;
        return x.id != ((_this6$order$importer = _this6.order.importer) === null || _this6$order$importer === void 0 ? void 0 : _this6$order$importer.id);
      }) && !this.order.isImporterInvoiced && !this.orderStatus.filter(function (x) {
        return ["CANCELLED", "DELIVERED"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(this.order.status);
    },
    canEditConsultant: function canEditConsultant() {
      return this.canManageConsultantData && this.handlingConsultants.getting.results;
    },
    canEditConsultantCommission: function canEditConsultantCommission() {
      var _this$order$consultan;
      return this.canManageConsultantData && ((_this$order$consultan = this.order.consultant) === null || _this$order$consultan === void 0 ? void 0 : _this$order$consultan.id_user) > 0 && !(this.isCustomerIndividual && this.isAnyTypeInvoiced);
    },
    isCustomerIndividual: function isCustomerIndividual() {
      var _this$order8;
      return ((_this$order8 = this.order) === null || _this$order8 === void 0 || (_this$order8 = _this$order8.user) === null || _this$order8 === void 0 ? void 0 : _this$order8.user_group) === "USER";
    },
    isCustomerProfessional: function isCustomerProfessional() {
      var _this$order9, _this$order10, _this$order11;
      return ((_this$order9 = this.order) === null || _this$order9 === void 0 || (_this$order9 = _this$order9.user) === null || _this$order9 === void 0 ? void 0 : _this$order9.user_group) === "HORECA" || ((_this$order10 = this.order) === null || _this$order10 === void 0 || (_this$order10 = _this$order10.user) === null || _this$order10 === void 0 ? void 0 : _this$order10.user_group) === "WHOLESALER" || ((_this$order11 = this.order) === null || _this$order11 === void 0 || (_this$order11 = _this$order11.user) === null || _this$order11 === void 0 ? void 0 : _this$order11.isHolding);
    },
    isCustomerHorecaUs: function isCustomerHorecaUs() {
      var _this$order12;
      return this.isCustomerProfessional && ((_this$order12 = this.order) === null || _this$order12 === void 0 || (_this$order12 = _this$order12.delivery_address) === null || _this$order12 === void 0 ? void 0 : _this$order12.country.iso_code) === "USA";
    },
    isCustomerIndividualUs: function isCustomerIndividualUs() {
      var _this$order13;
      return this.isCustomerIndividual && ((_this$order13 = this.order) === null || _this$order13 === void 0 || (_this$order13 = _this$order13.delivery_address) === null || _this$order13 === void 0 ? void 0 : _this$order13.country.iso_code) === "USA";
    },
    canBePricePostingUsaProSubmitted: function canBePricePostingUsaProSubmitted() {
      var _this$customerComplet;
      return (_this$customerComplet = this.customerComplete) === null || _this$customerComplet === void 0 ? void 0 : _this$customerComplet.isPricePostingUsaProSubmittedByPriceCoherence;
    },
    isEligibleCountryToChangeCurrency: function isEligibleCountryToChangeCurrency() {
      var _this$order14, _this$order15, _this$order16;
      return ((_this$order14 = this.order) === null || _this$order14 === void 0 || (_this$order14 = _this$order14.delivery_address) === null || _this$order14 === void 0 || (_this$order14 = _this$order14.country) === null || _this$order14 === void 0 ? void 0 : _this$order14.currency) !== null && ((_this$order15 = this.order) === null || _this$order15 === void 0 || (_this$order15 = _this$order15.delivery_address) === null || _this$order15 === void 0 || (_this$order15 = _this$order15.country) === null || _this$order15 === void 0 ? void 0 : _this$order15.currency) !== "EUR" && ((_this$order16 = this.order) === null || _this$order16 === void 0 || (_this$order16 = _this$order16.delivery_address) === null || _this$order16 === void 0 || (_this$order16 = _this$order16.country) === null || _this$order16 === void 0 ? void 0 : _this$order16.id_country) !== COUNTRIES.USA.id;
    },
    canChangeCurrency: function canChangeCurrency() {
      var _this$order17, _this$listDefaultCurr;
      return this.canManageOrder && this.isOrderEditable && this.isEligibleCountryToChangeCurrency && !this.isAnyTypeInvoiced && !(this.isPaymentProcessing || this.isPaymentSucceeded) && !this.isContainerOrder && !((_this$order17 = this.order) !== null && _this$order17 !== void 0 && (_this$order17 = _this$order17.parentContainerOrder) !== null && _this$order17 !== void 0 && _this$order17.id_order) > 0 && ((_this$listDefaultCurr = this.listDefaultCurrencies) === null || _this$listDefaultCurr === void 0 ? void 0 : _this$listDefaultCurr.length) > 1;
    },
    isCurrencyStillEditable: function isCurrencyStillEditable() {
      var _this$listDefaultCurr2;
      return this.canManageOrder && this.isEligibleCountryToChangeCurrency && !this.isAnyTypeInvoiced && !(this.isPaymentProcessing || this.isPaymentSucceeded) && (this.isAdminWaitingForCustomerAction || this.isWaitingForAdminValidation) && ((_this$listDefaultCurr2 = this.listDefaultCurrencies) === null || _this$listDefaultCurr2 === void 0 ? void 0 : _this$listDefaultCurr2.length) > 1;
    },
    listDefaultCurrencies: function listDefaultCurrencies() {
      var _this$order$delivery_,
        _this$order$delivery_2,
        _this$order$factoring2,
        _this7 = this;
      var availableCurrencies = [];
      if (((_this$order$delivery_ = this.order.delivery_address) === null || _this$order$delivery_ === void 0 || (_this$order$delivery_ = _this$order$delivery_.country) === null || _this$order$delivery_ === void 0 ? void 0 : _this$order$delivery_.id_country) === COUNTRIES.USA.id) {
        availableCurrencies = ["USD"];
      } else if (((_this$order$delivery_2 = this.order.delivery_address) === null || _this$order$delivery_2 === void 0 || (_this$order$delivery_2 = _this$order$delivery_2.country) === null || _this$order$delivery_2 === void 0 ? void 0 : _this$order$delivery_2.id_country) === COUNTRIES.BAHAMAS.id) {
        availableCurrencies = ["BSD", "USD"];
      } else {
        var _this$order18, _this$order19;
        availableCurrencies.push("EUR");
        if ((_this$order18 = this.order) !== null && _this$order18 !== void 0 && _this$order18.currency) availableCurrencies.push(this.order.currency);
        if ((_this$order19 = this.order) !== null && _this$order19 !== void 0 && (_this$order19 = _this$order19.delivery_address) !== null && _this$order19 !== void 0 && (_this$order19 = _this$order19.country) !== null && _this$order19 !== void 0 && _this$order19.currency) availableCurrencies.push(this.order.delivery_address.country.currency);
      }
      if (((_this$order$factoring2 = this.order.factoringProvider) === null || _this$order$factoring2 === void 0 || (_this$order$factoring2 = _this$order$factoring2.currencies) === null || _this$order$factoring2 === void 0 ? void 0 : _this$order$factoring2.length) > 0) {
        availableCurrencies = availableCurrencies.filter(function (x) {
          return _this7.order.factoringProvider.currencies.includes(x);
        });
      }
      return listCurrencies.filter(function (x) {
        return availableCurrencies.includes(x.id);
      });
    },
    isBypassBuyLimitMessageAvailable: function isBypassBuyLimitMessageAvailable() {
      return this.order.status === this.orderStatus.find(function (os) {
        return os.id == "AWAITING_VALIDATION";
      }).status || this.order.status === _orderStatus.find(function (os) {
        return os.id == "AWAITING_CUSTOMER_VALIDATION";
      }).status || this.order.status == this.orderStatus.find(function (os) {
        return os.id === "ADJUSTING";
      }).status || this.order.status == this.orderStatus.find(function (os) {
        return os.id === "VALIDATED";
      }).status;
    },
    userData: function userData() {
      return String.parseForVHtml(getFullNameUserHtml(this.order.user)) + "<br /><span class='text-smaller text-italic'>" + userGroupName(this.order.user) + (this.order.user.sponsorship_code ? " - " + this.order.user.sponsorship_code : "") + "</span>";
    },
    isEditingItemList: function isEditingItemList() {
      return this.idProductsUpdating.length > 0 || this.isAddingWine;
    },
    isAwaitingLogisticDetail: function isAwaitingLogisticDetail() {
      return this.mustRefreshLogisticDetails || !this.order.expedition_method && this.isFetchingShippingCosts;
    },
    isShippingInBlockingError: function isShippingInBlockingError() {
      return this.isShippingEditable && !this.isAwaitingLogisticDetail && (this.expedition_methods.length === 0 || this.expedition_methods.length === 1 && this.expedition_methods[0].isErrorEvenSuperAdmin);
    },
    shippingOverviewType: function shippingOverviewType() {
      var _this8 = this;
      if (this.order.expedition_method > 0) {
        var method_ref = Object.values(this.expedition_methods_ref).filter(function (ep) {
          return ep.id === _this8.order.expedition_method;
        })[0];
        return {
          icon: method_ref.faIcon,
          label: method_ref.text
        };
      } else {
        return null;
      }
    },
    currentInboundWarehouse: function currentInboundWarehouse() {
      var _this9 = this;
      return this.inboundWarehouses.find(function (x) {
        return x.id_warehouse === _this9.order.inbound_warehouse_id;
      }) || null;
    },
    currentStockTransferWarehouse: function currentStockTransferWarehouse() {
      var _this10 = this;
      return this.inboundWarehouses.find(function (x) {
        return x.id_warehouse === _this10.order.stockTransferWarehouseId;
      }) || null;
    },
    canManageFactoringProviders: function canManageFactoringProviders() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_FACTORING);
    },
    canEditFactoringProvider: function canEditFactoringProvider() {
      return this.canManageFactoringProviders && this.canManageOrder //&& this.factoringProvidersAvailable.some(x => x.id != this.order.factoringProvider?.id)
      ;
    },
    canChangeFactoringProvider: function canChangeFactoringProvider() {
      return this.canManageFactoringProviders && this.canManageOrder && this.isOrderEditable && this.isEligibleCountryToChangeCurrency && !(this.isPaymentProcessing || this.isPaymentSucceeded);
    },
    rulesForInboundWarehouse: function rulesForInboundWarehouse() {
      return [this.rules.mustSelectValue];
    },
    totalOrderDispatchPaymentAmountCurrency: function totalOrderDispatchPaymentAmountCurrency() {
      return this.inboundDeliveryPayments.filter(function (x) {
        return x.paymentState === paymentState.SUCCEEDED;
      }).reduce(function (acc, x) {
        return acc + x.totalAmountCurrency;
      }, 0);
    },
    totalPaymentAmountCurrency: function totalPaymentAmountCurrency() {
      return this.order.payments.filter(function (x) {
        return x.state === paymentState.SUCCEEDED;
      }).reduce(function (acc, x) {
        return acc + x.amount;
      }, 0);
    },
    totalReconciliationPayments: function totalReconciliationPayments() {
      var totalFromOcOrders = this.accountancyReconciliationPayments.payments.filter(function (x) {
        return x.orderPaymentState === paymentState.SUCCEEDED;
      }).reduce(function (acc, x) {
        return acc + x.totalAmountCurrencyAssociations;
      }, 0);
      var totalFromOldStockTransfers = this.accountancyReconciliationPayments.paymentsFromOldStockTransfers.filter(function (x) {
        return x.orderPaymentState === paymentState.SUCCEEDED;
      }).reduce(function (acc, x) {
        return acc + x.totalAmountCurrencyAssociations;
      }, 0);
      return totalFromOcOrders + totalFromOldStockTransfers;
    },
    totalCreditNoteNoteSucceeded: function totalCreditNoteNoteSucceeded() {
      var paymentStatesToInclude = Object.values(paymentState).filter(function (state) {
        return state !== "Succeeded" && state !== "Failed";
      });
      return this.order.payments.filter(function (x) {
        return x.type === 9;
      }).filter(function (x) {
        return paymentStatesToInclude.includes(x.state);
      }).reduce(function (acc, x) {
        return acc + x.amount;
      }, 0);
    },
    remainingPaymentAmount: function remainingPaymentAmount() {
      return roundToTwoDigit(this.order.total_amount_currency) - roundToTwoDigit(this.totalCreditNoteNoteSucceeded) - roundToTwoDigit(this.totalPaymentAmountCurrency) - roundToTwoDigit(this.totalOrderDispatchPaymentAmountCurrency) - roundToTwoDigit(this.totalReconciliationPayments);
    },
    canOpenAccountancyReconciliation: function canOpenAccountancyReconciliation() {
      return this.canManageAccountancy && this.hasBeenValidated && !this.isOrderEditable && !this.isCancelled;
    },
    itemsProvenanceFromOrder: function itemsProvenanceFromOrder() {
      return this.order.items.filter(function (x) {
        return x.item_provenances.some(function (p) {
          var _p$stockPart;
          return ((_p$stockPart = p.stockPart) === null || _p$stockPart === void 0 || (_p$stockPart = _p$stockPart.fromOrderData) === null || _p$stockPart === void 0 ? void 0 : _p$stockPart.id) > 0;
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          item_provenances: item.item_provenances.filter(function (provenance) {
            var _provenance$stockPart;
            return ((_provenance$stockPart = provenance.stockPart) === null || _provenance$stockPart === void 0 || (_provenance$stockPart = _provenance$stockPart.fromOrderData) === null || _provenance$stockPart === void 0 ? void 0 : _provenance$stockPart.id) > 0;
          })
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          quantity: item.item_provenances.reduce(function (acc, x) {
            return acc + x.quantity;
          }, 0)
        });
      });
    },
    itemsProvenanceNotFromOrder: function itemsProvenanceNotFromOrder() {
      return this.order.items.filter(function (x) {
        return x.item_provenances.some(function (p) {
          var _p$stockPart2;
          return !((_p$stockPart2 = p.stockPart) !== null && _p$stockPart2 !== void 0 && (_p$stockPart2 = _p$stockPart2.fromOrderData) !== null && _p$stockPart2 !== void 0 && _p$stockPart2.id) > 0;
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          item_provenances: item.item_provenances.filter(function (provenance) {
            var _provenance$stockPart2;
            return !((_provenance$stockPart2 = provenance.stockPart) !== null && _provenance$stockPart2 !== void 0 && (_provenance$stockPart2 = _provenance$stockPart2.fromOrderData) !== null && _provenance$stockPart2 !== void 0 && _provenance$stockPart2.id) > 0;
          })
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          quantity: item.item_provenances.reduce(function (acc, x) {
            return acc + x.quantity;
          }, 0)
        });
      });
    },
    hasWarningItemsProvenanceAboutInvoice: function hasWarningItemsProvenanceAboutInvoice() {
      var _this$itemsProvenance, _this$itemsProvenance2;
      return this.order.isPreventInvoice && ((_this$itemsProvenance = this.itemsProvenanceNotFromOrder) === null || _this$itemsProvenance === void 0 ? void 0 : _this$itemsProvenance.length) > 0 || !this.order.isPreventInvoice && ((_this$itemsProvenance2 = this.itemsProvenanceFromOrder) === null || _this$itemsProvenance2 === void 0 ? void 0 : _this$itemsProvenance2.length) > 0;
    },
    orderExpeditionMethodChosen: function orderExpeditionMethodChosen() {
      if (this.isAwaitingLogisticDetail) {
        var _this$lastExpeditionM, _this$lastExpeditionM2;
        return (_this$lastExpeditionM = (_this$lastExpeditionM2 = this.lastExpeditionMethod) === null || _this$lastExpeditionM2 === void 0 ? void 0 : _this$lastExpeditionM2.expedition_method) !== null && _this$lastExpeditionM !== void 0 ? _this$lastExpeditionM : 0;
      } else {
        return this.order.expedition_method;
      }
    },
    totalOfItemsIncludeDefaultShipping: function totalOfItemsIncludeDefaultShipping() {
      var _this$order20,
        _this11 = this;
      return (_this$order20 = this.order) === null || _this$order20 === void 0 || (_this$order20 = _this$order20.items) === null || _this$order20 === void 0 ? void 0 : _this$order20.reduce(function (acc, item) {
        return acc + _this11.getUnitPriceCurrencyForItem(item, _this11.orderExpeditionMethodChosen) * item.quantity;
      }, 0);
    },
    isContainerOrder: function isContainerOrder() {
      return this.order.type === orderTypes.CONTAINER;
    },
    isContainerOrderBeforeMerge: function isContainerOrderBeforeMerge() {
      return this.order.isContainerOrderBeforeMerge;
    },
    isLinkedToContainerOrder: function isLinkedToContainerOrder() {
      var _this$order$parentCon;
      return ((_this$order$parentCon = this.order.parentContainerOrder) === null || _this$order$parentCon === void 0 ? void 0 : _this$order$parentCon.id_order) > 0;
    },
    isLinkedToContainerOrderBeforeMerge: function isLinkedToContainerOrderBeforeMerge() {
      return this.isLinkedToContainerOrder && this.order.parentContainerOrder.isContainerOrderBeforeMerge;
    },
    isAnyChanceOfContainer: function isAnyChanceOfContainer() {
      var _this$order21, _this$order22, _this$order23;
      return this.isLinkedToContainerOrder || this.isContainerOrder || !((_this$order21 = this.order) !== null && _this$order21 !== void 0 && _this$order21.isStockTransfer) && ((_this$order22 = this.order) === null || _this$order22 === void 0 ? void 0 : _this$order22.expedition_method) === expeditionMethods.SEA_FREIGHT.id && !this.isCustomerIndividual && this.orderStatus.filter(function (x) {
        return ["AWAITING_VALIDATION", "AWAITING_CUSTOMER_VALIDATION", "ADJUSTING", "VALIDATED", "IN_PREPARATION"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes((_this$order23 = this.order) === null || _this$order23 === void 0 ? void 0 : _this$order23.status);
    },
    canManageSupplierPrices: function canManageSupplierPrices() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_SUPPLIER_PRICES);
    }
  },
  created: function created() {
    var _this12 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this12$baseModel, _this12$order$pricePo, _this12$order$pricePo2, _this12$$refs$orderHi;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if ((_this12$baseModel = _this12.baseModel) !== null && _this12$baseModel !== void 0 && _this12$baseModel.id_order) {
              _context.next = 3;
              break;
            }
            _this12.$router.push({
              name: "userHome"
            });
            return _context.abrupt("return");
          case 3:
            _this12.clientAppData = getClientAppData(_this12);
            _this12.canManageUsers = hasRole(process.env.VUE_APP_ROLES_MANAGE_USER);
            _this12.canManageOrder = hasRole(process.env.VUE_APP_ROLES_MANAGE_ORDER);
            _this12.canAccessPoData = hasRole(process.env.VUE_APP_ROLES_ACCESS_SOURCING) || hasRole(process.env.VUE_APP_ROLES_MANAGE_PURCHASE_ORDERS);
            _this12.canManageAccountancy = hasRole(process.env.VUE_APP_ROLES_MANAGE_ACCOUNTANCY);
            _this12.canManageConsultantData = hasRole(process.env.VUE_APP_ROLES_MANAGE_ORDER_CONSULTANT_DATA);
            _this12.tastingPhotos.canManage = hasRole(process.env.VUE_APP_ROLES_MANAGE_TASTING_PHOTOS);
            _this12.pricePostingDetails.canManage = hasRole(process.env.VUE_APP_ROLES_MANAGE_PRICE_POSTING);
            _this12.userLoggedHasLimitedLocation = hasLimitedLocations(_this12.loggedUserData);
            _this12.order = _objectSpread(_objectSpread({}, _this12.order), _this12.baseModel);
            _context.next = 15;
            return _this12.fetchCompleteCustomer();
          case 15:
            _this12.computeCasings();
            _this12.pricePosting.idUsed = (_this12$order$pricePo = (_this12$order$pricePo2 = _this12.order.pricePostingUsaPro) === null || _this12$order$pricePo2 === void 0 ? void 0 : _this12$order$pricePo2.id) !== null && _this12$order$pricePo !== void 0 ? _this12$order$pricePo : null;
            if (_this12.order.shipping_quantity != null) {
              _this12.isShippingQuantity = true;
            }
            _this12.fetchSubstituteCustomers();
            (_this12$$refs$orderHi = _this12.$refs.orderHistoryDrawer) === null || _this12$$refs$orderHi === void 0 || _this12$$refs$orderHi.fetchHistory();
            _this12.fetchOrderChildren();
            _this12.fetchInboundDeliveries();
            _this12.isDeliveryInstructionsAsDefaultForUserAdress = _this12.isOrderDeliveryInstructionsDefaultUser();
            _this12.sameAddress = isSameAddress(_this12.order.delivery_address, _this12.order.billing_address);
            if (!_this12.isShippingEditable) {
              _context.next = 30;
              break;
            }
            _context.next = 27;
            return _this12.fetchOrderLogistic(true, false);
          case 27:
            _this12.saveLastExpeditionMethod();
            _context.next = 31;
            break;
          case 30:
            _this12.order = calculateOrderAmountsLocal(_this12.order);
          case 31:
            _this12.$EventBus.$emit("loading", false);
            _this12.fetchInboundWarehouses();
            if (!_this12.isShipped) {
              if (_this12.isInInboundWithoutWarehouse) {
                _this12.isChangingInboundWarehouses = true;
              }
            }
            if (_this12.orderStatusAdjusting.includes(_this12.order.status)) {
              _this12.fetchAdjustments();
            }
            _this12.fetchCountries();
            _this12.refetchDocs();
            _this12.fetchAttachedFiles();
            if (_this12.isCreditNoteGenerable) {
              _this12.fetchGeneratedCreditNotes();
            }
            if (_this12.isCreditNoteUsable) {
              _this12.fetchUsableCreditNotes();
            }
            if (!_this12.isDelivered && !_this12.isCancelled) {
              _this12.fetchImportersAvailableForCountry();
            } else {
              _this12.fetchFactoringProvidersAvailable();
            }
            _this12.fetchCustomerStripeMethods();
            _this12.fetchCompleteDepartureWarehouse();
            _this12.fetchConsultants();
            _this12.getAvailablePricePostings();
            _this12.getInvoicePaymentReconciliations();
            _this12.getRequiredTastingPhotos();
            if (_this12.canEditItems) _this12.fetchCompleteWinesForDiscounts();
          case 48:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    updateCustomer: function updateCustomer() {
      this.isUpdatingCustomer = true;
      var _this = this;
      return request("/v1/orders/".concat(this.order.id_order, "/customer/").concat(this.updatedCustomerId), "put", null, true, "api").then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.fetchOrder();
            case 2:
              _this.$toasted.show("Customer updated", {
                type: "success"
              });
              _this.fetchUsableCreditNotes();
              _this.fetchFactoringProvidersAvailable();
              _this.refetchDocs();
              _this.isUpdatingCustomer = false;
              _this.isEditingCustomer = false;
              _this.customerDialogShown = false;
              _this.updatedCustomerId = null;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))).catch(function (e) {
        _this.isUpdatingCustomer = false;
        var errorData = getErrorData(e, _this.managedExceptions, "Unable to change the customer", true);
        handleErrorData(_this, errorData);
      });
    },
    fetchSubstituteCustomers: function fetchSubstituteCustomers() {
      var _this = this;
      request("/v1/orders/".concat(this.order.id_order, "/substitute-customers"), "get", null, true, "api").then(function (response) {
        _this.substituteCustomers = response.data.value;
      }).catch(function (e) {
        var errorData = getErrorData(e, _this.managedExceptions, "Unable to get available substitute customers", true);
        handleErrorData(_this, errorData);
      });
    },
    toogleCollapseItemsList: function toogleCollapseItemsList() {
      this.isCollapsed = !this.isCollapsed;
      if (this.isCollapsed) {
        this.$nextTick(function () {
          document.querySelector("#order-summary-list").scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        });
      }
    },
    fetchInboundDeliveries: function fetchInboundDeliveries() {
      var _this = this;
      this.isFetchingInboundDeliveries = true;
      request("/v1/orders/".concat(this.order.id_order, "/inbound-deliveries"), "get", null, true, "api").then(function (response) {
        _this.inboundDeliveries = _toConsumableArray(response.data);
        _this.isFetchingInboundDeliveries = false;
      });
    },
    fetchOrderChildren: function fetchOrderChildren() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this13;
              request("/v1/order/".concat(_this13.order.id_order, "/children"), "get", null, true, "api").then(function (response) {
                _this.orderChildren = response.data.value;
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get children orders.", true);
                handleErrorData(_this, errorData);
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchCountries: function fetchCountries() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this14;
              request("/v1/countries?implantedMarket=true", "post", _this.clientAppData, false, "api").then(function (response) {
                _this.listCountries = _toConsumableArray(response.data.countries);
                _this.listStates = _toConsumableArray(response.data.states);
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get countries.", true);
                handleErrorData(_this, errorData);
              });
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fetchOrder: function fetchOrder(_, ack) {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this15$order$pricePo, _this15$order$pricePo2, _this15$order, _this15$order$expedit, _this15$$refs$orderHi;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this = _this15;
              _context5.next = 3;
              return request("/v1/order/" + _this15.order.id_order, "get", null, true, "api").catch(function (e) {
                if (e.response.data) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "warning"
                  });
                }
                throw e;
              });
            case 3:
              response = _context5.sent;
              _this15.order = _objectSpread(_objectSpread({}, _this15.order), response.data);
              _this15.pricePosting.idUsed = (_this15$order$pricePo = (_this15$order$pricePo2 = _this15.order.pricePostingUsaPro) === null || _this15$order$pricePo2 === void 0 ? void 0 : _this15$order$pricePo2.id) !== null && _this15$order$pricePo !== void 0 ? _this15$order$pricePo : null;
              (_this15$order$expedit = (_this15$order = _this15.order).expedition_methods) !== null && _this15$order$expedit !== void 0 ? _this15$order$expedit : _this15$order.expedition_methods = [];
              _this15.order = calculateOrderAmountsLocal(_this15.order);
              _this15.computeCasings();
              (_this15$$refs$orderHi = _this15.$refs.orderHistoryDrawer) === null || _this15$$refs$orderHi === void 0 || _this15$$refs$orderHi.fetchHistory(true);
              _this15.computeWithCreditNoteItems();
              ack === null || ack === void 0 || ack(_this15.order);
              if (_this15.canEditItems) {
                _this15.fetchCompleteWinesForDiscounts();
              }
              _this15.$nextTick(function () {
                var _this15$$refs$orderCo;
                (_this15$$refs$orderCo = _this15.$refs.orderContainerChapter) === null || _this15$$refs$orderCo === void 0 || _this15$$refs$orderCo.refreshData();
              });
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    calculateOrderAmounts: function calculateOrderAmounts() {
      var _arguments = arguments,
        _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this16$calculateOrde;
        var isCalculatingAmounts, _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              isCalculatingAmounts = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : true;
              if (isCalculatingAmounts) {
                _this16.isCalculatingAmounts = true;
              }
              (_this16$calculateOrde = _this16.calculateOrderAmountsToken) === null || _this16$calculateOrde === void 0 || _this16$calculateOrde.cancel();
              _this16.calculateOrderAmountsToken = axios.CancelToken.source();
              _this = _this16;
              _context6.next = 7;
              return request("/v1/order/".concat(_this16.order.id_order, "/calculate-amounts"), "put", null, true, "api", null, _this16.calculateOrderAmountsToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.order.isFullyCalculatedAmounts = false;
                  if (isCalculatingAmounts) {
                    _this.isCalculatingAmounts = false;
                  }
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to calculate amounts.", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 7:
              if (isCalculatingAmounts) {
                _this16.isCalculatingAmounts = false;
              }
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    calculateAndFetchOrder: function calculateAndFetchOrder() {
      var _arguments2 = arguments,
        _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var withLoading, _this17$$refs$orderPa;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              withLoading = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : false;
              if (withLoading) {
                _this17.$EventBus.$emit("loading", true);
              }
              _this17.isCalculatingAmounts = true;
              _context7.prev = 3;
              _context7.next = 6;
              return _this17.calculateOrderAmounts(false);
            case 6:
              _context7.next = 8;
              return _this17.fetchOrder(null, function () {});
            case 8:
              (_this17$$refs$orderPa = _this17.$refs.orderPaymentList) === null || _this17$$refs$orderPa === void 0 || _this17$$refs$orderPa.updatePayments(_this17.order.payments);
              _context7.next = 13;
              break;
            case 11:
              _context7.prev = 11;
              _context7.t0 = _context7["catch"](3);
            case 13:
              _this17.isCalculatingAmounts = false;
              if (withLoading) {
                _this17.$EventBus.$emit("loading", false);
              }
            case 15:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[3, 11]]);
      }))();
    },
    fetchOrderLogistic: function fetchOrderLogistic() {
      var _arguments3 = arguments,
        _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var forceCalculation, withLoading, _this19, response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              forceCalculation = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : false;
              withLoading = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : true;
              if (!_this18.hasItems) {
                _context8.next = 23;
                break;
              }
              if (withLoading) {
                _this18.$EventBus.$emit("loading", true);
              }
              _this18.isCalculatingAmounts = true;
              _this18.isFetchingShippingCosts = true;
              _this19 = _this18;
              _context8.next = 9;
              return request("/v1/order/".concat(_this18.order.id_order, "/logistic/"), "get", null, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this19.managedExceptions, "Unable to get logistic costs.", true);
                handleErrorData(_this19, errorData);
              });
            case 9:
              response = _context8.sent;
              _this18.isFetchingShippingCosts = false;
              if (!response) {
                _context8.next = 15;
                break;
              }
              _context8.next = 14;
              return _this19.computeCharges(response.data);
            case 14:
              _this19.mustRefreshLogisticDetails = false;
            case 15:
              if (!(!_this18.order.isFullyCalculatedAmounts && forceCalculation)) {
                _context8.next = 20;
                break;
              }
              _context8.next = 18;
              return _this18.updateExpeditionMethod();
            case 18:
              _context8.next = 20;
              return _this18.calculateAndFetchOrder();
            case 20:
              if (!_this18.order.isFullyCalculatedAmounts) {
                _this18.order = calculateOrderAmountsLocal(_this18.order);
              }
              _this18.isCalculatingAmounts = false;
              if (withLoading) {
                _this18.$EventBus.$emit("loading", false);
              }
            case 23:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    afterSplitOrder: function afterSplitOrder(ack) {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this20.fetchOrder(null, ack);
            case 2:
              if (_this20.order.expedition_method) {
                _context9.next = 6;
                break;
              }
              _this20.order.isFullyCalculatedAmounts = false;
              _context9.next = 6;
              return _this20.fetchOrderLogistic(true);
            case 6:
              _this20.refetchDocs();
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    computeCasings: function computeCasings() {
      var _this21 = this;
      this.order.items.map(function (x) {
        return x.wine.casings = _this21.casingsAvailable(x);
      });
    },
    casingsAvailable: function casingsAvailable(item) {
      var wineCasings = item.wine.casings.map(function (wc) {
        return _objectSpread(_objectSpread({}, wc), {}, {
          textCard: casingWines.find(function (x) {
            return x.value == wc.casingId;
          }).textCard
        });
      });
      wineCasings.sort(function (a, b) {
        return a.quantity - b.quantity;
      });
      if (!wineCasings.some(function (x) {
        return x.quantity == 1;
      })) {
        wineCasings.unshift(casingForAdmin());
      }
      return wineCasings;
    },
    cancelOrder: function cancelOrder() {
      var _this22 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var ok, _this23;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this22.$refs.confirm.open("Cancellation", "Are you sure you want to cancel this order ?", {
                color: "red"
              });
            case 2:
              ok = _context10.sent;
              if (!ok) {
                _context10.next = 19;
                break;
              }
              _this22.isDecliningOrder = true;
              _this22.isUpdatingOrderStatus = true;
              _context10.prev = 6;
              _this23 = _this22;
              _context10.next = 10;
              return request("/v1/order/" + _this22.order.id_order + "/state/" + _orderStatus.filter(function (os) {
                return os.id === "CANCELLED";
              })[0].status, "put", {
                send_mails: true
              }, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this23.managedExceptions, "Unable to cancel this order.", true);
                handleErrorData(_this23, errorData);
                throw e;
              });
            case 10:
              _context10.next = 12;
              return _this22.fetchOrder(null, function () {});
            case 12:
              _this22.$toasted.show("Order has been cancelled successfully.", {
                type: "success"
              });
              _context10.next = 17;
              break;
            case 15:
              _context10.prev = 15;
              _context10.t0 = _context10["catch"](6);
            case 17:
              _this22.isDecliningOrder = false;
              _this22.isUpdatingOrderStatus = false;
            case 19:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[6, 15]]);
      }))();
    },
    onHoldOrder: function onHoldOrder() {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this24.$refs.confirm.open("On Hold", "Are you sure to put this order on the on hold status ?", {
                color: "red"
              });
            case 2:
              ok = _context11.sent;
              if (ok) {
                _this24.updateOrderStatus(_orderStatus.filter(function (os) {
                  return os.id === "ON_HOLD";
                })[0].status);
              }
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    cancelAddresses: function cancelAddresses() {
      this.isEditingAddresses = false;
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        delivery_address: this.bufferedAddresses.deliveryAddress
      });
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        billing_address: this.bufferedAddresses.billingAddress
      });
      this.sameAddress = this.bufferedAddresses.isSameAddress;
    },
    editAddresses: function editAddresses() {
      this.isEditingAddresses = true;
      this.bufferedAddresses = {
        deliveryAddress: _objectSpread({}, this.order.delivery_address),
        billingAddress: _objectSpread({}, this.order.billing_address),
        isSameAddress: this.sameAddress
      };
    },
    editBillingAddress: function editBillingAddress() {
      this.isEditingAddresses = true;
      this.bufferedAddresses = {
        billingAddress: _objectSpread({}, this.order.billing_address)
      };
    },
    cancelBillingAddress: function cancelBillingAddress() {
      this.isEditingAddresses = false;
      this.mustRecalculateCharges = false;
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        billing_address: this.bufferedAddresses.billingAddress
      });
    },
    editInboundWarehouseAddress: function editInboundWarehouseAddress() {
      this.isChangingInboundWarehouses = true;
      this.bufferedAddresses = {
        deliveryAddress: _objectSpread({}, this.order.delivery_address),
        inbound_warehouse_id: this.order.inbound_warehouse_id
      };
    },
    cancelInboundWarehouseAddress: function cancelInboundWarehouseAddress() {
      this.isChangingInboundWarehouses = false;
      if (this.order.is_destination_inbound && !this.order.inbound_warehouse_id) {
        this.order.is_destination_inbound = false;
        this.changeDestinationInbound();
      } else {
        this.order = _objectSpread(_objectSpread({}, this.order), {}, {
          delivery_address: this.bufferedAddresses.deliveryAddress,
          inbound_warehouse_id: this.bufferedAddresses.inbound_warehouse_id
        });
        this.bufferedAddresses = {
          inbound_warehouse_id: null
        };
      }
    },
    editStockTransferWarehouseAddress: function editStockTransferWarehouseAddress() {
      this.isChangingStockTransferWarehouses = true;
      this.bufferedAddresses = {
        deliveryAddress: _objectSpread({}, this.order.delivery_address),
        stockTransferWarehouseId: this.order.stockTransferWarehouseId
      };
      this.formStockTransfer = {
        stockTransferIsPreselling: this.order.stockTransferIsPreselling,
        reservationType: this.order.stockTransferReservationType,
        reservationUserId: this.order.stockTransferReservationUserId,
        reservationConsultantId: this.order.stockTransferReservationConsultantId
      };
    },
    cancelStockTransferWarehouseAddress: function cancelStockTransferWarehouseAddress() {
      this.isChangingStockTransferWarehouses = false;
      this.formStockTransfer = {
        stockTransferIsPreselling: this.order.stockTransferIsPreselling,
        reservationType: this.order.stockTransferReservationType,
        reservationUserId: this.order.stockTransferReservationUserId,
        reservationConsultantId: this.order.stockTransferReservationConsultantId
      };
      if (this.order.isStockTransfer && !this.order.stockTransferWarehouseId) {
        this.order.isStockTransfer = false;
        this.changeIsStockTransfer();
      } else {
        this.order = _objectSpread(_objectSpread({}, this.order), {}, {
          delivery_address: this.bufferedAddresses.deliveryAddress,
          stockTransferWarehouseId: this.bufferedAddresses.stockTransferWarehouseId
        });
        this.bufferedAddresses = {
          stockTransferWarehouseId: null
        };
      }
    },
    updateStockTransferReservation: function updateStockTransferReservation(form) {
      this.formStockTransfer.reservationType = form.stockReservationType;
      this.formStockTransfer.reservationUserId = form.stockReservationUserId;
      this.formStockTransfer.reservationConsultantId = form.stockReservationConsultantId;
    },
    openDefineAsStockTransferOnShippedDialog: function openDefineAsStockTransferOnShippedDialog() {
      var _this$order$user;
      this.definingAsStockTransferOnShipped.isConfiguring = true;
      // Preload reservation type
      if (this.order.user.isAllowedToDispatchToAnyone) {
        this.definingAsStockTransferOnShipped.form.reservationType = stockReservationTypes.DEFAULT.id;
      } else if ((_this$order$user = this.order.user) !== null && _this$order$user !== void 0 && _this$order$user.isHolding) {
        this.definingAsStockTransferOnShipped.form.reservationType = stockReservationTypes.SPECIFIC_CONSULTANT.id;
        this.definingAsStockTransferOnShipped.form.reservationConsultantId = this.order.user.id_user;
      } else {
        this.definingAsStockTransferOnShipped.form.reservationType = stockReservationTypes.SPECIFIC_CUSTOMER.id;
        this.definingAsStockTransferOnShipped.form.reservationUserId = this.order.user.id_user;
      }
    },
    changeWarehouseDefineStockTransfer: function changeWarehouseDefineStockTransfer(warehouseId) {
      this.definingAsStockTransferOnShipped.form.warehouseId = warehouseId;
    },
    updateDefineAsStockTransferReservation: function updateDefineAsStockTransferReservation(form) {
      this.definingAsStockTransferOnShipped.form.reservationType = form.stockReservationType;
      this.definingAsStockTransferOnShipped.form.reservationUserId = form.stockReservationUserId;
      this.definingAsStockTransferOnShipped.form.reservationConsultantId = form.stockReservationConsultantId;
    },
    saveAsStockTransferOnShipped: function saveAsStockTransferOnShipped() {
      var _this25 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this25$definingAsSto;
        var _this, data;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this25.definingAsStockTransferOnShipped.isPending = true;
              (_this25$definingAsSto = _this25.definingAsStockTransferOnShipped.cancellationToken) === null || _this25$definingAsSto === void 0 || _this25$definingAsSto.cancel();
              _this25.definingAsStockTransferOnShipped.cancellationToken = axios.CancelToken.source();
              _this = _this25;
              data = _objectSpread({}, _this25.definingAsStockTransferOnShipped.form);
              _context12.next = 7;
              return request("/v1/orders/".concat(_this25.order.id_order, "/stock-transfer"), "put", data, true, "api", null, _this25.definingAsStockTransferOnShipped.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.definingAsStockTransferOnShipped.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to define order to deliver as available stock.", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              _context12.next = 9;
              return _this25.fetchOrder(null, function () {});
            case 9:
              _this25.isDocumentsFetched = false;
              _this25.order = _objectSpread(_objectSpread({}, _this25.order), {}, {
                isFullyGeneratedDocuments: false
              });
              _this25.definingAsStockTransferOnShipped.isPending = false;
              _this25.definingAsStockTransferOnShipped.isConfiguring = false;
            case 13:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    confirmCancelAsStockTransfer: function confirmCancelAsStockTransfer() {
      var _this26 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return _this26.$refs.confirm.open("Not deliver as available stocks ?", "Are you sure to cancel the order setting 'Deliver as available stocks' ?", {
                color: "red",
                width: 600
              });
            case 2:
              ok = _context13.sent;
              if (ok) {
                _this26.cancelAsStockTransfer();
              }
            case 4:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    cancelAsStockTransfer: function cancelAsStockTransfer() {
      var _this27 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this27$cancellingAsS;
        var _this;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this27.cancellingAsStockTransfer.isPending = true;
              (_this27$cancellingAsS = _this27.cancellingAsStockTransfer.cancellationToken) === null || _this27$cancellingAsS === void 0 || _this27$cancellingAsS.cancel();
              _this27.cancellingAsStockTransfer.cancellationToken = axios.CancelToken.source();
              _this = _this27;
              _context14.next = 6;
              return request("/v1/orders/".concat(_this27.order.id_order, "/stock-transfer"), "delete", null, true, "api", null, _this27.cancellingAsStockTransfer.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.cancellingAsStockTransfer.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to cancel the definition of the deliver as available stock.", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 6:
              _context14.next = 8;
              return _this27.fetchOrder(null, function () {});
            case 8:
              _this27.isDocumentsFetched = false;
              _this27.order = _objectSpread(_objectSpread({}, _this27.order), {}, {
                isFullyGeneratedDocuments: false
              });
              _this27.cancellingAsStockTransfer.isPending = false;
            case 11:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    confirmCreatePreArrivalStocks: function confirmCreatePreArrivalStocks() {
      var _this28 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return _this28.$refs.confirm.open("Create all pre-arrival stocks ?", "Are you sure to create all products as pre-arrival stocks available ? Warning : This action can't be be cancelled.", {
                color: "red",
                width: 600
              });
            case 2:
              ok = _context15.sent;
              if (ok) {
                _this28.createPreArrivalStocks();
              }
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    createPreArrivalStocks: function createPreArrivalStocks() {
      var _this29 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var _this29$creatingPreAr;
        var _this;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _this29.creatingPreArrivalStocks.isPending = true;
              (_this29$creatingPreAr = _this29.creatingPreArrivalStocks.cancellationToken) === null || _this29$creatingPreAr === void 0 || _this29$creatingPreAr.cancel();
              _this29.creatingPreArrivalStocks.cancellationToken = axios.CancelToken.source();
              _this = _this29;
              _context16.next = 6;
              return request("/v1/orders/".concat(_this29.order.id_order, "/pre-arrival-stocks"), "post", null, true, "api", null, _this29.creatingPreArrivalStocks.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.creatingPreArrivalStocks.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to create pre-arrival stocks.", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 6:
              _context16.next = 8;
              return _this29.fetchOrder(null, function () {});
            case 8:
              _this29.creatingPreArrivalStocks.isPending = false;
            case 9:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    addItemUpdating: function addItemUpdating(id_item) {
      this.idProductsUpdating.push(id_item);
    },
    removeItemUpdating: function removeItemUpdating(id_item) {
      this.idProductsUpdating.splice(this.idProductsUpdating.indexOf(id_item), 1);
    },
    isActiveItem: function isActiveItem(item) {
      return !item.hasClosedStock && item.wine.is_active && !item.wine.deleted && !item.wine.isClosedStock;
    },
    showShipmentModal: function showShipmentModal(value) {
      var _this30 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _this31;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _this30.shipmentModalShown = value;
              _this30.availabilities = [];
              if (!(Boolean(value) === true)) {
                _context17.next = 7;
                break;
              }
              _this31 = _this30;
              _context17.next = 6;
              return request("/v1/shipping/orders/" + _this31.order.id_order + "/pickup-availability", "get", null, true, "api").then(function (_ref2) {
                var data = _ref2.data;
                _this31.availabilities = data;
              }).catch(function (e) {
                if (e.response.data) {
                  _this31.$toasted.show(e.response.data.value, {
                    type: "error"
                  });
                }
              });
            case 6:
              return _context17.abrupt("return", _context17.sent);
            case 7:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    openDocument: function openDocument(item) {
      window.open(item.url, "_blank");
    },
    productDetails: function productDetails(wine) {
      var detailsRoute = wine.type == listWineTypes.find(function (x) {
        return x.name === "Spirit";
      }).id ? "adminSpiritsDetails" : "adminWineDetails";
      return {
        name: detailsRoute,
        params: {
          id: wine.id_wine
        }
      };
    },
    computeCharges: function computeCharges(db) {
      var _this32 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var groupedShippingMethodsByDeparture, _this, shippingAmount, totalAmountCurrency;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _this32.expedition_methods = _this32.getAvailableExpeditionMethods(db);
              _this32.expedition_methods = [].concat(_toConsumableArray(_this32.expedition_methods.filter(function (m) {
                return m.expedition_method !== 6;
              })), _toConsumableArray(_this32.expedition_methods.filter(function (m) {
                return m.expedition_method === 6;
              })));
              _context18.next = 4;
              return _this32.initShippingMethod();
            case 4:
              groupedShippingMethodsByDeparture = _this32.expedition_methods.reduce(function (acc, x) {
                if (!acc[x.departureWarehouseId]) return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, [x]));
                return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, [].concat(_toConsumableArray(acc[x.departureWarehouseId]), [x])));
              }, {}); // Compute order shipping amount
              _this = _this32;
              Object.values(groupedShippingMethodsByDeparture).forEach(function (x) {
                var _x = _slicedToArray(x, 1),
                  anyShippingMethod = _x[0];
                if (x.length === 1) {
                  _this.order.expedition_methods[anyShippingMethod.departureWarehouseId] = anyShippingMethod;
                }
                _this.order.items.filter(function (e) {
                  return anyShippingMethod.itemIds.includes(e.id_item);
                }).forEach(function (e) {
                  if (x.length === 1) e.expeditionMethod = anyShippingMethod.expedition_method;
                  if (!e.expeditionMethod) {
                    var itemWithExistingShippingMethod = _this.order.items.filter(function (it) {
                      return anyShippingMethod.itemIds.includes(it.id_item);
                    }).find(function (it) {
                      return !!it.expeditionMethod;
                    });
                    if (itemWithExistingShippingMethod) {
                      e.expeditionMethod = itemWithExistingShippingMethod.expeditionMethod;
                    }
                  }
                  if (!!e.expeditionMethod) {
                    var shippingMethod = x.find(function (s) {
                      return s.id === e.expeditionMethod;
                    });
                    if (shippingMethod) {
                      e.totalShipping = shippingMethod.price_numeric_currency;
                      e.shippingAmount = e.totalShipping / anyShippingMethod.itemIds.length;
                    }
                  }
                });
              });
              shippingAmount = _this32.order.items.reduce(function (acc, x) {
                return acc + x.shippingAmount || 0;
              }, 0);
              totalAmountCurrency = shippingAmount + _this32.order.items.reduce(function (acc, x) {
                return acc + x.unit_price_currency * x.quantity;
              }, 0);
              _this32.order = _objectSpread(_objectSpread({}, _this32.order), {}, {
                amount_shipping_currency: shippingAmount,
                total_amount_currency: totalAmountCurrency,
                total_amount_currency_include_credit_notes: totalAmountCurrency - _this32.order.credit_notes_amount_currency
              });
            case 10:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    initShippingMethod: function initShippingMethod() {
      var _this33 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var initialShippingMethod, _this33$expedition_me, eta_min_hours, eta_max_hours, expedition_method, anyItem, shippingMethod;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              initialShippingMethod = _this33.order.expedition_method;
              if (!(_this33.expedition_methods.length === 1 && !_this33.expedition_methods[0].isErrorEvenSuperAdmin)) {
                _context19.next = 10;
                break;
              }
              _this33$expedition_me = _this33.expedition_methods[0], eta_min_hours = _this33$expedition_me.eta_min_hours, eta_max_hours = _this33$expedition_me.eta_max_hours, expedition_method = _this33$expedition_me.expedition_method;
              _this33.order.expedition_method = expedition_method;
              _this33.order.items.forEach(function (x) {
                return x.expeditionMethod = expedition_method;
              });
              _this33.order.eta_min_hours = eta_min_hours;
              _this33.order.eta_max_hours = eta_max_hours;
              if (!(_this33.order.expedition_method !== initialShippingMethod)) {
                _context19.next = 10;
                break;
              }
              _context19.next = 10;
              return _this33.updateExpeditionMethod();
            case 10:
              _this33.order.expedition_methods = _this33.expedition_methods.reduce(function (acc, x) {
                var item = _this33.order.items.find(function (e) {
                  return x.itemIds.includes(e.id_item);
                });
                if (item && item.expeditionMethod === x.expedition_method) {
                  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, x));
                }
                return acc;
              }, {});
              if (_this33.isShippingEditable) {
                anyItem = _this33.order.items[0];
                shippingMethod = _this33.expedition_methods.find(function (x) {
                  return anyItem.expeditionMethod === x.expedition_method;
                });
                if (!!shippingMethod) {
                  _this33.order.expedition_method = shippingMethod.expedition_method;
                  _this33.order.eta_min_hours = shippingMethod.eta_min_hours;
                  _this33.order.eta_max_hours = shippingMethod.eta_max_hours;
                } else {
                  _this33.order.expedition_method = null;
                }
              }
            case 12:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    getAvailableExpeditionMethods: function getAvailableExpeditionMethods(db) {
      var _this34 = this;
      return db.expedition_prices.map(function (x) {
        if ((x === null || x === void 0 ? void 0 : x.expedition_price) >= 0) {
          var method_ref = Object.values(_this34.expedition_methods_ref).filter(function (ep) {
            return ep.id === x.expedition_method;
          })[0];
          var priceExp = x.expeditionPriceCurrency;
          return _objectSpread(_objectSpread({}, x), {}, {
            id: x.expedition_method,
            departureWarehouseId: x.departureWarehouseId,
            icon: method_ref.faIcon,
            label: method_ref.text,
            price_numeric_currency: priceExp,
            price_label: "+ ".concat(formatPrice(priceExp / x.itemIds.length), " ").concat(_this34.getSymbolCurrency(_this34.order.currency), " / bottle"),
            price_global_label: formatPrice(priceExp) + " " + _this34.getSymbolCurrency(_this34.order.currency),
            eta_label: _this34.getEtaLabel(x.eta_min_hours, x.eta_max_hours),
            original_object: x
          });
        }
      });
    },
    getEtaLabel: function getEtaLabel(eta_min_hours, eta_max_hours) {
      var unit = eta_min_hours > 72 || eta_max_hours && eta_max_hours > 72 ? "days" : "hours";
      if (unit === "days") {
        return Math.ceil(eta_min_hours / 24) + (eta_max_hours ? "-" + Math.ceil(eta_max_hours / 24) : "") + " " + unit;
      } else {
        return eta_min_hours + (eta_max_hours ? "-" + eta_max_hours : "") + " " + unit;
      }
    },
    editItemPrice: function editItemPrice(item) {
      var _this35 = this;
      this.addItemUpdating(item.id_item);
      this.currentItemForWineStockChanged = item;
      this.editOrderItemPriceDialogShown = true;
      this.$nextTick(function () {
        _this35.$refs.EditOrderItemPriceDialog.open();
      });
    },
    confirmItemPrice: function confirmItemPrice() {
      var _this36 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var itemId, _this36$$refs$orderPa;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _this36.isDocumentsFetched = false;
              _this36.order = _objectSpread(_objectSpread({}, _this36.order), {}, {
                isFullyCalculatedAmounts: false,
                isFullyGeneratedDocuments: false
              });
              _this36.editOrderItemPriceDialogShown = false;
              itemId = _this36.currentItemForWineStockChanged.id_item;
              _this36.$nextTick(function () {
                _this36.currentItemForWineStockChanged = null;
              });
              _this36.removeItemUpdating(itemId);
              if (_this36.isEditingItemList) {
                _context20.next = 10;
                break;
              }
              _context20.next = 9;
              return _this36.fetchOrder(null, function () {});
            case 9:
              (_this36$$refs$orderPa = _this36.$refs.orderPaymentList) === null || _this36$$refs$orderPa === void 0 || _this36$$refs$orderPa.updatePayments(_this36.order.payments);
            case 10:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    cancelEditOrderItemPriceDialog: function cancelEditOrderItemPriceDialog() {
      var _this37 = this;
      this.editOrderItemPriceDialogShown = false;
      var itemId = this.currentItemForWineStockChanged.id_item;
      this.$nextTick(function () {
        _this37.currentItemForWineStockChanged = null;
      });
      this.removeItemUpdating(itemId);
    },
    deleteItem: function deleteItem(itemId) {
      var _this38 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var confirmMessage;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (_this38.order.items.length < 2 && !_this38.isContainerOrderBeforeMerge) {
                _this38.$toasted.show("You can't remove the last item. You should cancel the order", {
                  type: "warning"
                });
              } else {
                confirmMessage = "Are you sure you want to delete this product ?";
                _this38.$refs.confirm.open("Delete", confirmMessage, {
                  color: "red"
                }).then(/*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21(confirm) {
                    var backupOrder, item, _this39;
                    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
                      while (1) switch (_context21.prev = _context21.next) {
                        case 0:
                          if (!confirm) {
                            _context21.next = 20;
                            break;
                          }
                          _this38.addItemUpdating(itemId);
                          backupOrder = _objectSpread({}, _this38.order);
                          backupOrder = _objectSpread(_objectSpread({}, backupOrder), {}, {
                            items: _toConsumableArray(backupOrder.items)
                          });
                          _context21.prev = 4;
                          item = _this38.order.items.find(function (x) {
                            return x.id_item === itemId;
                          });
                          _this39 = _this38;
                          _context21.next = 9;
                          return request("/v1/basket/items/".concat(itemId), "delete", {
                            orderId: _this38.order.id_order
                          }, true, "api").then(function (_) {
                            _this39.order.items.splice(_this39.order.items.indexOf(item), 1);
                            _this39.isDocumentsFetched = false;
                            _this39.order = _objectSpread(_objectSpread({}, _this39.order), {}, {
                              isFullyCalculatedAmounts: false,
                              isFullyGeneratedDocuments: false
                            });
                          }).catch(function (e) {
                            _this39.order = backupOrder;
                            var errorData = getErrorData(e, _this39.managedExceptions, "Unable to remove item", true);
                            handleErrorData(_this39, errorData);
                            throw e;
                          });
                        case 9:
                          _context21.next = 11;
                          return _this38.resetLogisticDetails();
                        case 11:
                          _this38.order = calculateOrderAmountsLocal(_this38.order);
                          _this38.$toasted.show("Product removed.", {
                            type: "success"
                          });
                          _this38.$refs.OrderAttachedFilesDrawerRef.fetchWineDocuments();
                          _this38.$refs.OrderAttachedFilesDrawerRef.fetchWineryDocuments();
                          _context21.next = 19;
                          break;
                        case 17:
                          _context21.prev = 17;
                          _context21.t0 = _context21["catch"](4);
                        case 19:
                          _this38.removeItemUpdating(itemId);
                        case 20:
                        case "end":
                          return _context21.stop();
                      }
                    }, _callee21, null, [[4, 17]]);
                  }));
                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }());
              }
            case 1:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }))();
    },
    updateItemQuantity: function updateItemQuantity(itemId, quantity, casingId) {
      var _this40 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _this = _this40;
              _context25.next = 3;
              return request("/v1/basket/items/".concat(itemId, "/quantity"), "post", {
                orderId: _this40.order.id_order,
                quantity: quantity,
                casingId: casingId
              }, true, "api").then(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23(_) {
                  return _regeneratorRuntime().wrap(function _callee23$(_context23) {
                    while (1) switch (_context23.prev = _context23.next) {
                      case 0:
                        _this.isDocumentsFetched = false;
                        _this.order = _objectSpread(_objectSpread({}, _this.order), {}, {
                          isFullyCalculatedAmounts: false,
                          isFullyGeneratedDocuments: false
                        });
                        _context23.next = 4;
                        return _this.resetLogisticDetails();
                      case 4:
                      case "end":
                        return _context23.stop();
                    }
                  }, _callee23);
                }));
                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }()).catch(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24(e) {
                  var _e$response;
                  var isBypassingReachedBuyLimit, _e$response$data$valu, _e$response2, _e$response3, errorMessage, _e$response4, _e$response5, message, _errorMessage;
                  return _regeneratorRuntime().wrap(function _callee24$(_context24) {
                    while (1) switch (_context24.prev = _context24.next) {
                      case 0:
                        isBypassingReachedBuyLimit = null;
                        if (!((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 || (_e$response = _e$response.value) === null || _e$response === void 0 ? void 0 : _e$response.errorCode) === buyLimitErrors.BUY_LIMIT_REACHED.value && hasRole(process.env.VUE_APP_ROLES_BYPASS_ALL_BUY_LIMITS))) {
                          _context24.next = 8;
                          break;
                        }
                        errorMessage = (_e$response$data$valu = e === null || e === void 0 || (_e$response2 = e.response) === null || _e$response2 === void 0 || (_e$response2 = _e$response2.data) === null || _e$response2 === void 0 || (_e$response2 = _e$response2.value) === null || _e$response2 === void 0 ? void 0 : _e$response2.errorMessage) !== null && _e$response$data$valu !== void 0 ? _e$response$data$valu : e === null || e === void 0 || (_e$response3 = e.response) === null || _e$response3 === void 0 || (_e$response3 = _e$response3.data) === null || _e$response3 === void 0 || (_e$response3 = _e$response3.value) === null || _e$response3 === void 0 ? void 0 : _e$response3.message;
                        _context24.next = 5;
                        return _this.$refs.confirm.open("Bypass buy limits for order", "".concat(errorMessage, "  ").concat(buyLimitErrors.BUY_LIMIT_REACHED.text), {
                          color: "red"
                        });
                      case 5:
                        isBypassingReachedBuyLimit = _context24.sent;
                        _context24.next = 9;
                        break;
                      case 8:
                        if (e !== null && e !== void 0 && (_e$response4 = e.response) !== null && _e$response4 !== void 0 && (_e$response4 = _e$response4.data) !== null && _e$response4 !== void 0 && (_e$response4 = _e$response4.value) !== null && _e$response4 !== void 0 && _e$response4.message) {
                          message = e.response.data.value.message;
                          _this.$toasted.show(message, {
                            type: "warning"
                          });
                        } else if (e !== null && e !== void 0 && (_e$response5 = e.response) !== null && _e$response5 !== void 0 && (_e$response5 = _e$response5.data) !== null && _e$response5 !== void 0 && (_e$response5 = _e$response5.value) !== null && _e$response5 !== void 0 && _e$response5.errorMessage) {
                          _errorMessage = e.response.data.value.errorMessage;
                          _this.$toasted.show(_errorMessage, {
                            type: "warning"
                          });
                        } else {
                          _this.$toasted.show("An error occured. Please contact an administrator.", {
                            type: "error"
                          });
                        }
                      case 9:
                        if (isBypassingReachedBuyLimit) {
                          _context24.next = 13;
                          break;
                        }
                        _this.order.items = _this.order.items.map(function (x) {
                          return _objectSpread(_objectSpread({}, x), {}, {
                            quantity: x.original_qty
                          });
                        });
                        _context24.next = 17;
                        break;
                      case 13:
                        _context24.next = 15;
                        return request("/v1/order/".concat(_this.order.id_order, "/bypass"), "put", null, true, "api");
                      case 15:
                        _context24.next = 17;
                        return _this.updateItemQuantity(itemId, quantity, casingId);
                      case 17:
                      case "end":
                        return _context24.stop();
                    }
                  }, _callee24);
                }));
                return function (_x4) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 3:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    },
    changeQuantityOrder: function changeQuantityOrder(item, quantity) {
      var _this41 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        var casing, itemRef, _this41$$refs$orderPa;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _this41.addItemUpdating(item.id_item);
              _this41.errorLabels.quantity_orders = [];
              casing = item.casingId.match(/\d+/)[0];
              quantity = quantity * casing;
              itemRef = _this41.order.items.find(function (x) {
                return x.id_item === item.id_item;
              });
              itemRef.quantity = quantity;
              itemRef.casingId = item.casingId;
              itemRef.total_amount = item.quantity * item.unit_price;
              if (itemRef.quantity == 0) {
                // if the quantity of the item is down to 0, we delete the item of the cart and from the order
                _this41.order.items.splice(_this41.order.items.indexOf(itemRef), 1);
              }
              _context26.prev = 9;
              _context26.next = 12;
              return _this41.updateItemQuantity(item.id_item, quantity, item.casingId);
            case 12:
              _context26.next = 16;
              break;
            case 14:
              _context26.prev = 14;
              _context26.t0 = _context26["catch"](9);
            case 16:
              _this41.removeItemUpdating(item.id_item);
              if (_this41.isEditingItemList) {
                _context26.next = 21;
                break;
              }
              _context26.next = 20;
              return _this41.fetchOrder(null, function () {});
            case 20:
              (_this41$$refs$orderPa = _this41.$refs.orderPaymentList) === null || _this41$$refs$orderPa === void 0 || _this41$$refs$orderPa.updatePayments(_this41.order.payments);
            case 21:
            case "end":
              return _context26.stop();
          }
        }, _callee26, null, [[9, 14]]);
      }))();
    },
    searchWines: function searchWines(value) {
      var _this42 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        var search, _this42$searchWineCan, _this42$order$id_ware, departureWarehouseId, data, _this43;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              if (isArrowKey(value.keyCode)) {
                _context27.next = 15;
                break;
              }
              search = value.target.value;
              _this42.searchValue = value.target.value;
              if (!(search.length < 3)) {
                _context27.next = 7;
                break;
              }
              _this42.winesAddables = [];
              _context27.next = 15;
              break;
            case 7:
              _this42.isLoadingAddableWines = true;
              (_this42$searchWineCan = _this42.searchWineCancellationToken) === null || _this42$searchWineCan === void 0 || _this42$searchWineCan.cancel();
              _this42.searchWineCancellationToken = axios.CancelToken.source();
              departureWarehouseId = (_this42$order$id_ware = _this42.order.id_warehouse) !== null && _this42$order$id_ware !== void 0 ? _this42$order$id_ware : Object.keys(_this42.order.expedition_methods)[0];
              data = {
                filters: {
                  StockOnly: true
                },
                label: search,
                departureWarehouseIds: [departureWarehouseId],
                calculate_prices: false,
                userIdTarget: _this42.order.id_user,
                byPassStockReservation: hasRole(process.env.VUE_APP_ROLES_BYPASS_STOCK_RESERVATION)
              };
              _this43 = _this42;
              _context27.next = 15;
              return request("/v1/wines", "post", data, true, "api", null, _this42.searchWineCancellationToken).then(function (response) {
                var idWinesInOrder = _this43.order.items.map(function (y) {
                  return y.id_wine;
                });
                _this43.winesAddables = response.data.wines.filter(function (x) {
                  return !idWinesInOrder.includes(x.id_wine);
                });
                if (_this43.winesAddables.length > 0) {
                  _this43.winesAddables.map(function (x) {
                    x.display_name = x.display_name + " (" + x.casings.find(function (x) {
                      return x.isDefault;
                    }).casingId + ") " + " - " + x.sku;
                    x.casings = _this43.casingsAvailable({
                      wine: x
                    });
                    return x;
                  });
                } else {
                  _this43.$refs[ERROR_DATA.ref].open(ERROR_DATA.DIALOG_TYPES.DIALOG_WARNING.id, "No wine available, or already in this order.", {
                    showMessage: true,
                    showTitle: true
                  }, "Please take note");
                }
                _this43.isLoadingAddableWines = false;
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this43.managedExceptions, "An error occured. Please contact an administrator.", true);
                  handleErrorData(_this43, errorData);
                  _this43.isLoadingAddableWines = false;
                }
              });
            case 15:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }))();
    },
    initWineStockList: function initWineStockList() {
      this.wineStockKey = null;
      this.currentWine = null;
      this.currentItemForWineStockChanged = null;
      this.currentQuantity = 1;
      this.currentCasingId = "OC1";
    },
    closeWineStockListModal: function closeWineStockListModal() {
      var _this44 = this;
      this.$nextTick(function () {
        _this44.initWineStockList();
      });
    },
    isChangeStockAvailable: function isChangeStockAvailable(item) {
      var _this$order$expeditio,
        _this$order$expeditio2,
        _this$fetchingComplet2,
        _item$wine$stocks,
        _this45 = this;
      var departureContinent = ((_this$order$expeditio = this.order.expedition_methods) === null || _this$order$expeditio === void 0 ? void 0 : _this$order$expeditio.length) > 0 ? (_this$order$expeditio2 = this.order.expedition_methods[this.order.id_warehouse]) === null || _this$order$expeditio2 === void 0 ? void 0 : _this$order$expeditio2.departureContinent : null;
      if (!departureContinent && this.expedition_methods && this.expedition_methods.length > 0) {
        var _this$expedition_meth;
        departureContinent = (_this$expedition_meth = this.expedition_methods[0]) === null || _this$expedition_meth === void 0 ? void 0 : _this$expedition_meth.departureContinent;
      }
      if (!departureContinent && this.order.id_warehouse == ((_this$fetchingComplet2 = this.fetchingCompleteDepartureWarehouse.result) === null || _this$fetchingComplet2 === void 0 ? void 0 : _this$fetchingComplet2.id_warehouse)) {
        departureContinent = this.fetchingCompleteDepartureWarehouse.result.address.country.continent_iso_2;
      }
      return !this.isDelivered && !this.isCancelled && !this.isSubcontainerPutInboundStatus && ((_item$wine$stocks = item.wine.stocks) === null || _item$wine$stocks === void 0 ? void 0 : _item$wine$stocks.some(function (x) {
        var _storageContinent;
        var storageContinent = null;
        if (x.stock_type.toLowerCase() === "stock") {
          var _x$warehouse;
          storageContinent = (_x$warehouse = x.warehouse) === null || _x$warehouse === void 0 || (_x$warehouse = _x$warehouse.address) === null || _x$warehouse === void 0 || (_x$warehouse = _x$warehouse.country) === null || _x$warehouse === void 0 ? void 0 : _x$warehouse.continent_iso_2;
        } else if (x.stock_type.toLowerCase() === "consignment") {
          var _x$consignment_storag;
          storageContinent = (_x$consignment_storag = x.consignment_storage) === null || _x$consignment_storag === void 0 || (_x$consignment_storag = _x$consignment_storag.country) === null || _x$consignment_storag === void 0 ? void 0 : _x$consignment_storag.continent_iso_2;
        }
        (_storageContinent = storageContinent) !== null && _storageContinent !== void 0 ? _storageContinent : storageContinent = x.stock_storage_continent_iso2;
        return x.id_stock !== item.wine.id_stock && storageContinent === departureContinent && (x.status !== wineStockStatus.UNAVAILABLE || hasRole(process.env.VUE_APP_ROLES_BYPASS_STOCK_RESERVATION)) && (x.stock_countries.length === 0 || x.stock_countries.some(function (y) {
          return y.id_country === _this45.order.delivery_address.country.id_country;
        }));
      }));
    },
    changeStockItem: function changeStockItem(item) {
      var _this46 = this;
      this.wineStockKey = item.wine.id_wine;
      this.currentWine = _objectSpread({}, item.wine);
      this.currentItemForWineStockChanged = item;
      this.currentQuantity = item.quantity / item.casingId.match(/\d+/)[0];
      this.currentCasingId = item.casingId;
      this.wineStockIsUsedStockSwitchable = true;
      this.$nextTick(function () {
        _this46.$refs.WineStockListModal.open();
      });
    },
    changeWineStockOrder: function changeWineStockOrder(item, quantityTyped, casingId) {
      var _this47 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var _this47$changeWineSto, _this47$order$items$f;
        var itemId, quantity, isChangingQuantity, _this48, _this47$$refs$orderPa;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              itemId = item.id_item;
              _this47.addItemUpdating(itemId);
              (_this47$changeWineSto = _this47.changeWineStockCancellationToken) === null || _this47$changeWineSto === void 0 || _this47$changeWineSto.cancel();
              _this47.changeWineStockCancellationToken = axios.CancelToken.source();
              quantity = quantityTyped * casingId.match(/\d+/)[0];
              isChangingQuantity = ((_this47$order$items$f = _this47.order.items.find(function (x) {
                return x.id_item === item.id_item;
              })) === null || _this47$order$items$f === void 0 ? void 0 : _this47$order$items$f.quantity) !== quantity;
              _context28.prev = 6;
              _this48 = _this47;
              _context28.next = 10;
              return request("/v1/order/".concat(_this47.order.id_order, "/item/stock"), "put", {
                itemId: item.id_item,
                wineId: item.wine.id_wine,
                stockId: item.wine.id_stock,
                quantity: quantity,
                casingId: casingId,
                isBasket: false
              }, true, "api", null, _this47.changeWineStockCancellationToken).then(function (_) {
                _this48.isDocumentsFetched = false;
                _this48.order = _objectSpread(_objectSpread({}, _this48.order), {}, {
                  isFullyCalculatedAmounts: false,
                  isFullyGeneratedDocuments: false
                });
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, {}, "Unable to change the quantity", true);
                  handleErrorData(_this48, errorData);
                  throw e;
                }
              });
            case 10:
              if (!isChangingQuantity) {
                _context28.next = 13;
                break;
              }
              _context28.next = 13;
              return _this47.resetLogisticDetails();
            case 13:
              _context28.next = 17;
              break;
            case 15:
              _context28.prev = 15;
              _context28.t0 = _context28["catch"](6);
            case 17:
              _this47.removeItemUpdating(itemId);
              if (_this47.isEditingItemList) {
                _context28.next = 22;
                break;
              }
              _context28.next = 21;
              return _this47.fetchOrder(null, function () {});
            case 21:
              (_this47$$refs$orderPa = _this47.$refs.orderPaymentList) === null || _this47$$refs$orderPa === void 0 || _this47$$refs$orderPa.updatePayments(_this47.order.payments);
            case 22:
            case "end":
              return _context28.stop();
          }
        }, _callee28, null, [[6, 15]]);
      }))();
    },
    addWineFromWineStockList: function addWineFromWineStockList(wine, casingId) {
      var _arguments4 = arguments,
        _this49 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        var isFromWineStockModal, quantityFromStockModal;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              isFromWineStockModal = _arguments4.length > 2 && _arguments4[2] !== undefined ? _arguments4[2] : false;
              quantityFromStockModal = _arguments4.length > 3 && _arguments4[3] !== undefined ? _arguments4[3] : 0;
              _this49.wineStockKey = null;
              if (!_this49.currentItemForWineStockChanged) {
                _context29.next = 9;
                break;
              }
              _this49.currentItemForWineStockChanged.wine = wine;
              _context29.next = 7;
              return _this49.changeWineStockOrder(_this49.currentItemForWineStockChanged, quantityFromStockModal, casingId);
            case 7:
              _context29.next = 11;
              break;
            case 9:
              _context29.next = 11;
              return _this49.addWine(wine, casingId, isFromWineStockModal, quantityFromStockModal);
            case 11:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }))();
    },
    addWine: function addWine(wine, casingId) {
      var _arguments5 = arguments,
        _this50 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        var _wine$stocks;
        var isFromWineStockModal, quantityFromStockModal, quantity, _this50$addWineCancel, _wine$stocks$, data, _this51, _this50$$refs$orderPa, _e$response6, _e$response$data, value, isBypassingReachedBuyLimit, _value$errorMessage, errorMessage, errorData;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              isFromWineStockModal = _arguments5.length > 2 && _arguments5[2] !== undefined ? _arguments5[2] : false;
              quantityFromStockModal = _arguments5.length > 3 && _arguments5[3] !== undefined ? _arguments5[3] : 0;
              if (!casingId) {
                if (wine.casings.some(function (wc) {
                  return wc.isDefault && wc.quantity <= wine.stock_quantity;
                })) {
                  casingId = wine.casings.find(function (wc) {
                    return wc.isDefault;
                  }).casingId;
                } else if (wine.casings.some(function (wc) {
                  return wc.quantity == 1;
                })) {
                  casingId = wine.casings.find(function (wc) {
                    return wc.quantity == 1;
                  }).casingId;
                } else {
                  casingId = "OC1";
                }
              }
              quantity = 1;
              if (quantityFromStockModal > 0) {
                quantity = quantityFromStockModal;
                _this50.initWineStockList();
              }
              if (!isFromWineStockModal) {
                (_this50$addWineCancel = _this50.addWineCancellationToken) === null || _this50$addWineCancel === void 0 || _this50$addWineCancel.cancel();
                _this50.addWineCancellationToken = axios.CancelToken.source();
              }
              if (!(!isFromWineStockModal && ((_wine$stocks = wine.stocks) === null || _wine$stocks === void 0 ? void 0 : _wine$stocks.length) > 1 && wine.stocks.filter(function (x) {
                return x.status == wineStockStatus.DEFAULT || (x.status !== wineStockStatus.UNAVAILABLE || hasRole(process.env.VUE_APP_ROLES_BYPASS_STOCK_RESERVATION)) && (x.stock_countries.length === 0 || x.stock_countries.some(function (y) {
                  return y.id_country === _this50.order.delivery_address.country.id_country;
                }));
              }).length > 0)) {
                _context30.next = 15;
                break;
              }
              _this50.wineStockKey = wine.id_wine;
              _this50.currentWine = wine;
              _this50.currentQuantity = 1;
              _this50.currentCasingId = wine.casings.find(function (x) {
                return x.isDefault;
              }).casingId;
              _this50.wineStockIsUsedStockSwitchable = false;
              _this50.$nextTick(function () {
                _this50.$refs.WineStockListModal.open();
              });
              _context30.next = 58;
              break;
            case 15:
              _context30.prev = 15;
              _this50.isAddingWine = true;
              data = {
                id_order: _this50.order.id_order,
                expeditionMethod: _this50.order.expedition_method,
                id_wine: wine.id_wine,
                id_stock: wine.id_stock > 0 ? wine.id_stock : (_wine$stocks$ = wine.stocks[0]) === null || _wine$stocks$ === void 0 ? void 0 : _wine$stocks$.id_stock,
                quantity: quantity * casingId.match(/\d+/)[0],
                casingId: casingId
              };
              _this51 = _this50;
              _context30.next = 21;
              return request("/v1/basket/items", "post", data, true, "api", null, _this50.addWineCancellationToken).then(function (_) {
                _this51.isDocumentsFetched = false;
                _this51.order = _objectSpread(_objectSpread({}, _this51.order), {}, {
                  isFullyCalculatedAmounts: false,
                  isFullyGeneratedDocuments: false
                });
              }).catch(function (e) {
                throw e;
              });
            case 21:
              _context30.next = 23;
              return _this50.resetLogisticDetails();
            case 23:
              _this50.isAddingWine = false;
              _this50.wineAdding = null;
              _this50.winesAddables = [];
              if (_this50.isEditingItemList) {
                _context30.next = 30;
                break;
              }
              _context30.next = 29;
              return _this50.fetchOrder(null, function () {});
            case 29:
              (_this50$$refs$orderPa = _this50.$refs.orderPaymentList) === null || _this50$$refs$orderPa === void 0 || _this50$$refs$orderPa.updatePayments(_this50.order.payments);
            case 30:
              _this50.$toasted.show("Product added to the order", {
                type: "success"
              });
              _this50.$refs.OrderAttachedFilesDrawerRef.fetchWineDocuments();
              _this50.$refs.OrderAttachedFilesDrawerRef.fetchWineryDocuments();
              _context30.next = 58;
              break;
            case 35:
              _context30.prev = 35;
              _context30.t0 = _context30["catch"](15);
              if (axios.isCancel(_context30.t0)) {
                _context30.next = 58;
                break;
              }
              _e$response$data = (_e$response6 = _context30.t0.response) === null || _e$response6 === void 0 ? void 0 : _e$response6.data, value = _e$response$data.value;
              if (!value) {
                _context30.next = 56;
                break;
              }
              _this50.$toasted.show(value.errorMessage, {
                type: "warning"
              });
              isBypassingReachedBuyLimit = null;
              if (!(value.errorCode === buyLimitErrors.BUY_LIMIT_REACHED.value && hasRole(process.env.VUE_APP_ROLES_BYPASS_ALL_BUY_LIMITS))) {
                _context30.next = 48;
                break;
              }
              _this50.$toasted.clear();
              errorMessage = (_value$errorMessage = value === null || value === void 0 ? void 0 : value.errorMessage) !== null && _value$errorMessage !== void 0 ? _value$errorMessage : value === null || value === void 0 ? void 0 : value.message;
              _context30.next = 47;
              return _this50.$refs.confirm.open("Bypass buy limits for order", "".concat(errorMessage, "  ").concat(buyLimitErrors.BUY_LIMIT_REACHED.text), {
                color: "red"
              });
            case 47:
              isBypassingReachedBuyLimit = _context30.sent;
            case 48:
              if (!(isBypassingReachedBuyLimit === false)) {
                _context30.next = 50;
                break;
              }
              return _context30.abrupt("return");
            case 50:
              if (!isBypassingReachedBuyLimit) {
                _context30.next = 53;
                break;
              }
              _context30.next = 53;
              return request("/v1/order/".concat(_this50.order.id_order, "/bypass"), "put", null, true, "api");
            case 53:
              _this50.addWine(wine, isFromWineStockModal, quantityFromStockModal);
              _context30.next = 58;
              break;
            case 56:
              errorData = getErrorData(_context30.t0, _this.managedExceptions, "An error occured. Please contact an administrator.", true);
              handleErrorData(_this, errorData);
            case 58:
            case "end":
              return _context30.stop();
          }
        }, _callee30, null, [[15, 35]]);
      }))();
    },
    fetchCompleteWinesForDiscounts: function fetchCompleteWinesForDiscounts() {
      var _this52 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var _this52$fetchingCompl;
        var wineIds, _this52$order, data, _this53, response;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _this52.fetchingCompleteWines.isPending = true;
              (_this52$fetchingCompl = _this52.fetchingCompleteWines.cancellationToken) === null || _this52$fetchingCompl === void 0 || _this52$fetchingCompl.cancel();
              _this52.fetchingCompleteWines.cancellationToken = axios.CancelToken.source();
              wineIds = _this52.order.items.map(function (x) {
                return +x.id_wine;
              });
              if (!(wineIds.length > 0)) {
                _context31.next = 12;
                break;
              }
              data = {
                id_wines: wineIds,
                calculatePrices: true,
                userIdTarget: +_this52.order.id_user,
                departureWarehouseIds: [_this52.order.id_warehouse],
                byPassPagingLimitation: true,
                bypassStockSeek: true,
                bypassDeletedCheck: true
              };
              if (((_this52$order = _this52.order) === null || _this52$order === void 0 || (_this52$order = _this52$order.pricePostingUsaPro) === null || _this52$order === void 0 ? void 0 : _this52$order.id) > 0) data.pricePostingUsaProId = _this52.order.pricePostingUsaPro.id;
              _this53 = _this52;
              _context31.next = 10;
              return request("/v1/wines/", "post", data, true, "api", null, _this53.fetchingCompleteWines.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this53.fetchingCompleteWines.isPending = false;
                  _this53.fetchingCompleteWines.cancellationToken = null;
                  var errorData = getErrorData(e, "Unable to fetch conditional discounts", true);
                  handleErrorData(_this53, errorData);
                }
                throw e;
              });
            case 10:
              response = _context31.sent;
              response.data.wines.forEach(function (completeWine) {
                var _this52$order2;
                var item = (_this52$order2 = _this52.order) === null || _this52$order2 === void 0 || (_this52$order2 = _this52$order2.items) === null || _this52$order2 === void 0 ? void 0 : _this52$order2.find(function (x) {
                  return x.id_wine === completeWine.id_wine;
                });
                if (item !== null) {
                  item.wine = _objectSpread(_objectSpread(_objectSpread({}, item.wine), completeWine), {}, {
                    casings: item.wine.casings
                  });
                }
              });
            case 12:
              _this52.fetchingCompleteWines.isPending = false;
              _this52.fetchingCompleteWines.cancellationToken = null;
            case 14:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      }))();
    },
    updateDeliveryInstructions: function updateDeliveryInstructions() {
      var _this54 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var _this54$updateDeliver;
        var _this;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              (_this54$updateDeliver = _this54.updateDeliveryInstructionsToken) === null || _this54$updateDeliver === void 0 || _this54$updateDeliver.cancel();
              _this54.updateDeliveryInstructionsToken = axios.CancelToken.source();
              _this = _this54;
              _context32.next = 5;
              return request("/v1/orders/" + _this54.order.id_order + "/delivery-instructions", "put", {
                deliveryInstructions: _this54.newDeliveryInstructions,
                isSetAsDefaultForUserAddress: _this54.isDeliveryInstructionsAsDefaultForUserAdress
              }, true, "api", null, _this54.updateDeliveryInstructionsToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to update delivery instructions.", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 5:
              _this54.order.delivery_instructions = _this54.newDeliveryInstructions;
              _this54.isDocumentsFetched = false;
              _this54.editingDeliveryInstructions = false;
              _this54.$toasted.show("Delivery instructions updated", {
                type: "success"
              });
            case 9:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      }))();
    },
    isOrderDeliveryInstructionsDefaultUser: function isOrderDeliveryInstructionsDefaultUser() {
      return String.isNullOrEmpty(this.order.delivery_instructions) && String.isNullOrEmpty(this.order.delivery_address.deliveryInstructions) || this.order.delivery_instructions === this.order.delivery_address.deliveryInstructions;
    },
    updateExpeditionMethod: function updateExpeditionMethod() {
      var _this55 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var _this56$changeExpedit, _this56;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              if (!_this55.order.expedition_method) {
                _context33.next = 6;
                break;
              }
              _this56 = _this55;
              (_this56$changeExpedit = _this56.changeExpeditionMethodToken) === null || _this56$changeExpedit === void 0 || _this56$changeExpedit.cancel();
              _this56.changeExpeditionMethodToken = axios.CancelToken.source();
              _context33.next = 6;
              return request("/v1/order/".concat(_this55.order.id_order, "/expedition-method"), "put", {
                expedition_method: _this56.order.expedition_method,
                eta_min_hours: _this56.order.eta_min_hours,
                eta_max_hours: _this56.order.eta_max_hours
              }, true, "api", null, _this56.changeExpeditionMethodToken).then(function (_) {
                _this56.isDocumentsFetched = false;
                _this56.order = _objectSpread(_objectSpread({}, _this56.order), {}, {
                  isFullyCalculatedAmounts: false,
                  isFullyGeneratedDocuments: false
                });
                _this56.saveLastExpeditionMethod();
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this56.managedExceptions, "Unable to change expedition method", true);
                  handleErrorData(_this56, errorData);
                }
              });
            case 6:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }))();
    },
    changeExpeditionMethod: function changeExpeditionMethod(value) {
      var _this57 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var _lastExpeditionMethod, _lastExpeditionMethod2;
        var lastExpeditionMethods, _lastExpeditionMethod3, isDeselectingCellar, confirmed;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _this57.isChangingExpeditionMethod = true;
              _this57.errorLabels.quantity_orders = [];
              _this57.errorLabels.shipping = {};
              if (!_this57.order.expedition_methods) _this57.order.expedition_methods = {};
              if (_this57.canEditItems) {
                _this57.order.expedition_method = value.id;
                _this57.order.eta_min_hours = value.eta_min_hours;
                _this57.order.eta_max_hours = value.eta_max_hours;
              }
              lastExpeditionMethods = _objectSpread({}, _this57.order.expedition_methods);
              if (!((value.expedition_method === expeditionMethods.CELLAR_STORAGE.id || ((_lastExpeditionMethod = lastExpeditionMethods[value.departureWarehouseId]) === null || _lastExpeditionMethod === void 0 ? void 0 : _lastExpeditionMethod.id) === expeditionMethods.CELLAR_STORAGE.id) && value.expedition_method !== ((_lastExpeditionMethod2 = lastExpeditionMethods[value.departureWarehouseId]) === null || _lastExpeditionMethod2 === void 0 ? void 0 : _lastExpeditionMethod2.id))) {
                _context34.next = 27;
                break;
              }
              isDeselectingCellar = ((_lastExpeditionMethod3 = lastExpeditionMethods[value.departureWarehouseId]) === null || _lastExpeditionMethod3 === void 0 ? void 0 : _lastExpeditionMethod3.id) === expeditionMethods.CELLAR_STORAGE.id;
              _context34.next = 10;
              return _this57.$refs.confirm.open("To your attention", isDeselectingCellar ? "When deselecting this type of shipment, be aware that duties and taxes will be included in the products. Wine's prices will be update." : "When choosing the type of shipment « stored at the cellar », please be aware that duties and taxes will no longer be included on the products and may be charged to you later by the financial authorities. Wine prices will be updated.", {
                color: "warning"
              });
            case 10:
              confirmed = _context34.sent;
              if (!confirmed) {
                _context34.next = 22;
                break;
              }
              _this57.$EventBus.$emit("loading", true);
              _this57.order.expedition_methods[value.departureWarehouseId] = value;
              _this57.computeShippingAmount(value.id, value.price_numeric_currency);
              _context34.next = 17;
              return _this57.updateExpeditionMethod();
            case 17:
              _context34.next = 19;
              return _this57.calculateAndFetchOrder();
            case 19:
              _this57.$EventBus.$emit("loading", false);
              _context34.next = 25;
              break;
            case 22:
              _this57.order = _objectSpread(_objectSpread({}, _this57.order), {}, {
                expedition_method: lastExpeditionMethods.id,
                eta_min_hours: lastExpeditionMethods.eta_min_hours,
                eta_max_hours: lastExpeditionMethods.eta_max_hours,
                expedition_methods: _objectSpread({}, lastExpeditionMethods)
              });
              _this57.isChangingExpeditionMethod = false;
              return _context34.abrupt("return");
            case 25:
              _context34.next = 32;
              break;
            case 27:
              _this57.order.expedition_methods[value.departureWarehouseId] = value;
              _this57.computeShippingAmount(value.id, value.price_numeric_currency);
              if (!_this57.canEditItems) {
                _context34.next = 32;
                break;
              }
              _context34.next = 32;
              return _this57.updateExpeditionMethod();
            case 32:
              _this57.isDocumentsFetched = false;
              _this57.isChangingExpeditionMethod = false;
              _this57.$nextTick(function () {
                _this57.order.expedition_methods = _objectSpread(_objectSpread({}, _this57.order.expedition_methods), {}, _defineProperty({}, value.departureWarehouseId, value));
              });
            case 35:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      }))();
    },
    computeShippingAmount: function computeShippingAmount(shippingMethod, totalShipping) {
      this.order.items.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          expeditionMethod: shippingMethod,
          totalShipping: totalShipping
        });
      });
      var shippingAmount = totalShipping;
      var totalAmountCurrency = shippingAmount + this.order.items.reduce(function (acc, x) {
        return acc + x.unit_price_currency * x.quantity;
      }, 0);
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        amount_shipping_currency: shippingAmount,
        total_amount_currency: totalAmountCurrency,
        total_amount_currency_include_credit_notes: totalAmountCurrency - this.order.credit_notes_amount_currency
      });
    },
    saveLastExpeditionMethod: function saveLastExpeditionMethod() {
      var _this58 = this;
      if (!!this.order.expedition_method) {
        this.lastExpeditionMethod = _objectSpread({}, this.expedition_methods.find(function (x) {
          return x.id === _this58.order.expedition_method;
        }));
      }
    },
    resetLogisticDetails: function resetLogisticDetails() {
      var _this59 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var _this60;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _this59.mustRefreshLogisticDetails = true;
              if (!_this59.order.expedition_method) {
                _context35.next = 7;
                break;
              }
              _this59.saveLastExpeditionMethod();
              _this60 = _this59;
              _this60.order.expedition_method = 0;
              _context35.next = 7;
              return request("/v1/orders/".concat(_this59.order.id_order, "/logistic-details/"), "delete", {
                doRecalculateOrderAmounts: false
              }, true, "api").then(function (_) {
                _this60.order.expedition_methods = [];
                _this60.order.eta_min_hours = 0;
                _this60.order.eta_max_hours = null;
                _this60.order.amount_shipping_currency = null;
                _this60.order.items = _this60.order.items.map(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    expeditionMethod: null
                  });
                });
              }).catch(function (e) {
                _this60.mustRefreshLogisticDetails = false;
                _this60.order.expedition_method = _this60.lastExpeditionMethod.id;
                var errorData = getErrorData(e, _this60.managedExceptions, "An error occured. Please contact an administrator.");
                _this60.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 7:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      }))();
    },
    returnToAdjustableStatus: function returnToAdjustableStatus() {
      var _this61 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              if (_this61.order.isFullyCalculatedAmounts) {
                _context36.next = 3;
                break;
              }
              _context36.next = 3;
              return _this61.calculateOrderAmounts();
            case 3:
              _context36.next = 5;
              return _this61.$refs.confirm.open("To your attention", "Are you sure you want to make adjustments on this order ?", {
                color: "green"
              });
            case 5:
              confirmed = _context36.sent;
              if (confirmed) {
                if (_this61.isAdminWaitingForCustomerAction) {
                  _this61.updateStateOrder(_orderStatus.find(function (x) {
                    return x.id == "ADJUSTING";
                  }).status);
                } else if (_this61.order.status == _orderStatus.find(function (x) {
                  return x.id == "IN_PREPARATION";
                }).status) {
                  _this61.updateStateOrder(_orderStatus.find(function (x) {
                    return x.id == "VALIDATED";
                  }).status);
                } else if (_this61.order.status == _orderStatus.find(function (x) {
                  return x.id == "AWAITING_VALIDATION";
                }).status) {
                  _this61.updateStateOrder(_orderStatus.find(function (x) {
                    return x.id == "ADJUSTING";
                  }).status);
                }
              }
            case 7:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }))();
    },
    updateOrderStatus: function updateOrderStatus(status) {
      var _this62 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              if (!_this62.orderStatus.filter(function (os) {
                return os.id === "VALIDATED";
              }).some(function (x) {
                return x.status === status;
              })) {
                _context37.next = 8;
                break;
              }
              if (_this62.order.isFullyCalculatedAmounts) {
                _context37.next = 4;
                break;
              }
              _context37.next = 4;
              return _this62.calculateAndFetchOrder(true);
            case 4:
              _this62.validationDrawer = true;
              _this62.updateStatusMenu = false;
              _context37.next = 50;
              break;
            case 8:
              if (!_this62.orderStatus.filter(function (os) {
                return os.id === "IN_PREPARATION";
              }).some(function (x) {
                return x.status === status;
              })) {
                _context37.next = 16;
                break;
              }
              if (_this62.order.isFullyCalculatedAmounts) {
                _context37.next = 12;
                break;
              }
              _context37.next = 12;
              return _this62.calculateAndFetchOrder(true);
            case 12:
              _this62.preparationDrawerIterator++;
              _this62.$nextTick(function () {
                _this62.preparationDrawer = true;
                _this62.updateStatusMenu = false;
              });
              _context37.next = 50;
              break;
            case 16:
              if (!_this62.orderStatus.filter(function (os) {
                return os.id === "DELIVERY";
              }).some(function (x) {
                return x.status === status;
              })) {
                _context37.next = 24;
                break;
              }
              if (_this62.order.isFullyCalculatedAmounts) {
                _context37.next = 20;
                break;
              }
              _context37.next = 20;
              return _this62.calculateAndFetchOrder(true);
            case 20:
              _this62.deliveryDrawer = true;
              _this62.updateStatusMenu = false;
              _context37.next = 50;
              break;
            case 24:
              if (!_this62.orderStatus.filter(function (os) {
                return os.id === "DELIVERED";
              }).some(function (x) {
                return x.status === status;
              })) {
                _context37.next = 32;
                break;
              }
              if (_this62.order.isFullyCalculatedAmounts) {
                _context37.next = 28;
                break;
              }
              _context37.next = 28;
              return _this62.calculateAndFetchOrder(true);
            case 28:
              _this62.deliveredDrawer = true;
              _this62.updateStatusMenu = false;
              _context37.next = 50;
              break;
            case 32:
              if (!_this62.orderStatus.filter(function (os) {
                return os.id === "INBOUND";
              }).some(function (x) {
                return x.status === status;
              })) {
                _context37.next = 46;
                break;
              }
              if (_this62.order.isFullyCalculatedAmounts) {
                _context37.next = 36;
                break;
              }
              _context37.next = 36;
              return _this62.calculateOrderAmounts(true);
            case 36:
              _context37.next = 38;
              return _this62.$refs.confirm.open("Stored inbound", "Do you want to notify the customer ?", {
                color: "green"
              });
            case 38:
              confirmed = _context37.sent;
              if (!confirmed) {
                _context37.next = 43;
                break;
              }
              return _context37.abrupt("return", _this62.updateStateOrder(status));
            case 43:
              return _context37.abrupt("return", _this62.updateStateOrder(status, {
                send_mails: false
              }));
            case 44:
              _context37.next = 50;
              break;
            case 46:
              if (_this62.order.isFullyCalculatedAmounts) {
                _context37.next = 49;
                break;
              }
              _context37.next = 49;
              return _this62.calculateOrderAmounts(true);
            case 49:
              return _context37.abrupt("return", _this62.updateStateOrder(status));
            case 50:
            case "end":
              return _context37.stop();
          }
        }, _callee37);
      }))();
    },
    updateStateOrder: function updateStateOrder(status) {
      var _arguments6 = arguments,
        _this63 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        var body, _this;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              body = _arguments6.length > 1 && _arguments6[1] !== undefined ? _arguments6[1] : {};
              _this = _this63;
              _this.$EventBus.$emit("loading", true);
              _this.isUpdatingOrderStatus = true;
              _context39.next = 6;
              return request("/v1/order/" + _this.order.id_order + "/state/" + status, "put", body, true, "api").then(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee38(response) {
                  var _this$$refs$orderShip;
                  return _regeneratorRuntime().wrap(function _callee38$(_context38) {
                    while (1) switch (_context38.prev = _context38.next) {
                      case 0:
                        _this.updateStatusMenu = false;
                        _this.isDocumentsFetched = false;
                        _context38.prev = 2;
                        _context38.next = 5;
                        return _this.fetchOrder(null, function () {});
                      case 5:
                        if (_this.isShippingEditable && (!_this.expedition_methods || _this.expedition_methods.length === 0)) {
                          _this.fetchOrderLogistic(false, false);
                        }
                        _this.$toasted.show("Order status updated.", {
                          type: "success"
                        });
                        (_this$$refs$orderShip = _this.$refs.orderShipmentRef) === null || _this$$refs$orderShip === void 0 || _this$$refs$orderShip.fetchShipments();
                        _context38.next = 12;
                        break;
                      case 10:
                        _context38.prev = 10;
                        _context38.t0 = _context38["catch"](2);
                      case 12:
                        _this.isUpdatingOrderStatus = false;
                        _this.$EventBus.$emit("loading", false);
                      case 14:
                      case "end":
                        return _context38.stop();
                    }
                  }, _callee38, null, [[2, 10]]);
                }));
                return function (_x5) {
                  return _ref6.apply(this, arguments);
                };
              }()).catch(function (e) {
                _this.isUpdatingOrderStatus = false;
                _this.$EventBus.$emit("loading", false);
                var errorData = getErrorData(e, _this.managedExceptions, "An error occured. Please contact an administrator.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 6:
              return _context39.abrupt("return", _context39.sent);
            case 7:
            case "end":
              return _context39.stop();
          }
        }, _callee39);
      }))();
    },
    refetchDocs: function refetchDocs() {
      var _this64 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        var _this65;
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              if (!_this64.isDocumentsConsultable) {
                _context40.next = 9;
                break;
              }
              if (_this64.order.isFullyCalculatedAmounts) {
                _context40.next = 4;
                break;
              }
              _context40.next = 4;
              return _this64.calculateAndFetchOrder();
            case 4:
              _this65 = _this64;
              _this65.isLoadingDocuments = true;
              return _context40.abrupt("return", request("/v1/orders/" + _this65.order.id_order + "/docs", "get", null, true, "api").then(function (_ref7) {
                var data = _ref7.data;
                _this65.documents = data.filter(function (x) {
                  var _x$document_urls;
                  return ((_x$document_urls = x.document_urls) === null || _x$document_urls === void 0 ? void 0 : _x$document_urls.length) > 0;
                }).reduce(function (acc, x) {
                  return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, x), {}, {
                    children: _toConsumableArray(x.document_urls)
                  })]);
                }, []);
                _this65.isDocumentsFetched = true;
                _this65.isLoadingDocuments = false;
              }).catch(function (e) {
                var errorData = getErrorData(e, _this65.managedExceptions, "Unable to refresh documents", true);
                handleErrorData(_this65, errorData);
                _this64.isLoadingDocuments = false;
              }));
            case 9:
              _this64.isLoadingDocuments = false;
            case 10:
            case "end":
              return _context40.stop();
          }
        }, _callee40);
      }))();
    },
    fetchAdjustments: function fetchAdjustments() {
      var _this66 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _this = _this66;
              _context41.next = 3;
              return request("/v1/orders/" + _this66.order.id_order + "/adjustments", "get", null, true, "api").then(function (response) {
                _this.adjustments = response.data;
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "An error occured. Please contact an administrator.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 3:
            case "end":
              return _context41.stop();
          }
        }, _callee41);
      }))();
    },
    upload: function upload() {
      this.fetchAttachedFiles();
    },
    fetchAttachedFiles: function fetchAttachedFiles() {
      var _this67 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _this67.isLoadingAttachedFiles = true;
              _this = _this67;
              _context42.next = 4;
              return request("/v1/order/".concat(_this67.order.id_order, "/files"), "get", null, true, "api", null, _this67.filesCancelToken).then(function (response) {
                if (response) _this.attachedFiles = _toConsumableArray(response.data);
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load files.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
              });
            case 4:
              _this67.isLoadingAttachedFiles = false;
            case 5:
            case "end":
              return _context42.stop();
          }
        }, _callee42);
      }))();
    },
    removeFile: function removeFile(id) {
      var _this68 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
        var confirmed, _this69;
        return _regeneratorRuntime().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _this68.isMakingDrawerStateless = true;
              _context43.next = 3;
              return _this68.$refs.confirm.open("Cancel", "Are you sure you want to remove this file?", {
                color: "red"
              });
            case 3:
              confirmed = _context43.sent;
              if (!confirmed) {
                _context43.next = 10;
                break;
              }
              _this68.isLoadingAttachedFiles = true;
              _this69 = _this68;
              _context43.next = 9;
              return request("/v1/order/".concat(_this68.order.id_order, "/files/").concat(id), "delete", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this69.managedExceptions, "Unable to remove this purchase order.");
                _this69.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                _this69.isLoadingAttachedFiles = false;
                throw e;
              });
            case 9:
              _this68.fetchAttachedFiles();
            case 10:
              _this68.isMakingDrawerStateless = false;
            case 11:
            case "end":
              return _context43.stop();
          }
        }, _callee43);
      }))();
    },
    openFileUrl: function openFileUrl(url) {
      window.open(url, "_blank");
    },
    saveAddress: function saveAddress() {
      var _this70 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
        var _this70$updateAddress;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              (_this70$updateAddress = _this70.updateAddressesToken) === null || _this70$updateAddress === void 0 || _this70$updateAddress.cancel();
              _this70.updateAddressesToken = axios.CancelToken.source();
              data = {
                isDestinationInbound: _this70.order.is_destination_inbound,
                inboundWarehouseId: _this70.order.inbound_warehouse_id,
                isStockTransfer: _this70.order.isStockTransfer,
                stockTransferWarehouseId: _this70.order.stockTransferWarehouseId,
                stockTransferIsPreselling: _this70.isChangingStockTransferWarehouses ? _this70.formStockTransfer.stockTransferIsPreselling : _this70.order.stockTransferIsPreselling,
                stockTransferReservationType: _this70.isChangingStockTransferWarehouses ? _this70.formStockTransfer.reservationType : _this70.order.stockTransferReservationType,
                stockTransferReservationUserId: _this70.isChangingStockTransferWarehouses ? _this70.formStockTransfer.reservationUserId : _this70.order.stockTransferReservationUserId,
                stockTransferReservationConsultantId: _this70.isChangingStockTransferWarehouses ? _this70.formStockTransfer.reservationConsultantId : _this70.order.stockTransferReservationConsultantId,
                deliveryAddress: _this70.order.delivery_address,
                billingAddress: _this70.order.billing_address
              };
              _this = _this70;
              _context44.next = 6;
              return request("/v1/order/".concat(_this70.order.id_order, "/addresses"), "put", data, true, "api", null, _this70.updateAddressesToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to save addresses.", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 6:
              _this70.order.stockTransferIsPreselling = data.stockTransferIsPreselling;
              _this70.order.stockTransferReservationType = data.stockTransferReservationType;
              _this70.order.stockTransferReservationUserId = data.stockTransferReservationUserId;
              _this70.order.stockTransferReservationConsultantId = data.stockTransferReservationConsultantId;
              _this70.isEditingAddresses = false;
              _this70.isDocumentsFetched = false;
              _this70.order.isFullyGeneratedDocuments = false;
              if (_this70.isShipped) _this70.refetchDocs();
            case 14:
            case "end":
              return _context44.stop();
          }
        }, _callee44);
      }))();
    },
    addressChange: function addressChange() {
      if (this.sameAddress) {
        this.order.billing_address = _objectSpread({}, this.order.delivery_address);
      }
    },
    saveBillingAddress: function saveBillingAddress() {
      var _this71 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              _context45.next = 2;
              return _this71.saveAddress();
            case 2:
            case "end":
              return _context45.stop();
          }
        }, _callee45);
      }))();
    },
    saveInboundWarehouseAddress: function saveInboundWarehouseAddress() {
      var _this72 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              _context46.next = 2;
              return _this72.saveAddress();
            case 2:
              _this72.isChangingInboundWarehouses = false;
              _this72.bufferedAddresses = {
                inbound_warehouse_id: null
              };
            case 4:
            case "end":
              return _context46.stop();
          }
        }, _callee46);
      }))();
    },
    saveStockTransferWarehouseAddress: function saveStockTransferWarehouseAddress() {
      var _this73 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
        return _regeneratorRuntime().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              _context47.next = 2;
              return _this73.saveAddress();
            case 2:
              _this73.isChangingStockTransferWarehouses = false;
              _this73.bufferedAddresses = {
                stockTransferWarehouseId: null
              };
            case 4:
            case "end":
              return _context47.stop();
          }
        }, _callee47);
      }))();
    },
    fetchCommittedPresellStockParts: function fetchCommittedPresellStockParts() {
      var _this74 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
        var response;
        return _regeneratorRuntime().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              _this74.committedPresellStockParts = [];
              _context48.next = 3;
              return request("/v1/orders/".concat(_this74.order.id_order, "/committed-presell-parts"), "get", null, true, "api", null);
            case 3:
              response = _context48.sent;
              if (response) {
                _this74.committedPresellStockParts = response.data.value;
              }
            case 5:
            case "end":
              return _context48.stop();
          }
        }, _callee48);
      }))();
    },
    openDialogAdjustmentToCancelOrder: function openDialogAdjustmentToCancelOrder() {
      var _this75 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
        return _regeneratorRuntime().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              _this75.committedPresellStockParts = [];
              _this75.dialogAdjustment.type = orderAdjustmentsTypes.ADMIN_DECLINE.id;
              _this75.dialogAdjustment.visible = true;
            case 3:
            case "end":
              return _context49.stop();
          }
        }, _callee49);
      }))();
    },
    openDialogAdjustment: function openDialogAdjustment() {
      var _this76 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
        return _regeneratorRuntime().wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              if (_this76.order.isFullyCalculatedAmounts) {
                _context50.next = 3;
                break;
              }
              _context50.next = 3;
              return _this76.calculateAndFetchOrder(true);
            case 3:
              _this76.dialogAdjustment.type = orderAdjustmentsTypes.ADMIN_PROPOSE_ADJUSTMENT.id;
              _this76.dialogAdjustment.visible = true;
            case 5:
            case "end":
              return _context50.stop();
          }
        }, _callee50);
      }))();
    },
    dialogAdjustmentAction: function dialogAdjustmentAction() {
      var _this77 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee51() {
        var _this77$adjustmentTok, _this78;
        return _regeneratorRuntime().wrap(function _callee51$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              _this77.errorLabels.adjustment = "";
              _context51.t0 = _this77.dialogAdjustment.type;
              _context51.next = _context51.t0 === orderAdjustmentsTypes.USER_ASK_ADJUSTMENT.id ? 4 : 8;
              break;
            case 4:
              if (!(!_this77.dialogAdjustment.message || _this77.dialogAdjustment.message.length < 1)) {
                _context51.next = 7;
                break;
              }
              _this77.errorLabels.adjustment = _this77.errorMessages.mandatory;
              return _context51.abrupt("return");
            case 7:
              return _context51.abrupt("break", 8);
            case 8:
              _this77.isCreatingAdjustment = true;
              _context51.prev = 9;
              (_this77$adjustmentTok = _this77.adjustmentToken) === null || _this77$adjustmentTok === void 0 || _this77$adjustmentTok.cancel();
              _this77.adjustmentToken = axios.CancelToken.source();
              _this78 = _this77;
              _context51.next = 15;
              return request("/v1/orders/adjustments", "post", {
                order_id: _this78.order.id_order,
                type: _this78.dialogAdjustment.type,
                custom_message: _this78.dialogAdjustment.message
              }, true, "api", null, _this77.adjustmentToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var _e$response7;
                  if ((e === null || e === void 0 || (_e$response7 = e.response) === null || _e$response7 === void 0 || (_e$response7 = _e$response7.data) === null || _e$response7 === void 0 || (_e$response7 = _e$response7.value) === null || _e$response7 === void 0 ? void 0 : _e$response7.errorCode) == "stock_part_in_use") {
                    _this78.fetchCommittedPresellStockParts();
                  }
                  var errorData = getErrorData(e, _this78.managedExceptions, "An error occured. Please contact an administrator.");
                  _this78.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  _this78.isCreatingAdjustment = false;
                  throw e;
                }
              });
            case 15:
              _context51.next = 17;
              return _this77.fetchOrder(null, function () {});
            case 17:
              if (_this77.isCreditNoteGenerable) {
                _this77.fetchGeneratedCreditNotes();
              }
              _context51.next = 20;
              return _this77.fetchAdjustments();
            case 20:
              _this77.dialogAdjustment.message = "";
              _this77.dialogAdjustment.visible = false;
              _this77.$toasted.show(_this78.dialogAdjustmentData.success_toast_message, {
                type: "success"
              });
              _context51.next = 27;
              break;
            case 25:
              _context51.prev = 25;
              _context51.t1 = _context51["catch"](9);
            case 27:
              _this77.isCreatingAdjustment = false;
            case 28:
            case "end":
              return _context51.stop();
          }
        }, _callee51, null, [[9, 25]]);
      }))();
    },
    confirmCancelOrderWithoutNotifyCustomer: function confirmCancelOrderWithoutNotifyCustomer() {
      var _this79 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              _context52.next = 2;
              return _this79.$refs.confirm.open("Cancel order without notify customer", "Are you sure you to cancel this order without notify the customer ?", {
                color: "red"
              });
            case 2:
              ok = _context52.sent;
              if (!ok) {
                _context52.next = 6;
                break;
              }
              _context52.next = 6;
              return _this79.cancelOrderWithoutNotifyCustomer();
            case 6:
            case "end":
              return _context52.stop();
          }
        }, _callee52);
      }))();
    },
    cancelOrderWithoutNotifyCustomer: function cancelOrderWithoutNotifyCustomer() {
      var _this80 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
        var _this81;
        return _regeneratorRuntime().wrap(function _callee53$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              _this80.isCancellingOrderWithoutNotifyCustomer = true;
              _context53.prev = 1;
              _this81 = _this80;
              _context53.next = 5;
              return request("/v1/orders/".concat(_this80.order.id_order), "delete", null, true, "api").catch(function (e) {
                _this81.isCancellingOrderWithoutNotifyCustomer = false;
                var errorData = getErrorData(e, _this81.managedExceptions, "Unable to cancel order.", true);
                handleErrorData(_this81, errorData);
                throw e;
              });
            case 5:
              _context53.next = 7;
              return _this80.fetchOrder(null, function () {});
            case 7:
              if (_this80.isCreditNoteGenerable) {
                _this80.fetchGeneratedCreditNotes();
              }
              _this80.dialogAdjustment.message = "";
              _this80.dialogAdjustment.visible = false;
              _this80.$toasted.show("Order cancelled without notify the customer", {
                type: "success"
              });
              _context53.next = 15;
              break;
            case 13:
              _context53.prev = 13;
              _context53.t0 = _context53["catch"](1);
            case 15:
              _this80.isCancellingOrderWithoutNotifyCustomer = false;
            case 16:
            case "end":
              return _context53.stop();
          }
        }, _callee53, null, [[1, 13]]);
      }))();
    },
    adminConfirmOrderForCustomer: function adminConfirmOrderForCustomer() {
      var _this82 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee54() {
        var _this82$order$payment;
        var ok, _this83;
        return _regeneratorRuntime().wrap(function _callee54$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              if (_this82.order.isFullyCalculatedAmounts) {
                _context54.next = 3;
                break;
              }
              _context54.next = 3;
              return _this82.calculateOrderAmounts();
            case 3:
              ok = true;
              if (!(_this82.order.status == _orderStatus.find(function (x) {
                return x.id == "AWAITING_CUSTOMER_VALIDATION";
              }).status && !((_this82$order$payment = _this82.order.payments) !== null && _this82$order$payment !== void 0 && _this82$order$payment.length))) {
                _context54.next = 8;
                break;
              }
              _context54.next = 7;
              return _this82.$refs.confirm.open("Payment is missing", "Are you sure you to confirm this order without any payment set ? You will have to add payment manually", {
                color: "red"
              });
            case 7:
              ok = _context54.sent;
            case 8:
              if (ok) {
                _this83 = _this82;
                _this83.isApprovingOrder = true;
                _this82.updateStateOrder(_orderStatus.find(function (x) {
                  return x.id === "AWAITING_VALIDATION";
                }).status, {
                  send_mails: false
                }).finally(function (_) {
                  _this83.isApprovingOrder = false;
                });
              }
            case 9:
            case "end":
              return _context54.stop();
          }
        }, _callee54);
      }))();
    },
    adminValidateOrder: function adminValidateOrder() {
      var _this84 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee55$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              _this = _this84;
              _this.isApprovingOrder = true;
              _this84.updateOrderStatus(_orderStatus.find(function (x) {
                return x.id === "VALIDATED";
              }).status).finally(function (_) {
                _this.isApprovingOrder = false;
              });
            case 3:
            case "end":
              return _context55.stop();
          }
        }, _callee55);
      }))();
    },
    computeAddressStockConsignment: function computeAddressStockConsignment(item) {
      if (item.wine.stock_storage_continent_iso2) {
        return " stored in " + listContinents.find(function (x) {
          return x.id == item.wine.stock_storage_continent_iso2;
        }).display_name;
      } else {
        return item.wineryAddress.city + (item.wineryAddress.zip ? " " + item.wineryAddress.zip : "") + ", " + item.wineryAddress.country.printable_name + (item.wineryAddress.state.id_state ? " " + item.wineryAddress.state.state_label : "");
      }
    },
    showPoItemProvenances: function showPoItemProvenances(provenances) {
      var _this85 = this;
      var html = "";
      var hasPoProvenance = false;
      provenances.forEach(function (provenance) {
        var _provenance$stockPart3;
        if (((_provenance$stockPart3 = provenance.stockPart) === null || _provenance$stockPart3 === void 0 || (_provenance$stockPart3 = _provenance$stockPart3.fromPoData) === null || _provenance$stockPart3 === void 0 ? void 0 : _provenance$stockPart3.id) > 0) {
          if (!hasPoProvenance) {
            html += ": from";
            hasPoProvenance = true;
          }
          var route = _this85.$router.resolve(_this85.poDetails(provenance.stockPart.fromPoData.id));
          html += " <a class=\"router-link\" href=\"".concat(route.href, "\">PO#").concat(provenance.stockPart.fromPoData.id, "</a>");
        }
      });
      return html;
    },
    poDetails: function poDetails(poId) {
      return {
        name: "adminEditPurchaseOrder",
        params: {
          id: poId
        }
      };
    },
    goToUserEdit: function goToUserEdit(user) {
      return {
        name: "adminUserDetails",
        query: {
          id_user: user.id_user
        }
      };
    },
    redirectToWineCatalog: function redirectToWineCatalog() {
      this.$router.push({
        name: "adminProductList"
      });
    },
    startEditDeliveryInstructions: function startEditDeliveryInstructions() {
      var _this86 = this;
      this.editingDeliveryInstructions = true;
      this.newDeliveryInstructions = this.order.delivery_instructions;
      this.$nextTick(function (_) {
        _this86.$refs.inputDeliveryInstruction.focus();
      });
    },
    openSendMailModal: function openSendMailModal() {
      var _this87 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
        return _regeneratorRuntime().wrap(function _callee56$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              if (_this87.order.isFullyCalculatedAmounts) {
                _context56.next = 3;
                break;
              }
              _context56.next = 3;
              return _this87.calculateAndFetchOrder(true);
            case 3:
              _this87.sendMailModalShown = true;
              _this87.$nextTick(function () {
                _this87.$refs.SendMailModal.open();
              });
            case 5:
            case "end":
              return _context56.stop();
          }
        }, _callee56);
      }))();
    },
    closeSendMailModal: function closeSendMailModal() {
      var _this88 = this;
      this.$nextTick(function () {
        _this88.sendMailModalShown = false;
        if (!_this88.isDocumentsFetched && _this88.order.isFullyCalculatedAmounts) {
          _this88.refetchDocs();
        }
      });
    },
    toggleShowCreditNoteItems: function toggleShowCreditNoteItems() {
      this.isShowExistingCreditNoteItems = !this.isShowExistingCreditNoteItems;
    },
    creditNoteIsEditable: function creditNoteIsEditable(item) {
      var _item$uses,
        _this89 = this;
      return item.status === this.creditNote.status.DRAFT && !((_item$uses = item.uses) !== null && _item$uses !== void 0 && _item$uses.some(function (x) {
        return x.status !== _this89.creditNoteUse.status.CANCELED;
      }));
    },
    creditNoteDetails: function creditNoteDetails(id) {
      var detailsRoute = "adminEditCreditNote";
      var routeParams = {};
      return {
        name: detailsRoute,
        params: {
          id: id,
          routeParams: routeParams
        }
      };
    },
    fetchUsableCreditNotes: function fetchUsableCreditNotes() {
      var _this90 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee57$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              _this = _this90;
              _context57.next = 3;
              return request("/v1/credit-notes/usables?targetUserId=".concat(_this90.order.id_user), "get", null, true, "api").then(function (response) {
                _this.usableCreditNotes = response.data.value.items.map(function (item) {
                  item.isSelected = false;
                  item.isUsable = true;
                  item.useId = null;
                  item.notUsableMessage = "";
                  item.amountToCredit = 0.0;
                  item.maxAmountToCredit = item.remaining.amountCurrency;
                  if (item.remaining.amountCurrency <= 0) {
                    item.isUsable = false;
                  }
                  if (item.uses !== null) {
                    item.uses.forEach(function (use) {
                      if (use.order !== null && use.status !== creditNoteUse.status.CANCELED) {
                        if (use.order.id === _this.order.id_order) {
                          item.isSelected = true;
                          item.useId = use.id;
                        }
                      }
                    });
                  }
                  if (item.isUsable) {
                    var hasInitialVateRate = item.initialVatRate ? true : false;
                    if (hasInitialVateRate !== _this.isConcernedByVat || hasInitialVateRate && _this.isConcernedByVat && item.initialVatRate !== 1 + parseFloat((_this.order.amount_vat_currency / _this.order.amount_ex_vat_currency).toFixed(3))) {
                      item.isUsable = false;
                      if (hasInitialVateRate) {
                        if (item.initialVatRate.toFixed(2) == 1 + parseFloat((_this.order.amount_vat_currency / _this.order.amount_ex_vat_currency).toFixed(2))) {
                          item.isUsable = true;
                        }
                        item.notUsableMessage = "There is " + ((item.initialVatRate - 1) * 100).toFixed(1) + " % VAT on this credit note.";
                      } else {
                        item.notUsableMessage = "This credit note is without VAT.";
                      }
                    }
                  }
                  if (item.isUsable && item.initialCurrency !== _this.order.currency) {
                    item.isUsable = false;
                    item.notUsableMessage = "The currency (" + item.initialCurrency + ") is not the same on the order.";
                  }
                  return _objectSpread({}, item);
                });
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load usable credit notes.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 3:
            case "end":
              return _context57.stop();
          }
        }, _callee57);
      }))();
    },
    unselectCreditNote: function unselectCreditNote(value) {
      var _this91 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
        var ok, _this91$$refs$orderPa;
        return _regeneratorRuntime().wrap(function _callee58$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              _context58.next = 2;
              return _this91.$refs.confirm.open("Remove", "Are you sure you want to remove this credit of this order ?", {
                color: "red"
              });
            case 2:
              ok = _context58.sent;
              if (!ok) {
                _context58.next = 12;
                break;
              }
              _this91.isUnselectingCreditNote = _objectSpread(_objectSpread({}, _this91.isUnselectingCreditNote), {}, _defineProperty({}, value.id, true));
              _context58.next = 7;
              return _this91.removeCreditNote(value.creditNoteId, value.id);
            case 7:
              _context58.next = 9;
              return _this91.fetchOrder(null, function () {});
            case 9:
              _context58.next = 11;
              return _this91.fetchUsableCreditNotes();
            case 11:
              (_this91$$refs$orderPa = _this91.$refs.orderPaymentList) === null || _this91$$refs$orderPa === void 0 || _this91$$refs$orderPa.updatePayments(_this91.order.payments);
            case 12:
            case "end":
              return _context58.stop();
          }
        }, _callee58);
      }))();
    },
    setMaxAmountToCredit: function setMaxAmountToCredit(item) {
      item.amountToCredit = item.maxAmountToCredit;
      var amountToCredit = this.order.total_amount_currency_include_credit_notes;
      this.usableCreditNotes.forEach(function (x) {
        if (x.amountToCredit && item.id !== x.id) {
          amountToCredit -= parseFloat(x.amountToCredit);
        }
      });
      if (amountToCredit < 0) {
        item.amountToCredit = 0;
      } else if (amountToCredit - item.amountToCredit < 0) {
        item.amountToCredit = amountToCredit;
      }
    },
    changeAmountToCredit: function changeAmountToCredit(item) {
      if (item.amountToCredit > item.remaining.amountCurrency) {
        item.amountToCredit = item.remaining.amountCurrency;
      }
      var amountToCredit = this.order.total_amount_currency_include_credit_notes;
      this.usableCreditNotes.forEach(function (x) {
        if (x.amountToCredit && item.id !== x.id) {
          amountToCredit -= parseFloat(x.amountToCredit);
        }
      });
      if (amountToCredit < 0) {
        item.amountToCredit = 0;
      } else if (amountToCredit - item.amountToCredit < 0) {
        item.amountToCredit = amountToCredit;
      }
    },
    applyCreditNotes: function applyCreditNotes() {
      var _this92 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
        var _this, uses, _this92$$refs$orderPa;
        return _regeneratorRuntime().wrap(function _callee59$(_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              _this92.isLoadingCreditNoteApply = true;
              _this = _this92;
              uses = _this92.usableCreditNotes.filter(function (x) {
                return x.amountToCredit && parseFloat(x.amountToCredit) > 0;
              }).map(function (x) {
                var item = {
                  id: x.id,
                  amountCurrency: parseFloat(x.amountToCredit),
                  orderId: _this.order.id_order,
                  status: creditNoteUse.status.IN_PROGRESS
                };
                return item;
              });
              _context59.prev = 3;
              _context59.next = 6;
              return request("/v1/credit-notes/uses", "post", {
                uses: uses
              }, true, "api").then(function (_) {
                _this.isDocumentsFetched = false;
                _this.order = _objectSpread(_objectSpread({}, _this.order), {}, {
                  isFullyCalculatedAmounts: false,
                  isFullyGeneratedDocuments: false
                });
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 6:
              _context59.next = 8;
              return _this92.fetchOrder(null, function () {});
            case 8:
              (_this92$$refs$orderPa = _this92.$refs.orderPaymentList) === null || _this92$$refs$orderPa === void 0 || _this92$$refs$orderPa.updatePayments(_this92.order.payments);
              _context59.next = 13;
              break;
            case 11:
              _context59.prev = 11;
              _context59.t0 = _context59["catch"](3);
            case 13:
              _this92.fetchUsableCreditNotes();
              _this92.isLoadingCreditNoteApply = false;
            case 15:
            case "end":
              return _context59.stop();
          }
        }, _callee59, null, [[3, 11]]);
      }))();
    },
    removeCreditNote: function removeCreditNote(id, useId) {
      var _this93 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee60() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee60$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              _this = _this93;
              _context60.next = 3;
              return request("/v1/credit-notes/".concat(id, "/uses/").concat(useId), "delete", null, true, "api").then(function (_) {
                _this.isDocumentsFetched = false;
                _this.order = _objectSpread(_objectSpread({}, _this.order), {}, {
                  isFullyCalculatedAmounts: false,
                  isFullyGeneratedDocuments: false
                });
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                _this.isUnselectingCreditNote = _objectSpread(_objectSpread({}, _this.isUnselectingCreditNote), {}, _defineProperty({}, useId, false));
                throw e;
              });
            case 3:
            case "end":
              return _context60.stop();
          }
        }, _callee60);
      }))();
    },
    fetchGeneratedCreditNotes: function fetchGeneratedCreditNotes() {
      var _this94 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee61() {
        var totalShipping, totalShippingCurrency, _this, response;
        return _regeneratorRuntime().wrap(function _callee61$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              _this94.isAvailableItemsForCreditNote = false;
              _this94.creditNoteItems = [];
              totalShipping = 0;
              totalShippingCurrency = 0;
              _this = _this94;
              _context61.next = 7;
              return request("/v1/credit-notes/all", "post", {
                fromOrderId: _this.order.id_order
              }, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load generated credit notes.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 7:
              response = _context61.sent;
              if (response) {
                _this.generatedCreditNotes = response.data.value.items;
                _this.generatedCreditNotes.forEach(function (creditNote) {
                  creditNote.items.forEach(function (i) {
                    if (i.type == _this.creditNoteItem.type.PRODUCT) {
                      var orderItem = _this.order.items.find(function (x) {
                        return x.id_wine == i.wineId;
                      });
                      if (orderItem !== null && orderItem !== void 0 && orderItem.wine) {
                        i.wine = orderItem.wine;
                        i.casingId = orderItem.casingId;
                        i.casingQuantity = orderItem.casingQuantity;
                      }
                    }
                    _this.creditNoteItems.push(_objectSpread({}, i));
                    if (i.type == _this.creditNoteItem.type.SHIPPING) {
                      totalShipping += i.amount;
                      totalShippingCurrency += i.amountCurrency;
                    }
                  });
                });
              }
              _this94.computeWithCreditNoteItems(true);
              if (!_this.isAvailableItemsForCreditNote && _this.order.amount_shipping > 0 && parseFloat(totalShipping.toFixed(2)) < _this.order.amount_shipping && parseFloat(totalShippingCurrency.toFixed(2)) < _this.order.amount_shipping_currency) {
                _this.isAvailableItemsForCreditNote = true;
              }
            case 11:
            case "end":
              return _context61.stop();
          }
        }, _callee61);
      }))();
    },
    computeWithCreditNoteItems: function computeWithCreditNoteItems() {
      var withAvailabilityCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this = this;
      if (_this.creditNoteItems) {
        _this.order.items.map(function (orderItem) {
          orderItem.remaining_quantity = orderItem.quantity;
          var creditNotesItems = _this.creditNoteItems.filter(function (x) {
            return x.orderItemId == orderItem.id_item;
          });
          if (creditNotesItems.length > 0) {
            creditNotesItems.forEach(function (cnItem) {
              orderItem.remaining_quantity -= cnItem.quantity;
            });
          }
          if (withAvailabilityCheck && orderItem.remaining_quantity > 0) {
            _this.isAvailableItemsForCreditNote = true;
          }
          return orderItem;
        });
      }
    },
    openCreditNoteModal: function openCreditNoteModal() {
      var _this95 = this;
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var splitOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.updateCreditNoteId = value;
      this.splitOrder = splitOrder;
      this.creditNoteModalShown = true;
      this.$nextTick(function () {
        _this95.$refs.CreditNoteModal.open();
      });
    },
    closeCreditNoteModal: function closeCreditNoteModal() {
      var _this96 = this;
      this.$nextTick(function () {
        _this96.creditNoteModalShown = false;
        _this96.fetchGeneratedCreditNotes();
      });
    },
    closeAndReloadCreditNoteModal: function closeAndReloadCreditNoteModal() {
      var _this97 = this;
      this.$nextTick(function () {
        _this97.creditNoteModalShown = false;
        _this97.fetchOrderChildren();
        _this97.fetchGeneratedCreditNotes();
        if (_this97.isCreditNoteUsable) {
          _this97.fetchUsableCreditNotes();
        }
        _this97.isDocumentsFetched = false;
      });
    },
    validateAndAutoApplyCreditNote: function validateAndAutoApplyCreditNote() {
      var _this98 = this;
      this.$nextTick(function () {
        _this98.creditNoteModalShown = false;
        _this98.fetchOrderChildren();
        _this98.fetchGeneratedCreditNotes();
        if (_this98.isCreditNoteUsable) {
          _this98.fetchUsableCreditNotes();
        }
        _this98.isDocumentsFetched = false;
        _this98.refetchAndDocs(function () {});
      });
    },
    startEditOrderCurrency: function startEditOrderCurrency() {
      var _this99 = this;
      this.editingOrderCurrency = true;
      this.initialCurrency = this.order.currency;
      this.$nextTick(function (_) {
        _this99.$refs.inputOrderCurrency.focus();
      });
    },
    startEditCustomer: function startEditCustomer() {
      var _this100 = this;
      this.isEditingCustomer = true;
      this.$nextTick(function (_) {
        _this100.$refs.inputCustomer.focus();
      });
    },
    updateOrderCurrency: function updateOrderCurrency() {
      var _this101 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee63() {
        var confirmMessage, _this;
        return _regeneratorRuntime().wrap(function _callee63$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              _this101.isUpdatingOrderCurrency = true;
              confirmMessage = "Are you sure you want to change the currency ?";
              if (_this101.order.credit_notes_amount_currency > 0) {
                confirmMessage += " To your attention, credits will be removed.";
              }
              _this = _this101;
              _this101.$refs.confirm.open("Change currency", confirmMessage, {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee62(confirm) {
                  var _this$updateOrderCurr;
                  return _regeneratorRuntime().wrap(function _callee62$(_context62) {
                    while (1) switch (_context62.prev = _context62.next) {
                      case 0:
                        if (!confirm) {
                          _context62.next = 10;
                          break;
                        }
                        _this101.$EventBus.$emit("loading", true);
                        (_this$updateOrderCurr = _this.updateOrderCurrencyToken) === null || _this$updateOrderCurr === void 0 || _this$updateOrderCurr.cancel();
                        _this.updateOrderCurrencyToken = axios.CancelToken.source();
                        _context62.next = 6;
                        return request("/v1/order/currency", "post", {
                          orderId: _this.order.id_order,
                          currency: _this.order.currency
                        }, true, "api", null, _this.updateOrderCurrencyToken).then(function (_) {
                          _this.isDocumentsFetched = false;
                        }).catch(function (e) {
                          _this.isUpdatingOrderCurrency = false;
                          if (!axios.isCancel(e)) {
                            _this101.$EventBus.$emit("loading", false);
                            var errorData = getErrorData(e, _this.managedExceptions, "Unable to change the currency.", true);
                            handleErrorData(_this, errorData);
                            return;
                          }
                        });
                      case 6:
                        // reload order + logistic cost + credit notes
                        Promise.all([_this.fetchOrder(null, function () {}), _this.fetchOrderLogistic(false, false), _this.fetchUsableCreditNotes(), _this.fetchFactoringProvidersAvailable()]).then(function () {
                          var _this$$refs$orderPaym;
                          (_this$$refs$orderPaym = _this.$refs.orderPaymentList) === null || _this$$refs$orderPaym === void 0 || _this$$refs$orderPaym.updatePayments(_this.order.payments);
                          _this.editingOrderCurrency = false;
                          _this.isUpdatingOrderCurrency = false;
                        });
                        _this101.$EventBus.$emit("loading", false);
                        _context62.next = 13;
                        break;
                      case 10:
                        _this.order.currency = _this.initialCurrency;
                        _this.editingOrderCurrency = false;
                        _this.isUpdatingOrderCurrency = false;
                      case 13:
                      case "end":
                        return _context62.stop();
                    }
                  }, _callee62);
                }));
                return function (_x6) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 5:
            case "end":
              return _context63.stop();
          }
        }, _callee63);
      }))();
    },
    isItemDanger: function isItemDanger(lowestStatusPo) {
      return lowestStatusPo.status === purchaseOrder.status.DRAFT;
    },
    isItemWarning: function isItemWarning(lowestStatusPo, itemQty) {
      return lowestStatusPo.status === purchaseOrder.status.OPEN && lowestStatusPo.receiptStatus === purchaseOrder.receiptStatus.AWAITING || lowestStatusPo.quantity < itemQty;
    },
    isItemSuccess: function isItemSuccess(lowestStatusPo, itemQty) {
      return (lowestStatusPo.status === purchaseOrder.status.OPEN || lowestStatusPo.status === purchaseOrder.status.CLOSED) && lowestStatusPo.receiptStatus === purchaseOrder.receiptStatus.RECEIVED && lowestStatusPo.quantity === itemQty;
    },
    getItemPoStatus: function getItemPoStatus(item) {
      var itemQtyFilled = item.associatedPurchaseOrders.reduce(function (acc, x) {
        return acc + x.quantity;
      }, 0);
      var itemQtyReceived = item.associatedPurchaseOrders.filter(function (x) {
        return x.receiptStatus === purchaseOrder.receiptStatus.RECEIVED;
      }).reduce(function (acc, x) {
        return acc + x.quantity;
      }, 0);
      if (itemQtyFilled < item.quantity || item.associatedPurchaseOrders.some(function (x) {
        return x.status === purchaseOrder.status.DRAFT;
      })) return "danger";
      if (itemQtyReceived >= item.quantity) return "success";
      return "warning";
    },
    goToPurchaseOrder: function goToPurchaseOrder(value) {
      return {
        name: "adminEditPurchaseOrder",
        params: {
          id: value.id
        }
      };
    },
    fetchImportersAvailableForCountry: function fetchImportersAvailableForCountry() {
      var _this102 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee64() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee64$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              _this = _this102;
              data = {
                countryDestination: _this102.order.delivery_address.country.id_country,
                customerTypeDestination: IMPORTER.getimporterCustomerTypeIdFromUserGroup(_this102.order.user.user_group)
              };
              _context64.next = 4;
              return request("/v1/importers/all", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load importers available");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 4:
              response = _context64.sent;
              _this102.importersAvailableForCountry = response.data.value.items;
              _this102.createListImportersForSelector();
              _this102.fetchFactoringProvidersAvailable();
            case 8:
            case "end":
              return _context64.stop();
          }
        }, _callee64);
      }))();
    },
    createListImportersForSelector: function createListImportersForSelector() {
      var _this103 = this,
        _this$order$importer2;
      this.importersForSelector = _toConsumableArray(this.importersAvailableForCountry.filter(function (x) {
        var _this103$order$import;
        return x.id !== ((_this103$order$import = _this103.order.importer) === null || _this103$order$import === void 0 ? void 0 : _this103$order$import.id);
      }));
      if (((_this$order$importer2 = this.order.importer) === null || _this$order$importer2 === void 0 ? void 0 : _this$order$importer2.id) > 0) {
        this.importersForSelector.unshift(this.order.importer);
      }
    },
    startEditImporter: function startEditImporter() {
      var _this104 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee65() {
        return _regeneratorRuntime().wrap(function _callee65$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              _this104.isEditingImporter = true;
              _this104.createListImportersForSelector();
              _this104.importerSelectorSelected = _this104.importersForSelector[0];
            case 3:
            case "end":
              return _context65.stop();
          }
        }, _callee65);
      }))();
    },
    saveChangeImporter: function saveChangeImporter() {
      var _this105 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee66() {
        var _this105$order$import;
        var _this105$changeOrderI, _this106, data, response;
        return _regeneratorRuntime().wrap(function _callee66$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              if (!(((_this105$order$import = _this105.order.importer) === null || _this105$order$import === void 0 ? void 0 : _this105$order$import.id) !== _this105.importerSelectorSelected.id)) {
                _context66.next = 11;
                break;
              }
              (_this105$changeOrderI = _this105.changeOrderImporterCancellationToken) === null || _this105$changeOrderI === void 0 || _this105$changeOrderI.cancel();
              _this105.changeOrderImporterCancellationToken = axios.CancelToken.source();
              _this106 = _this105;
              data = {
                importerId: _this105.importerSelectorSelected.id
              };
              _context66.next = 7;
              return request("/v1/orders/" + +_this105.order.id_order + "/importer", "put", data, true, "api", null, _this105.changeOrderImporterCancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this106.managedExceptions, "Unable to change importer", true);
                  handleErrorData(_this106, errorData);
                  _this106.isEditingImporter = false;
                  throw e;
                }
              });
            case 7:
              response = _context66.sent;
              if (response) {
                _this106.isDocumentsFetched = false;
                _this106.order.isFullyGeneratedDocuments = false;
                _this106.order.importer = _this106.importersForSelector.find(function (x) {
                  return x.id === _this105.importerSelectorSelected.id;
                });
                _this106.isEditingImporter = false;
                _this106.fetchOrder(null, function () {});
              }
              _context66.next = 12;
              break;
            case 11:
              _this105.isEditingImporter = false;
            case 12:
            case "end":
              return _context66.stop();
          }
        }, _callee66);
      }))();
    },
    fetchFactoringProvidersAvailable: function fetchFactoringProvidersAvailable() {
      var _this107 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee67() {
        var _this107$importersAva, _this108, data, response;
        return _regeneratorRuntime().wrap(function _callee67$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              if (!_this107.canManageFactoringProviders) {
                _context67.next = 10;
                break;
              }
              _this108 = _this107;
              data = {
                currency: _this107.order.currency,
                withAvailabilities: true
              };
              if (_this107.order.user.user_group === "USER") {
                data.isIndividual = true;
              } else {
                data.isProfessional = true;
              }
              if (((_this107$importersAva = _this107.importersAvailableForCountry) === null || _this107$importersAva === void 0 ? void 0 : _this107$importersAva.length) > 0) {
                data.includeImporter = true;
              }
              _context67.next = 7;
              return request("/v1/factoring-providers/all", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this108.managedExceptions, "Unable to load financing options available");
                _this108.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 7:
              response = _context67.sent;
              _this107.factoringProvidersAvailable = response.data.value.items;
              _this107.createListFactoringProvidersForSelector();
            case 10:
            case "end":
              return _context67.stop();
          }
        }, _callee67);
      }))();
    },
    createListFactoringProvidersForSelector: function createListFactoringProvidersForSelector() {
      var _this109 = this,
        _this$order$factoring3;
      this.factoringProvidersForSelector = _toConsumableArray(this.factoringProvidersAvailable.filter(function (x) {
        var _this109$order$factor;
        return x.id !== ((_this109$order$factor = _this109.order.factoringProvider) === null || _this109$order$factor === void 0 ? void 0 : _this109$order$factor.id);
      }));
      this.factoringProvidersForSelector.unshift({
        id: null,
        name: "No financing option"
      });
      if (((_this$order$factoring3 = this.order.factoringProvider) === null || _this$order$factoring3 === void 0 ? void 0 : _this$order$factoring3.id) > 0) {
        this.factoringProvidersForSelector.unshift(this.order.factoringProvider);
      }
    },
    startEditFactoringProvider: function startEditFactoringProvider() {
      var _this110 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee68() {
        return _regeneratorRuntime().wrap(function _callee68$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              _this110.isEditingFactoringProvider = true;
              _this110.createListFactoringProvidersForSelector();
              _this110.factoringProviderSelectorSelected = _this110.factoringProvidersForSelector[0];
            case 3:
            case "end":
              return _context68.stop();
          }
        }, _callee68);
      }))();
    },
    saveChangeFactoringProvider: function saveChangeFactoringProvider() {
      var _this111 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee69() {
        var _this111$order$factor;
        var _this111$changeOrderF, _this112, response;
        return _regeneratorRuntime().wrap(function _callee69$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              if (!(((_this111$order$factor = _this111.order.factoringProvider) === null || _this111$order$factor === void 0 ? void 0 : _this111$order$factor.id) !== _this111.factoringProviderSelectorSelected.id)) {
                _context69.next = 10;
                break;
              }
              (_this111$changeOrderF = _this111.changeOrderFactoringProviderCancellationToken) === null || _this111$changeOrderF === void 0 || _this111$changeOrderF.cancel();
              _this111.changeOrderFactoringProviderCancellationToken = axios.CancelToken.source();
              _this112 = _this111;
              _context69.next = 6;
              return request("/v1/order/".concat(_this111.order.id_order, "/factoring-provider"), "put", {
                factoringProviderId: _this111.factoringProviderSelectorSelected.id
              }, true, "api", null, _this111.changeOrderFactoringProviderCancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this112.managedExceptions, "Unable to change financing option", true);
                  handleErrorData(_this112, errorData);
                  _this112.isEditingFactoringProvider = false;
                  throw e;
                }
              });
            case 6:
              response = _context69.sent;
              if (response) {
                _this112.isDocumentsFetched = false;
                _this112.order.isFullyGeneratedDocuments = false;
                _this112.order.factoringProvider = _this112.factoringProvidersForSelector.find(function (x) {
                  return x.id === _this111.factoringProviderSelectorSelected.id;
                });
                _this112.isEditingFactoringProvider = false;
                _this112.fetchOrder(null, function () {});
              }
              _context69.next = 11;
              break;
            case 10:
              _this111.isEditingFactoringProvider = false;
            case 11:
            case "end":
              return _context69.stop();
          }
        }, _callee69);
      }))();
    },
    fetchConsultants: function fetchConsultants() {
      var _this113 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee70() {
        var _this113$handlingCons;
        var data, _this, response;
        return _regeneratorRuntime().wrap(function _callee70$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              _this113.handlingConsultants.getting.isPending = true;
              (_this113$handlingCons = _this113.handlingConsultants.getting.cancellationToken) === null || _this113$handlingCons === void 0 || _this113$handlingCons.cancel();
              _this113.handlingConsultants.getting.cancellationToken = axios.CancelToken.source();
              data = {
                isConsultantOrHolding: true,
                active: true
              };
              _this = _this113;
              _context70.next = 7;
              return request("/v1/users", "post", data, true, "api", null, _this.handlingConsultants.getting.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.handlingConsultants.getting.isPending = false;
                  _this.handlingConsultants.getting.cancellationToken = null;
                  var errorData = getErrorData(e, "Unable to get list of available consultants", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              response = _context70.sent;
              response.data.users.forEach(function (user) {
                _this113.handlingConsultants.getting.results.push({
                  id: user.id_user,
                  full_name: getFullNameUser(user) + " - " + user.delivery_country_iso_code + " - " + user.consultant_code + " (" + user.login + ")"
                });
              });
              _this113.handlingConsultants.getting.results.sort(function (a, b) {
                return a.full_name.localeCompare(b.full_name);
              });
              _this113.handlingConsultants.getting.isPending = false;
            case 11:
            case "end":
              return _context70.stop();
          }
        }, _callee70);
      }))();
    },
    startEditConsultant: function startEditConsultant() {
      var _this$order$consultan2;
      this.handlingConsultants.updating.isConfiguring = true;
      if ((_this$order$consultan2 = this.order.consultant) !== null && _this$order$consultan2 !== void 0 && _this$order$consultan2.id_user) {
        this.handlingConsultants.updating.form = {
          consultantId: this.order.consultant.id_user,
          valid: true
        };
      } else {
        this.handlingConsultants.updating.form = {
          consultantId: null,
          valid: false
        };
      }
    },
    cancelEditConsultant: function cancelEditConsultant() {
      this.handlingConsultants.updating.isConfiguring = false;
      this.handlingConsultants.updating.form = {
        consultantId: null,
        valid: false
      };
    },
    saveChangeConsultant: function saveChangeConsultant() {
      var _this114 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee71() {
        var _this114$handlingCons;
        var _this114$handlingCons2, valid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee71$(_context71) {
          while (1) switch (_context71.prev = _context71.next) {
            case 0:
              _this114.handlingConsultants.updating.isPending = true;
              (_this114$handlingCons = _this114.handlingConsultants.updating.cancellationToken) === null || _this114$handlingCons === void 0 || _this114$handlingCons.cancel();
              _this114.handlingConsultants.updating.cancellationToken = axios.CancelToken.source();
              _this114$handlingCons2 = _this114.handlingConsultants.updating.form, valid = _this114$handlingCons2.valid, withoutValid = _objectWithoutProperties(_this114$handlingCons2, _excluded);
              _this = _this114;
              _context71.next = 7;
              return request("/v1/order/".concat(+_this114.order.id_order, "/consultant"), "put", withoutValid, true, "api", null, _this114.handlingConsultants.updating.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.handlingConsultants.updating.isPending = false;
                  _this.handlingConsultants.updating.cancellationToken = null;
                  var errorData = getErrorData(e, "Unable to change consultant", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              _this114.$toasted.show("Consultant changed", {
                type: "success"
              });
              _this114.cancelEditConsultant();
              _this114.handlingConsultants.updating.isPending = false;
              _this114.fetchOrder();
            case 11:
            case "end":
              return _context71.stop();
          }
        }, _callee71);
      }))();
    },
    fetchInboundWarehouses: function fetchInboundWarehouses() {
      var _this115 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee72() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee72$(_context72) {
          while (1) switch (_context72.prev = _context72.next) {
            case 0:
              _this = _this115;
              _context72.next = 3;
              return request("/v1/warehouses", "post", {
                isInboundCompatible: true,
                excludedIds: [+_this115.order.id_warehouse],
                paging: null
              }, true, "api").then(function (response) {
                _this.inboundWarehouses = response.data.warehouses;
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load warehouses.", true);
                handleErrorData(_this, errorData);
              });
            case 3:
            case "end":
              return _context72.stop();
          }
        }, _callee72);
      }))();
    },
    changeInboundWarehouse: function changeInboundWarehouse(idWarehouse) {
      var _this116 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee73() {
        return _regeneratorRuntime().wrap(function _callee73$(_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              _this116.order.inbound_warehouse_id = idWarehouse;
              if (_this116.order.inbound_warehouse_id) {
                _this116.order.delivery_address = _this116.inboundWarehouses.find(function (x) {
                  return x.id_warehouse == idWarehouse;
                }).address;
              }
            case 2:
            case "end":
              return _context73.stop();
          }
        }, _callee73);
      }))();
    },
    fetchInboundWarehousesWhenItemsUpdated: function fetchInboundWarehousesWhenItemsUpdated(idWarehouse) {
      var _this117 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee74() {
        return _regeneratorRuntime().wrap(function _callee74$(_context74) {
          while (1) switch (_context74.prev = _context74.next) {
            case 0:
              _context74.next = 2;
              return _this117.fetchInboundWarehouses();
            case 2:
              _this117.changeInboundWarehouse(idWarehouse);
              _this117.$refs.inboundWarehouseSelect.updateModel(idWarehouse);
            case 4:
            case "end":
              return _context74.stop();
          }
        }, _callee74);
      }))();
    },
    changeStockTransferWarehouse: function changeStockTransferWarehouse(idWarehouse) {
      var _this118 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee75() {
        return _regeneratorRuntime().wrap(function _callee75$(_context75) {
          while (1) switch (_context75.prev = _context75.next) {
            case 0:
              _this118.order.stockTransferWarehouseId = idWarehouse;
              if (_this118.order.stockTransferWarehouseId) {
                _this118.order.delivery_address = _this118.inboundWarehouses.find(function (x) {
                  return x.id_warehouse == idWarehouse;
                }).address;
              }
            case 2:
            case "end":
              return _context75.stop();
          }
        }, _callee75);
      }))();
    },
    fetchStockTransferWarehousesWhenItemsUpdated: function fetchStockTransferWarehousesWhenItemsUpdated(idWarehouse) {
      var _this119 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee76() {
        return _regeneratorRuntime().wrap(function _callee76$(_context76) {
          while (1) switch (_context76.prev = _context76.next) {
            case 0:
              _context76.next = 2;
              return _this119.fetchInboundWarehouses();
            case 2:
              _this119.changeStockTransferWarehouse(idWarehouse);
              _this119.$refs.stockTransferWarehouseSelect.updateModel(idWarehouse);
            case 4:
            case "end":
              return _context76.stop();
          }
        }, _callee76);
      }))();
    },
    changeDestinationInbound: function changeDestinationInbound() {
      var _this120 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee77() {
        return _regeneratorRuntime().wrap(function _callee77$(_context77) {
          while (1) switch (_context77.prev = _context77.next) {
            case 0:
              _this120.isEditingAddresses = false;
              _this120.isChangingInboundWarehouses = false;
              if (_this120.order.is_destination_inbound) {
                _this120.isChangingInboundWarehouses = true;
                _this120.order.isStockTransfer = false;
                _this120.order.stockTransferWarehouseId = null;
                _this120.order.stockTransferIsPreselling = null;
                _this120.order.stockTransferReservationType = null;
                _this120.order.stockTransferReservationUserId = null;
                _this120.order.stockTransferReservationConsultantId = null;
              } else {
                if (_this120.order.inbound_warehouse_id) {
                  _this120.order.inbound_warehouse_id = null;
                  _this120.saveAddress();
                }
              }
            case 3:
            case "end":
              return _context77.stop();
          }
        }, _callee77);
      }))();
    },
    changeIsStockTransfer: function changeIsStockTransfer() {
      var _this121 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee78() {
        var _this121$order$user;
        return _regeneratorRuntime().wrap(function _callee78$(_context78) {
          while (1) switch (_context78.prev = _context78.next) {
            case 0:
              _this121.isEditingAddresses = false;
              _this121.isChangingStockTransferWarehouses = false;
              if (_this121.order.isStockTransfer) {
                _this121.isChangingStockTransferWarehouses = true;
                _this121.formStockTransfer.stockTransferIsPreselling = true;

                // Preload reservation type
                if (_this121.order.user.isAllowedToDispatchToAnyone) {
                  // if dispatch for all -> default warehouse reservation
                  _this121.formStockTransfer.reservationType = stockReservationTypes.DEFAULT.id;
                } else if ((_this121$order$user = _this121.order.user) !== null && _this121$order$user !== void 0 && _this121$order$user.isHolding) {
                  // if corporate -> reserved for consultant
                  _this121.formStockTransfer.reservationType = stockReservationTypes.SPECIFIC_CONSULTANT.id;
                  _this121.formStockTransfer.reservationConsultantId = _this121.order.user.id_user;
                } else {
                  // if user or horeca -> reserved for specific user
                  _this121.formStockTransfer.reservationType = stockReservationTypes.SPECIFIC_CUSTOMER.id;
                  _this121.formStockTransfer.reservationUserId = _this121.order.user.id_user;
                }
                _this121.order.is_destination_inbound = false;
                _this121.order.inbound_warehouse_id = null;
              } else {
                if (_this121.order.stockTransferWarehouseId) {
                  _this121.order.stockTransferWarehouseId = null;
                  _this121.order.stockTransferIsPreselling = null;
                  _this121.order.stockTransferReservationType = null;
                  _this121.order.stockTransferReservationUserId = null;
                  _this121.order.stockTransferReservationConsultantId = null;
                  _this121.saveAddress();
                }
              }
            case 3:
            case "end":
              return _context78.stop();
          }
        }, _callee78);
      }))();
    },
    openAttachedFilesDrawer: function openAttachedFilesDrawer() {
      this.$refs.OrderAttachedFilesDrawerRef.openDrawer();
    },
    refetchAndGetCharges: function refetchAndGetCharges(ack) {
      var _this122 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee79() {
        return _regeneratorRuntime().wrap(function _callee79$(_context79) {
          while (1) switch (_context79.prev = _context79.next) {
            case 0:
              _context79.next = 2;
              return _this122.fetchOrder(null, ack);
            case 2:
              _this122.isDocumentsFetched = false;
              _this122.fetchOrderLogistic();
            case 4:
            case "end":
              return _context79.stop();
          }
        }, _callee79);
      }))();
    },
    refetchAndDocs: function refetchAndDocs(ack) {
      var _this123 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee80() {
        return _regeneratorRuntime().wrap(function _callee80$(_context80) {
          while (1) switch (_context80.prev = _context80.next) {
            case 0:
              _context80.next = 2;
              return _this123.fetchOrder(null, ack);
            case 2:
              _this123.refetchDocs();
            case 3:
            case "end":
              return _context80.stop();
          }
        }, _callee80);
      }))();
    },
    exportXlsFreight: function exportXlsFreight() {
      var _this124 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee81() {
        var url, fileName, _this, response;
        return _regeneratorRuntime().wrap(function _callee81$(_context81) {
          while (1) switch (_context81.prev = _context81.next) {
            case 0:
              _this124.isExportingXlsFreight = true;
              url = "/v1/order/".concat(_this124.order.id_order, "/xls-freight");
              fileName = "".concat(_this124.order.id_order, "_XLS_FREIGHT.xlsx");
              _this = _this124;
              _context81.next = 6;
              return request(url, "get", null, true, "api", "blob").catch(function (e) {
                _this.isExportingXlsFreight = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to export file");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 6:
              response = _context81.sent;
              fileDownload(response.data, fileName, "application/xlsx");
              _this124.isExportingXlsFreight = false;
            case 9:
            case "end":
              return _context81.stop();
          }
        }, _callee81);
      }))();
    },
    editShippingQuantity: function editShippingQuantity(isCheckbox) {
      var _this125 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee82() {
        var _this125$editShipping;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee82$(_context82) {
          while (1) switch (_context82.prev = _context82.next) {
            case 0:
              data = {};
              if (!isCheckbox) {
                _context82.next = 10;
                break;
              }
              if (!(!_this125.isShippingQuantity && _this125.order.shipping_quantity > 0)) {
                _context82.next = 7;
                break;
              }
              _this125.order.shipping_quantity = null;
              data = {};
              _context82.next = 8;
              break;
            case 7:
              return _context82.abrupt("return");
            case 8:
              _context82.next = 11;
              break;
            case 10:
              data = {
                quantity: _this125.order.shipping_quantity
              };
            case 11:
              _this125.isEditingShippingQuantity = true;
              (_this125$editShipping = _this125.editShippingQuantityToken) === null || _this125$editShipping === void 0 || _this125$editShipping.cancel();
              _this125.editShippingQuantityToken = axios.CancelToken.source();
              _this = _this125;
              _context82.next = 17;
              return request("/v1/order/".concat(_this125.order.id_order, "/shipping-quantity"), "put", data, true, "api", null, _this125.editShippingQuantityToken).catch(function (e) {
                _this.isEditingShippingQuantity = false;
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to edit the shipping quantity.", {
                    type: "error"
                  });
                  throw e;
                }
              });
            case 17:
              _this125.isDocumentsFetched = false;
              _this125.order = _objectSpread(_objectSpread({}, _this125.order), {}, {
                isFullyCalculatedAmounts: false,
                isFullyGeneratedDocuments: false
              });
              _context82.next = 21;
              return _this125.fetchOrderLogistic(true);
            case 21:
              _this125.isEditingShippingQuantity = false;
            case 22:
            case "end":
              return _context82.stop();
          }
        }, _callee82);
      }))();
    },
    orderDetails: function orderDetails(orderId) {
      return {
        name: "adminOrderSummary",
        params: {
          id: orderId
        }
      };
    },
    orderDispatchDetails: function orderDispatchDetails(id) {
      var routeParams = {};
      return {
        name: "adminInboundDeliveryDetails",
        params: {
          id: id,
          routeParams: routeParams
        }
      };
    },
    openSelectInitialOrderDialog: function openSelectInitialOrderDialog() {
      var _this126 = this;
      this.selectInitialOrderDialogShown = true;
      this.$nextTick(function () {
        _this126.$refs.SelectInitialOrderDialog.open();
      });
    },
    closeSelectInitialOrderDialog: function closeSelectInitialOrderDialog(result) {
      this.selectInitialOrderDialogShown = false;
      this.order.initialOrderId = result.initialOrderId;
      this.order.initialOrderReference = result.initialOrderReference;
    },
    generateInvoice: function generateInvoice() {
      var _this127 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee83() {
        var verificationConfirmed, confirm, _this128;
        return _regeneratorRuntime().wrap(function _callee83$(_context83) {
          while (1) switch (_context83.prev = _context83.next) {
            case 0:
              _context83.next = 2;
              return _this127.verifyWarningItemsProvenanceAboutInvoice();
            case 2:
              verificationConfirmed = _context83.sent;
              if (!verificationConfirmed) {
                _context83.next = 16;
                break;
              }
              _context83.next = 6;
              return _this127.$refs.confirm.open("Generate invoice", "You will no longer be able to modify the quantities or the items without going through a credit note", {
                width: 480,
                isHtmlMessage: false
              });
            case 6:
              confirm = _context83.sent;
              if (!confirm) {
                _context83.next = 16;
                break;
              }
              _this127.lastInvoicedOrder = null;
              _this127.isGeneratingInvoice = true;
              _this128 = _this127;
              _context83.next = 13;
              return request("/v1/orders/".concat(_this127.order.id_order, "/invoice"), "put", {}, true, "api", null).catch(function (e) {
                _this128.isGeneratingInvoice = false;
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this128.managedExceptions, "Unable to generate invoice.", true);
                  handleErrorData(_this128, errorData);
                  throw e;
                }
              });
            case 13:
              _context83.next = 15;
              return _this127.refetchAndDocs(function () {});
            case 15:
              _this127.isGeneratingInvoice = false;
            case 16:
            case "end":
              return _context83.stop();
          }
        }, _callee83);
      }))();
    },
    verifyWarningItemsProvenanceAboutInvoice: function verifyWarningItemsProvenanceAboutInvoice() {
      var _this129 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee84() {
        var _this129$itemsProvena, _this129$itemsProvena2, htmlMessage;
        return _regeneratorRuntime().wrap(function _callee84$(_context84) {
          while (1) switch (_context84.prev = _context84.next) {
            case 0:
              if (!_this129.hasWarningItemsProvenanceAboutInvoice) {
                _context84.next = 8;
                break;
              }
              htmlMessage = "";
              if (_this129.order.isPreventInvoice && ((_this129$itemsProvena = _this129.itemsProvenanceNotFromOrder) === null || _this129$itemsProvena === void 0 ? void 0 : _this129$itemsProvena.length) > 0) {
                htmlMessage = "<div>Some items are not linked to a previous invoice, which may result in accounting issues. <br />" + "Please ensure that the order complies with all applicable laws.</div>";
                _this129.itemsProvenanceNotFromOrder.forEach(function (item) {
                  htmlMessage += "<div>- " + "".concat(item.quantity, " b. of ").concat(item.wine.naming_data.sku) + " <span class='text-smaller text-italic'>(" + _this129.wineNaming(_this129.$whitelabel, item.wine.naming_data, true, true) + ")</span>" + "</div>";
                });
              } else if (!_this129.order.isPreventInvoice && ((_this129$itemsProvena2 = _this129.itemsProvenanceFromOrder) === null || _this129$itemsProvena2 === void 0 ? void 0 : _this129$itemsProvena2.length) > 0) {
                htmlMessage = "<div>Some items are already linked to a previous invoice, which may result in accounting issues. <br />" + "Please ensure that the order complies with all applicable laws.</div>";
                _this129.itemsProvenanceFromOrder.forEach(function (item) {
                  htmlMessage += "<div>- " + "".concat(item.quantity, " b. of ").concat(item.wine.naming_data.sku) + " <span class='text-smaller text-italic'>(" + _this129.wineNaming(_this129.$whitelabel, item.wine.naming_data, true, true) + ")</span>" + "</div>";
                });
              }
              _context84.next = 5;
              return _this129.$refs.confirm.open("Potential accountancy issue", htmlMessage, {
                width: 650,
                isHtmlMessage: true
              });
            case 5:
              return _context84.abrupt("return", _context84.sent);
            case 8:
              return _context84.abrupt("return", true);
            case 9:
            case "end":
              return _context84.stop();
          }
        }, _callee84);
      }))();
    },
    confirmCancelInvoice: function confirmCancelInvoice() {
      var _this130 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee85() {
        var confirm;
        return _regeneratorRuntime().wrap(function _callee85$(_context85) {
          while (1) switch (_context85.prev = _context85.next) {
            case 0:
              _context85.next = 2;
              return _this130.$refs.confirm.open("Cancel invoice", "Are you sure you want to cancel this invoice ? Please note that it must be the most recent one generated and should not have been recorded by the accounting team or sent to the customer. The payment state must be not succeeded, or processing.", {
                width: 480,
                isHtmlMessage: false
              });
            case 2:
              confirm = _context85.sent;
              if (confirm) _this130.cancelInvoice();
            case 4:
            case "end":
              return _context85.stop();
          }
        }, _callee85);
      }))();
    },
    cancelInvoice: function cancelInvoice() {
      var _this131 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee86() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee86$(_context86) {
          while (1) switch (_context86.prev = _context86.next) {
            case 0:
              _this131.lastInvoicedOrder = null;
              _this131.isCancellingInvoice = true;
              _this = _this131;
              _context86.next = 5;
              return request("/v1/orders/".concat(_this131.order.id_order, "/invoice"), "delete", null, true, "api", null).catch(function (e) {
                _this.isCancellingInvoice = false;
                if (!axios.isCancel(e)) {
                  var _e$response8;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to cancel invoice.", true);
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  if ((e === null || e === void 0 || (_e$response8 = e.response) === null || _e$response8 === void 0 || (_e$response8 = _e$response8.data) === null || _e$response8 === void 0 || (_e$response8 = _e$response8.value) === null || _e$response8 === void 0 ? void 0 : _e$response8.errorCode) === "cancel_invoice_not_last_invoice") {
                    _this131.getLastInvoicedOrder();
                  }
                  throw e;
                }
              });
            case 5:
              _this131.isCancellingInvoice = false;
              window.location.reload();
            case 7:
            case "end":
              return _context86.stop();
          }
        }, _callee86);
      }))();
    },
    getLastInvoicedOrder: function getLastInvoicedOrder() {
      var _this132 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee87() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee87$(_context87) {
          while (1) switch (_context87.prev = _context87.next) {
            case 0:
              _this132.lastInvoicedOrder = null;
              _this = _this132;
              _context87.next = 4;
              return request("/v1/orders/invoice/last", "get", null, true, "api", null).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to get last invoiced order.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 4:
              response = _context87.sent;
              _this132.lastInvoicedOrder = _objectSpread({}, response.data.value);
            case 6:
            case "end":
              return _context87.stop();
          }
        }, _callee87);
      }))();
    },
    confirmReturnToValidated: function confirmReturnToValidated() {
      var _this133 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee88() {
        var confirm, _this134;
        return _regeneratorRuntime().wrap(function _callee88$(_context88) {
          while (1) switch (_context88.prev = _context88.next) {
            case 0:
              _context88.next = 2;
              return _this133.$refs.confirm.open("Return to validated", "Are you sure you want to return to validated? Be careful not to re-notify the customer when changing status!", {
                width: 480,
                isHtmlMessage: false
              });
            case 2:
              confirm = _context88.sent;
              if (!confirm) {
                _context88.next = 10;
                break;
              }
              _this134 = _this133;
              _this133.isReturningToValidated = true;
              _context88.next = 8;
              return request("/v1/orders/".concat(_this133.order.id_order, "/return-to-validated"), "post", null, true, "api", null).catch(function (e) {
                _this134.isReturningToValidated = false;
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this134.managedExceptions, "Unable to return to validated.", true);
                  _this134.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 8:
              _this133.isReturningToValidated = false;
              window.location.reload();
            case 10:
            case "end":
              return _context88.stop();
          }
        }, _callee88);
      }))();
    },
    fetchCompleteCustomer: function fetchCompleteCustomer() {
      var _this135 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee89() {
        var _this135$customerComp;
        var _this, response, _this135$customerComp2;
        return _regeneratorRuntime().wrap(function _callee89$(_context89) {
          while (1) switch (_context89.prev = _context89.next) {
            case 0:
              _this = _this135;
              _context89.next = 3;
              return request("/v1/user/".concat(_this135.order.id_user), "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Can't get complete customer");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 3:
              response = _context89.sent;
              _this135.customerComplete = _objectSpread({}, response.data);
              if (!!((_this135$customerComp = _this135.customerComplete.consultantAttached) !== null && _this135$customerComp !== void 0 && _this135$customerComp.id_user) && _this135.customerComplete.consultantAttached.id_user > 0) {
                if (_this135.customerComplete.consultantAttached.isHolding && _this135.customerComplete.consultantAttached.id_user != _this135.customerComplete.id_user && _this135.customerComplete.consultantAttached.sponsorship_code != _this135.customerComplete.sponsorship_code && ((_this135$customerComp2 = _this135.customerComplete.consultantAttached.consultantAttached) === null || _this135$customerComp2 === void 0 ? void 0 : _this135$customerComp2.id_user) > 0) {
                  _this135.customerConsultantAttached = _objectSpread({}, _this135.customerComplete.consultantAttached.consultantAttached);
                } else {
                  _this135.customerConsultantAttached = _objectSpread({}, _this135.customerComplete.consultantAttached);
                }
              }
              _this135.customerCompleteLoaded = true;
            case 7:
            case "end":
              return _context89.stop();
          }
        }, _callee89);
      }))();
    },
    fetchCustomerStripeMethods: function fetchCustomerStripeMethods() {
      var _this136 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee90() {
        var response;
        return _regeneratorRuntime().wrap(function _callee90$(_context90) {
          while (1) switch (_context90.prev = _context90.next) {
            case 0:
              if (_this136.customerStripeMethodsLoaded) {
                _context90.next = 5;
                break;
              }
              _context90.next = 3;
              return request("/v1/stripe/orders/".concat(_this136.order.id_order, "/payment-methods"), "get", null, true, "api");
            case 3:
              response = _context90.sent;
              if (response) {
                _this136.customerStripeMethods = _objectSpread({}, response.data);
                _this136.customerHasStripeMethods = _this136.customerStripeMethods.list_credit_cards.length + _this136.customerStripeMethods.list_bank_accounts.length + _this136.customerStripeMethods.list_us_bank_accounts.length > 0;
                _this136.customerStripeMethodsLoaded = true;
              }
            case 5:
            case "end":
              return _context90.stop();
          }
        }, _callee90);
      }))();
    },
    fetchCompleteDepartureWarehouse: function fetchCompleteDepartureWarehouse() {
      var _this137 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee92() {
        var _this137$fetchingComp;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee92$(_context92) {
          while (1) switch (_context92.prev = _context92.next) {
            case 0:
              _this137.fetchingCompleteDepartureWarehouse.isPending = true;
              (_this137$fetchingComp = _this137.fetchingCompleteDepartureWarehouse.cancellationToken) === null || _this137$fetchingComp === void 0 || _this137$fetchingComp.cancel();
              _this137.fetchingCompleteDepartureWarehouse.cancellationToken = axios.CancelToken.source();
              _this = _this137;
              _context92.next = 6;
              return request("/v1/warehouse/".concat(_this137.order.id_warehouse), "get", null, true, "api", null, _this.fetchingCompleteDepartureWarehouse.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee91(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee91$(_context91) {
                    while (1) switch (_context91.prev = _context91.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.fetchingCompleteDepartureWarehouse.isPending = false;
                          _this.fetchingCompleteDepartureWarehouse.cancellationToken = null;
                          errorData = getErrorData(e, _this.managedExceptions, "Unable to get the departure warehouse.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context91.stop();
                    }
                  }, _callee91);
                }));
                return function (_x7) {
                  return _ref9.apply(this, arguments);
                };
              }());
            case 6:
              response = _context92.sent;
              _this137.fetchingCompleteDepartureWarehouse.result = _objectSpread({}, response.data);
              _this137.fetchingCompleteDepartureWarehouse.isPending = false;
              _this137.fetchingCompleteDepartureWarehouse.cancellationToken = null;
            case 10:
            case "end":
              return _context92.stop();
          }
        }, _callee92);
      }))();
    },
    removeConsultant: function removeConsultant() {
      var _this138 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee93() {
        var confirm, _this139;
        return _regeneratorRuntime().wrap(function _callee93$(_context93) {
          while (1) switch (_context93.prev = _context93.next) {
            case 0:
              _context93.next = 2;
              return _this138.$refs.confirm.open("Remove consultant", "Are you sure you want to remove the consultant on this order ?", {
                color: "red"
              });
            case 2:
              confirm = _context93.sent;
              if (!confirm) {
                _context93.next = 9;
                break;
              }
              _this139 = _this138;
              _context93.next = 7;
              return request("/v1/order/".concat(+_this138.order.id_order, "/consultant"), "delete", null, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this139.managedExceptions, "Unable to remove consultant");
                _this139.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 7:
              _this138.$toasted.show("Consultant removed", {
                type: "success"
              });
              _this138.fetchOrder();
            case 9:
            case "end":
              return _context93.stop();
          }
        }, _callee93);
      }))();
    },
    changeConsultant: function changeConsultant() {
      var _this140 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee94() {
        var confirm, _this141, data;
        return _regeneratorRuntime().wrap(function _callee94$(_context94) {
          while (1) switch (_context94.prev = _context94.next) {
            case 0:
              _context94.next = 2;
              return _this140.$refs.confirm.open("Change consultant", "Are you sure you want to change the consultant on this order ?", {
                color: "red"
              });
            case 2:
              confirm = _context94.sent;
              if (!confirm) {
                _context94.next = 10;
                break;
              }
              _this141 = _this140;
              data = {
                consultantId: _this141.customerConsultantAttached.id_user
              };
              _context94.next = 8;
              return request("/v1/order/".concat(+_this140.order.id_order, "/consultant"), "put", data, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this141.managedExceptions, "Unable to change consultant");
                _this141.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 8:
              _this140.$toasted.show("Consultant changed", {
                type: "success"
              });
              _this140.fetchOrder();
            case 10:
            case "end":
              return _context94.stop();
          }
        }, _callee94);
      }))();
    },
    updateOrderWhenPaymentUpdated: function updateOrderWhenPaymentUpdated(payments) {
      this.order.payments = _toConsumableArray(payments);
      this.isDocumentsFetched = false;
      this.order.isFullyGeneratedDocuments = false;
    },
    openAccountancyReconciliation: function openAccountancyReconciliation() {
      var _this142 = this;
      this.accountancyReconciliationDialogShown = true;
      this.$nextTick(function () {
        _this142.$refs.AccountancyOrderReconciliationDialog.open();
      });
    },
    closeAccountancyReconciliation: function closeAccountancyReconciliation() {
      this.accountancyReconciliationDialogShown = false;
    },
    getInvoicePaymentReconciliations: function getInvoicePaymentReconciliations() {
      var _this143 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee95() {
        var _this144, response;
        return _regeneratorRuntime().wrap(function _callee95$(_context95) {
          while (1) switch (_context95.prev = _context95.next) {
            case 0:
              if (!(_this143.canManageAccountancy && _this143.isInvoiced)) {
                _context95.next = 7;
                break;
              }
              _this144 = _this143;
              _context95.next = 4;
              return request("/v1/accountancy/oc-ec-item-associations/ec-order/".concat(_this143.baseModel.id_order, "/payment-reconciliations"), "get", null, true, "api").catch(function (e) {
                _this144.$toasted.show("Unable to load payment reconciliations", {
                  type: "warning"
                });
                throw e;
              });
            case 4:
              response = _context95.sent;
              _this143.accountancyReconciliationPayments.payments = _toConsumableArray(response.data.value.fromOcOrders);
              _this143.accountancyReconciliationPayments.paymentsFromOldStockTransfers = _toConsumableArray(response.data.value.fromOldStockTransfers);
            case 7:
            case "end":
              return _context95.stop();
          }
        }, _callee95);
      }))();
    },
    openAccountancyEcReconciliation: function openAccountancyEcReconciliation() {
      var _this145 = this;
      this.accountancyEcReconciliationDialogShown = true;
      this.$nextTick(function () {
        _this145.$refs.AccountancyEcReconciliationDialog.open();
      });
    },
    closeAccountancyEcReconciliation: function closeAccountancyEcReconciliation() {
      this.accountancyEcReconciliationDialogShown = false;
    },
    accountancyEcReconciliationUpdated: function accountancyEcReconciliationUpdated() {
      this.getInvoicePaymentReconciliations();
    },
    callBackAfterMerge: function callBackAfterMerge(orderIdDestination, ack) {
      var _this146 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee96() {
        var route;
        return _regeneratorRuntime().wrap(function _callee96$(_context96) {
          while (1) switch (_context96.prev = _context96.next) {
            case 0:
              _context96.next = 2;
              return _this146.fetchOrder(null, ack);
            case 2:
              if (_this146.isCancelled) {
                route = _this146.orderDetails(orderIdDestination);
                _this146.$router.replace(route);
                window.location.reload();
              } else {
                _this146.fetchOrderLogistic();
              }
            case 3:
            case "end":
              return _context96.stop();
          }
        }, _callee96);
      }))();
    },
    getAvailablePricePostings: function getAvailablePricePostings() {
      var _this147 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee97() {
        var _this147$order;
        var _this148, response, noOne;
        return _regeneratorRuntime().wrap(function _callee97$(_context97) {
          while (1) switch (_context97.prev = _context97.next) {
            case 0:
              if (!(_this147.canBePricePostingUsaProSubmitted || ((_this147$order = _this147.order) === null || _this147$order === void 0 || (_this147$order = _this147$order.pricePostingUsaPro) === null || _this147$order === void 0 ? void 0 : _this147$order.id) > 0)) {
                _context97.next = 7;
                break;
              }
              _this148 = _this147;
              _context97.next = 4;
              return request("/v1/price-posting/usable", "get", null, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this148.managedExceptions, "Unable to get available price postings");
                _this148.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 4:
              response = _context97.sent;
              noOne = {
                id: null,
                applicationDateString: "No one"
              };
              _this147.pricePosting.availableItems = [noOne].concat(_toConsumableArray(response.data.value.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  applicationDateString: new Date(x.applicationDate).formatStringMonth() + (x.status == pricePostingStatusList.DRAFT.id ? " (draft)" : "")
                });
              })));
            case 7:
            case "end":
              return _context97.stop();
          }
        }, _callee97);
      }))();
    },
    cancelChangePricePosting: function cancelChangePricePosting() {
      var _this$order$pricePost2, _this$order$pricePost3;
      this.pricePosting.idUsed = (_this$order$pricePost2 = (_this$order$pricePost3 = this.order.pricePostingUsaPro) === null || _this$order$pricePost3 === void 0 ? void 0 : _this$order$pricePost3.id) !== null && _this$order$pricePost2 !== void 0 ? _this$order$pricePost2 : null;
      this.pricePosting.isReselecting = false;
    },
    confirmChangePricePosting: function confirmChangePricePosting() {
      var _this149 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee98() {
        var confirm;
        return _regeneratorRuntime().wrap(function _callee98$(_context98) {
          while (1) switch (_context98.prev = _context98.next) {
            case 0:
              _context98.next = 2;
              return _this149.$refs.confirm.open("Change price posting", "Shipping and items prices will be reset to default prices according to price posting declaration, or present price." + " Expedition method can be removed, and must be reselected." + " Are you sure you want to change the price posting declaration used for this order ?", {
                color: "red",
                width: 650
              });
            case 2:
              confirm = _context98.sent;
              if (!confirm) {
                _context98.next = 6;
                break;
              }
              _context98.next = 6;
              return _this149.changePricePosting();
            case 6:
            case "end":
              return _context98.stop();
          }
        }, _callee98);
      }))();
    },
    confirmSyncPricePosting: function confirmSyncPricePosting() {
      var _this150 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee99() {
        var confirm;
        return _regeneratorRuntime().wrap(function _callee99$(_context99) {
          while (1) switch (_context99.prev = _context99.next) {
            case 0:
              _context99.next = 2;
              return _this150.$refs.confirm.open("Sync prices with database prices", "Shipping and items prices will be reset to default prices according to price posting declaration." + " Expedition method can be removed, and must be reselected." + " Are you sure you want to sync the prices for this order ?", {
                color: "red",
                width: 650
              });
            case 2:
              confirm = _context99.sent;
              if (!confirm) {
                _context99.next = 6;
                break;
              }
              _context99.next = 6;
              return _this150.changePricePosting();
            case 6:
            case "end":
              return _context99.stop();
          }
        }, _callee99);
      }))();
    },
    changePricePosting: function changePricePosting() {
      var _this151 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee100() {
        var _this, data;
        return _regeneratorRuntime().wrap(function _callee100$(_context100) {
          while (1) switch (_context100.prev = _context100.next) {
            case 0:
              _this151.$EventBus.$emit("loading", true);
              _this151.pricePosting.isUpdating = true;
              _this = _this151;
              data = {
                pricePostingUsaProId: _this151.pricePosting.idUsed
              };
              _context100.next = 6;
              return request("/v1/orders/".concat(+_this151.order.id_order, "/price-posting"), "put", data, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to change price posting", true);
                handleErrorData(_this, errorData);
                _this.pricePosting.isUpdating = false;
                _this.$EventBus.$emit("loading", false);
                throw e;
              });
            case 6:
              _context100.next = 8;
              return _this151.refetchAndGetCharges(function () {});
            case 8:
              _this151.$toasted.show("Price posting changed", {
                type: "success"
              });
              _this151.pricePosting.isUpdating = false;
              _this151.pricePosting.isReselecting = false;
              _this151.$EventBus.$emit("loading", false);
            case 12:
            case "end":
              return _context100.stop();
          }
        }, _callee100);
      }))();
    },
    getPricePostingErrorMessage: function getPricePostingErrorMessage(item) {
      var _this$order$pricePost4, _item$wine$pricesPost;
      if (!((_this$order$pricePost4 = this.order.pricePostingUsaPro) !== null && _this$order$pricePost4 !== void 0 && _this$order$pricePost4.id)) return null;
      if (!item.wine.pricesPosted) return "This wine seems to be NOT price-posted";
      var postedUsdPricePerBottle = item.wine.pricesPosted.priceUsdPerBottle;
      var postedUsdPricePerBottleShippingIncluded = item.wine.pricesPosted.priceUsdDefaultShippingIncludedPerBottle;
      if (((_item$wine$pricesPost = item.wine.pricesPosted.conditionalDiscounts) === null || _item$wine$pricesPost === void 0 ? void 0 : _item$wine$pricesPost.length) > 0) {
        var filteredDiscounts = item.wine.pricesPosted.conditionalDiscounts.filter(function (x) {
          return x.bottleThreshold <= item.quantity;
        });
        if ((filteredDiscounts === null || filteredDiscounts === void 0 ? void 0 : filteredDiscounts.length) > 0) {
          var discountPosted = filteredDiscounts.reduce(function (max, current) {
            return max.bottleThreshold > current.bottleThreshold ? max : current;
          });
          postedUsdPricePerBottle = discountPosted.priceUsdPerBottle;
          postedUsdPricePerBottleShippingIncluded = discountPosted.priceUsdDefaultShippingIncludedPerBottle;
        }
      }
      if (postedUsdPricePerBottle !== item.unit_price_currency) return "This wine seems to be price-posted at ".concat(formatPrice(postedUsdPricePerBottleShippingIncluded), "$/btl def.ship.inc, for this quantity");
      return null;
    },
    getPricePostingWarningMessage: function getPricePostingWarningMessage(item) {
      var _item$wine$pricesPost2;
      var actualCogsEuro = item.wine.cogs_euro_ex_vat;
      var postedCogsEuro = (_item$wine$pricesPost2 = item.wine.pricesPosted) === null || _item$wine$pricesPost2 === void 0 ? void 0 : _item$wine$pricesPost2.cogsEuro;
      if (!!postedCogsEuro && postedCogsEuro < actualCogsEuro) return "This wine has been price-posted according to ".concat(formatPrice(postedCogsEuro), "\u20AC cogs, and it's now ").concat(formatPrice(actualCogsEuro), "\u20AC cogs.");
      return null;
    },
    startEditConsultantCommission: function startEditConsultantCommission() {
      this.isEditingConsultantCommission = true;
      this.isNewConsultantCommissionTypePercentage = this.order.customConsultantCommission > 0;
      this.newConsultantCommissionPercentage = this.order.customConsultantCommission;
      this.newConsultantCommissionAmountCurrency = this.order.amountConsultantCommissionCurrency;
    },
    saveConsultantCommission: function saveConsultantCommission() {
      var _this152 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee101() {
        var _this, data;
        return _regeneratorRuntime().wrap(function _callee101$(_context101) {
          while (1) switch (_context101.prev = _context101.next) {
            case 0:
              _this152.isSavingConsultantCommission = true;
              _this = _this152;
              data = _this152.isNewConsultantCommissionTypePercentage ? {
                percentage: _this152.newConsultantCommissionPercentage
              } : {
                amountCurrency: _this152.newConsultantCommissionAmountCurrency
              };
              _context101.next = 5;
              return request("/v1/orders/".concat(_this152.order.id_order, "/consultant-commission"), "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to change consultant commission");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                _this.isSavingConsultantCommission = false;
                throw e;
              });
            case 5:
              _this152.isFullyCalculatedAmounts = false;
              _this152.isSavingConsultantCommission = false;
              _this152.isEditingConsultantCommission = false;
              _this152.fetchOrder(null, function () {});
            case 9:
            case "end":
              return _context101.stop();
          }
        }, _callee101);
      }))();
    },
    openOrderCustomsInvoiceDialog: function openOrderCustomsInvoiceDialog() {
      var _this153 = this;
      this.orderCustomsInvoiceDialogShown = true;
      this.$nextTick(function () {
        _this153.$refs.orderCustomsInvoiceDialog.open();
      });
    },
    closeOrderCustomsInvoiceDialog: function closeOrderCustomsInvoiceDialog() {
      this.orderCustomsInvoiceDialogShown = false;
    },
    confirmOrderCustomsInvoiceDialog: function confirmOrderCustomsInvoiceDialog() {
      this.orderCustomsInvoiceDialogShown = false;
      this.isDocumentsFetched = false;
      this.order.isFullyGeneratedDocuments = false;
      this.documentDialog = false;
    },
    getRequiredTastingPhotos: function getRequiredTastingPhotos() {
      var _this154 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee102() {
        var _this154$order;
        var _this154$order2, _this155, formSearch, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee102$(_context102) {
          while (1) switch (_context102.prev = _context102.next) {
            case 0:
              if (!(_this154.tastingPhotos.canManage && _this154.isDelivered && (_this154$order = _this154.order) !== null && _this154$order !== void 0 && _this154$order.hasTastingPhotoRequired)) {
                _context102.next = 11;
                break;
              }
              _this154.tastingPhotos.required.isSearchPending = true;
              _this154.tastingPhotos.required.items = [];
              _this155 = _this154;
              formSearch = {
                orderIds: [(_this154$order2 = _this154.order) === null || _this154$order2 === void 0 ? void 0 : _this154$order2.id_order],
                allowedStatus: [TASTING_PHOTOS.REQUIRED.STATUS.TO_TAKE.id, TASTING_PHOTOS.REQUIRED.STATUS.PARTIALLY_TAKEN.id]
              };
              paramsQuery = Object.encodeToUri(formSearch);
              _context102.next = 8;
              return request("/v1/tasting-photos/required?params=".concat(paramsQuery), "get", null, true, "api").catch(function (e) {
                _this155.tastingPhotos.required.isSearchPending = false;
                _this155.$toasted.show("Unable to load required photos.", {
                  type: "error"
                });
                throw e;
              });
            case 8:
              response = _context102.sent;
              _this154.tastingPhotos.required.items = _toConsumableArray(response.data.value);
              _this154.tastingPhotos.required.isSearchPending = false;
            case 11:
            case "end":
              return _context102.stop();
          }
        }, _callee102);
      }))();
    },
    openTastingPhotoUploader: function openTastingPhotoUploader(tastingPhotoRequiredId) {
      var _this156 = this;
      this.tastingPhotos.upload.tastingPhotoRequiredId = tastingPhotoRequiredId;
      this.tastingPhotos.upload.isComponentCreated = true;
      this.$nextTick(function () {
        _this156.$refs.tastingPhotoUploadForm.open();
      });
    },
    closeTastingPhotoUploader: function closeTastingPhotoUploader() {
      var _this157 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee103() {
        return _regeneratorRuntime().wrap(function _callee103$(_context103) {
          while (1) switch (_context103.prev = _context103.next) {
            case 0:
              _this157.tastingPhotos.upload.isComponentCreated = false;
              _this157.getRequiredTastingPhotos();
            case 2:
            case "end":
              return _context103.stop();
          }
        }, _callee103);
      }))();
    },
    startEditAccountancyCode: function startEditAccountancyCode() {
      this.editingAccountancyCode.form.accountancyCode = this.order.accountancyCode;
      this.editingAccountancyCode.isConfiguring = true;
    },
    copyImporterAccountancyCode: function copyImporterAccountancyCode() {
      var _this$order$importer3;
      this.editingAccountancyCode.form.accountancyCode = (_this$order$importer3 = this.order.importer) === null || _this$order$importer3 === void 0 ? void 0 : _this$order$importer3.accountingExternalId;
    },
    copyCustomerAccountancyCode: function copyCustomerAccountancyCode() {
      var _this$order$user2;
      this.editingAccountancyCode.form.accountancyCode = (_this$order$user2 = this.order.user) === null || _this$order$user2 === void 0 ? void 0 : _this$order$user2.accountingExternalId;
    },
    saveAccountancyCode: function saveAccountancyCode() {
      var _this158 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee105() {
        var _this158$editingAccou;
        var _this, data;
        return _regeneratorRuntime().wrap(function _callee105$(_context105) {
          while (1) switch (_context105.prev = _context105.next) {
            case 0:
              _this158.editingAccountancyCode.isPending = true;
              (_this158$editingAccou = _this158.editingAccountancyCode.cancellationToken) === null || _this158$editingAccou === void 0 || _this158$editingAccou.cancel();
              _this158.editingAccountancyCode.cancellationToken = axios.CancelToken.source();
              _this = _this158;
              data = _objectSpread({}, _this158.editingAccountancyCode.form);
              _context105.next = 7;
              return request("/v1/orders/".concat(_this158.order.id_order, "/accountancy-code"), "put", data, true, "api", null, _this.editingAccountancyCode.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee104(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee104$(_context104) {
                    while (1) switch (_context104.prev = _context104.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.editingAccountancyCode.isPending = false;
                          _this.editingAccountancyCode.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to save accountancy code.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context104.stop();
                    }
                  }, _callee104);
                }));
                return function (_x8) {
                  return _ref10.apply(this, arguments);
                };
              }());
            case 7:
              _this158.editingAccountancyCode.isPending = false;
              _this158.editingAccountancyCode.cancellationToken = null;
              _this158.order.accountancyCode = _this158.editingAccountancyCode.form.accountancyCode.trim().toUpperCase();
              _this158.editingAccountancyCode.isConfiguring = false;
            case 11:
            case "end":
              return _context105.stop();
          }
        }, _callee105);
      }))();
    },
    getFromOrderDataErrorMessage: function getFromOrderDataErrorMessage(item) {
      var _item$item_provenance,
        _this159 = this;
      var itemProvenances = item === null || item === void 0 || (_item$item_provenance = item.item_provenances) === null || _item$item_provenance === void 0 ? void 0 : _item$item_provenance.filter(function (x) {
        return x.stockPart.fromOrderData != null;
      });
      if ((itemProvenances === null || itemProvenances === void 0 ? void 0 : itemProvenances.length) > 0) {
        var discrepedencies = [];
        itemProvenances.forEach(function (ip) {
          var fromOrderData = ip.stockPart.fromOrderData;
          var itemPriceUsedForComparison = fromOrderData.sellUnitDefaultShippingIncludedCurrencyInclVat === null ? item.unit_price_currency : item.unitPriceIncludeDefaultShippingCurrency;
          var fromOrderPriceForComparison = fromOrderData.sellUnitPriceIncludeDefaultShippingCurrencyInclVat;
          if ((fromOrderData === null || fromOrderData === void 0 ? void 0 : fromOrderData.id) > 0) {
            if (fromOrderPriceForComparison != itemPriceUsedForComparison) {
              var _fromOrderData$invoic;
              var discrepedency = {
                quantity: ip.quantity,
                order: ((_fromOrderData$invoic = fromOrderData.invoiceNumberLabel) === null || _fromOrderData$invoic === void 0 ? void 0 : _fromOrderData$invoic.length) > 0 ? fromOrderData.invoiceNumberLabel : fromOrderData.referenceOrder.shorterReference(),
                soldPrice: "".concat(formatPrice(fromOrderPriceForComparison)).concat(_this159.getSymbolCurrency(fromOrderData.sellCurrency)).concat(fromOrderData.sellUnitDefaultShippingIncludedCurrencyInclVat === null ? " (ex shipping)" : "")
              };
              discrepedencies.push(discrepedency);
            }
          }
        });
        if (discrepedencies.length > 0) {
          var message = "This product has ";
          discrepedencies.forEach(function (x, i) {
            if (i > 0) message += ", ";
            message += "".concat(x.quantity, "b. from ").concat(x.order, " sold at ").concat(x.soldPrice, " per bottle");
          });
          return message;
        }
      }
      return null;
    },
    getItemCnQuantity: function getItemCnQuantity(itemId) {
      var _this$creditNoteItems, _cnItems$reduce;
      var cnItems = (_this$creditNoteItems = this.creditNoteItems) === null || _this$creditNoteItems === void 0 ? void 0 : _this$creditNoteItems.filter(function (x) {
        return x.orderItemId === itemId;
      });
      return (_cnItems$reduce = cnItems === null || cnItems === void 0 ? void 0 : cnItems.reduce(function (acc, x) {
        return acc + x.quantity;
      }, 0)) !== null && _cnItems$reduce !== void 0 ? _cnItems$reduce : 0;
    },
    getItemCnMessage: function getItemCnMessage(itemId) {
      var quantity = this.getItemCnQuantity(itemId);
      if (quantity > 0) {
        return "".concat(quantity, " bottle").concat(quantity > 0 && "s", " included in a credit note");
      } else {
        return null;
      }
    },
    consultantCommissionPaid: function consultantCommissionPaid(form) {
      this.order.isConsultantCommissionPaid = true;
      this.order.dateConsultantCommissionPaid = form.paymentDate;
    },
    consultantCommissionNotPaid: function consultantCommissionNotPaid() {
      this.order.isConsultantCommissionPaid = false;
      this.order.dateConsultantCommissionPaid = null;
    },
    isShippingOutOfRange: function isShippingOutOfRange() {
      var _this$expedition_meth2;
      return ((_this$expedition_meth2 = this.expedition_methods) === null || _this$expedition_meth2 === void 0 ? void 0 : _this$expedition_meth2.length) === 1 && this.expedition_methods[0].isOutOfRange;
    },
    getShippingOutOfRangeMessage: function getShippingOutOfRangeMessage() {
      var nbVariation = this.expedition_methods[0].outOfRangeVariation;
      if (nbVariation > 0) {
        return "This volume should not get an available shipping method. You should add ".concat(nbVariation, " regular bottle").concat(nbVariation > 1 && "s");
      } else {
        return "This volume should not get an available shipping method. You should remove ".concat(nbVariation, " regular bottle").concat(nbVariation > 1 && "s");
      }
    },
    isShippingInError: function isShippingInError() {
      var _this$expedition_meth3;
      return ((_this$expedition_meth3 = this.expedition_methods) === null || _this$expedition_meth3 === void 0 ? void 0 : _this$expedition_meth3.length) === 1 && this.expedition_methods[0].isError;
    },
    getShippingHtmlOverview: function getShippingHtmlOverview() {
      var _this$order$expeditio3,
        _this160 = this;
      var isForceShowShippingType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var html = "";

      //Commande terminée
      if (!this.isShippingEditable && !this.isCancelled) {
        var currencySymbol = this.getSymbolCurrency(this.order.currency);
        var nbBottles = this.nbBottles;
        var totalAmountCurrencyCreditNoteShipping = this.totalAmountCurrencyCreditNoteShipping || 0;
        html += "\n          <div>Shipping type : ".concat(this.order.shipmentLabel, "</div>\n        ");
        if (this.order.amount_shipping_currency > 0) {
          if (this.order.amountShippingNotIncludedInItemsCurrency !== 0) {
            if (this.hasBeenPricePostedWithProperShippingFees) {
              html += "\n                <div>\n                  PricePost Shipping fees\n                  <span>:\n                    ".concat(this.order.nbRegularBottlesForShipping, " x\n                    ").concat(this.formatPrice(this.order.amountShippingNotIncludedInItemsCurrency / this.order.nbRegularBottlesForShipping), " ").concat(currencySymbol, "\n                  </span>\n                  <span>\n                    = ").concat(this.formatPrice(this.order.amountShippingNotIncludedInItemsCurrency), " ").concat(currencySymbol, "\n                  </span>\n                </div>\n              ");
            } else {
              var label = this.order.amountShippingNotIncludedInItemsCurrency > 0 ? "Shipping fee" : "Shipping bonus";
              html += "\n                <div>\n                  ".concat(label, "\n                  <span> +\n                    ").concat(this.formatPrice(this.order.amountShippingNotIncludedInItemsCurrency / nbBottles), " ").concat(currencySymbol, " / bottle\n                  </span>\n                  <span>\n                    : ").concat(this.formatPrice(this.order.amountShippingNotIncludedInItemsCurrency), " ").concat(currencySymbol, "\n                  </span>\n                </div>\n              ");
            }
          } else {
            html += "<div>Shipping included</div>";
          }
          html += "\n            <div class=\"text-smaller\">\n          ";
          if (this.hasBeenPricePostedWithProperShippingFees) {
            html += "\n              <div>\n                Complete final logistic :\n                ".concat(this.formatPrice(this.order.amount_shipping_currency - totalAmountCurrencyCreditNoteShipping || 0), " ").concat(currencySymbol, "\n              </div>\n            ");
          } else {
            html += "\n              <div>\n                Complete final logistic \u2243\n                ".concat(this.formatPrice(this.order.amount_shipping_currency / nbBottles), " ").concat(currencySymbol, " / bottle\n                <span> :\n                  ").concat(this.formatPrice(this.order.amount_shipping_currency - totalAmountCurrencyCreditNoteShipping || 0), " ").concat(currencySymbol, "\n                </span>\n              </div>\n            ");
          }
          html += "</div>";
          if (!this.hasBeenPricePostedWithProperShippingFees) {
            html += "\n              <div class=\"text-smaller\">\n                <div>".concat(this.nbRegularBottlesIncludingCreditNote, " regular bottles</div>\n                ").concat(this.isCustomerHorecaUs ? "<div class=\"text-smaller text-italic\">\n                      Need to declare the express shipping fees on HAL invoices\n                    </div>" : "", "\n              </div>\n            ");
          }
        }
        return html;
      }

      //Store at the cellar
      if (!this.isShippingEditable && this.order.expedition_method === this.expeditionMethods.CELLAR_STORAGE.id) {
        html += "\n          <span class=\"free-storage-text\">Free storage for 3 months.</span><br/>\n          A notification asking to collect the goods will be sent every month\n          <strong>for 2 months</strong>, then every week <strong>for the last month.</strong>\n        ";
        return html;
      }

      //En cours
      if (this.order.expedition_method > 0 && !this.isShippingInBlockingError && !this.isAwaitingLogisticDetail && this.isShippingEditable && this.order.expedition_method !== this.expeditionMethods.CELLAR_STORAGE.id && ((_this$order$expeditio3 = this.order.expedition_methods[this.order.id_warehouse]) === null || _this$order$expeditio3 === void 0 ? void 0 : _this$order$expeditio3.id) !== this.expeditionMethods.CELLAR_STORAGE.id) {
        var expedition = this.order.expedition_methods[this.order.id_warehouse];
        var _nbBottles = this.nbBottles;
        var nbRegularBottles = this.nbRegularBottles;
        var _currencySymbol = this.getSymbolCurrency(this.order.currency);

        // Prix par bouteille
        var pricePerBottle = expedition ? this.formatPrice(expedition.price_numeric_currency / this.order.items.reduce(function (acc, x) {
          return acc + x.quantity;
        }, 0)) : this.formatPrice(this.order.amount_shipping_currency / _nbBottles);

        // Montant total
        var totalShipping = this.formatPrice(this.order.amount_shipping_currency || 0);
        if (isForceShowShippingType) {
          var _Object$values$find;
          var shippingType = (_Object$values$find = Object.values(expeditionMethods).find(function (x) {
            return x.id === _this160.order.expedition_method;
          })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.text;
          html += "\n          <div class=\"text-right\">Shipping type : ".concat(shippingType, "</div>\n        ");
        }
        html += "\n          <div class=\"text-right\">\n            <div>\n              Complete logistic \u2243\n              <span>".concat(pricePerBottle, " ").concat(_currencySymbol, " / bottle</span>\n              <span>: ").concat(totalShipping, " ").concat(_currencySymbol, "</span>\n            </div>\n            <div class=\"text-smaller\">\n        ");

        // Sous-bloc bouteilles
        if (this.hasBeenPricePostedWithProperShippingFees) {
          html += "\n            <div>\n              ".concat(this.nbRegularBottlesForShippingIncludingCreditNote, " regular bottles,\n              for declaring the express shipping fees on HAL invoices\n            </div>\n          ");
        } else {
          html += "\n            <div>\n              ".concat(_nbBottles, " bottles\n              ").concat(nbRegularBottles !== _nbBottles ? "<span class=\"ml-2 text-italic\">(".concat(nbRegularBottles, " regular bottles)</span>") : "", "\n            </div>\n          ");
          if (this.isCustomerHorecaUs && nbRegularBottles !== _nbBottles) {
            html += "\n              <div class=\"text-smaller text-italic\">\n                Needed for declaring the express shipping fees on HAL invoices\n              </div>\n            ";
          }
        }
        html += "</div>"; // ferme text-smaller

        // Frais facturés
        if (this.isOrderFullyCalculatedAmounts && this.orderShippingAmountCurrencyToPay !== 0) {
          html += "\n            <div>\n              Shipping fee charged :\n              ".concat(this.formatPrice(this.orderShippingAmountCurrencyToPay), " ").concat(_currencySymbol, "\n            </div>\n          ");
        }
        html += "</div>"; // ferme text-right
      }
      return html;
    },
    openChangeDepartureWarehouse: function openChangeDepartureWarehouse() {
      var _this161 = this;
      this.departureWarehouseChangeDialogShown = true;
      this.$nextTick(function () {
        _this161.$refs.departureWarehouseChangeDialog.open();
      });
    },
    closeChangeDepartureWarehouse: function closeChangeDepartureWarehouse(hasBeenChanged) {
      this.departureWarehouseChangeDialogShown = false;
      if (hasBeenChanged) {
        this.refetchAndDocs();
      }
    },
    openPricesPostingHistoryModal: function openPricesPostingHistoryModal(item) {
      var _this162 = this;
      this.pricePostingDetails.wine = _objectSpread({}, item.wine);
      this.$nextTick(function () {
        _this162.$refs.pricePostingWineConditionalDiscountHistoryRef.open();
      });
    },
    openSupplierPrices: function openSupplierPrices(idWine) {
      var _this163 = this;
      this.selectedIdWineSupplierForPriceModal = idWine;
      this.isWineSupplierPriceModalShown = true;
      this.$nextTick(function () {
        _this163.$refs.wineSupplierPriceModal.open();
      });
    },
    closeSupplierPrices: function closeSupplierPrices(wine) {
      this.selectedIdWineSupplierForPriceModal = null;
      this.isWineSupplierPriceModalShown = false;
      this.updateItemSupplierPrices(wine);
    },
    updateItemSupplierPrices: function updateItemSupplierPrices(prices) {
      var _this164 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee106() {
        return _regeneratorRuntime().wrap(function _callee106$(_context106) {
          while (1) switch (_context106.prev = _context106.next) {
            case 0:
              _this164.order.items.forEach(function (item) {
                if (item.wine.id_wine === prices.wineId) {
                  item.suppliersPricesList = prices.items;
                }
              });
            case 1:
            case "end":
              return _context106.stop();
          }
        }, _callee106);
      }))();
    },
    getOrderConfirmationReference: getOrderConfirmationReference,
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice,
    getFullNameUserHtml: getFullNameUserHtml,
    getFullNameUser: getFullNameUser,
    wineNaming: wineNaming,
    scrollTo: scrollTo,
    isSuperAdmin: isSuperAdmin,
    getPublicPaymentStateForAdmins: getPublicPaymentStateForAdmins,
    getUnitPriceCurrencyForItem: getUnitPriceCurrencyForItem,
    showShippingPriceMinusDefault: showShippingPriceMinusDefault
  },
  watch: {
    "order.status": function orderStatus(newVal, oldVal) {
      if (!this.orderStatusStopped.includes(this.order.status)) {
        this.order.resume_status = null;
      } else {
        if (this.order.lastStatus == _orderStatus.filter(function (os) {
          return os.id === "DELIVERY";
        })[0].status && !this.isDestinationGreatExport) {
          if (this.order.is_destination_inbound) {
            this.order.resume_status = _orderStatus.find(function (os) {
              return os.id == "INBOUND";
            }).status;
          } else {
            this.order.resume_status = this.order.lastStatus + 2;
          }
        } else {
          if (this.order.lastStatus == _orderStatus.filter(function (os) {
            return os.id === "CUSTOMS_CLEARANCE";
          })[0].status && this.order.is_destination_inbound) {
            this.order.resume_status = _orderStatus.find(function (os) {
              return os.id == "INBOUND";
            }).status;
          } else {
            this.order.resume_status = this.order.lastStatus + 1;
          }
        }
      }
    }
  }
};